//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IClient {
    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param status (optional) 
     * @param locationId (optional) 
     * @param productId (optional) 
     * @param own (optional) 
     * @param copied (optional) 
     * @param forCommunity (optional) 
     * @param fromEdi (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param lastModifiedAtFrom (optional) 
     * @param lastModifiedAtTo (optional) 
     * @param search (optional) 
     * @param orderBy (optional) 
     * @param orderByDesc (optional) 
     * @return Payload of ValuesDto containing CombinedSampleResponse
     */
    listCombinedSamples(page?: number | undefined, pageSize?: number | undefined, status?: string | undefined, locationId?: number | undefined, productId?: number | undefined, own?: boolean | undefined, copied?: boolean | undefined, forCommunity?: boolean | undefined, fromEdi?: boolean | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, lastModifiedAtFrom?: Date | undefined, lastModifiedAtTo?: Date | undefined, search?: string | undefined, orderBy?: string | undefined, orderByDesc?: string | undefined): Promise<ValuesDto_combinedSampleResponse>;
    /**
     * @return Payload of Object
     */
    readConfig(): Promise<any>;
    /**
     * @return Payload of ValuesDto containing ControlMeasureGroupResponse
     */
    listControlMeasureGroups(): Promise<ValuesDto_controlMeasureGroupResponse>;
    /**
     * @return Payload of ControlMeasureGroupResponse
     */
    createControlMeasureGroup(body: CreateControlMeasureGroupRequest): Promise<ControlMeasureGroupResponse>;
    /**
     * @param id (optional) The id of the ControlMeasureGroup
     * @return Payload of ControlMeasureGroupResponse
     */
    readControlMeasureGroup(id?: number | undefined): Promise<ControlMeasureGroupResponse>;
    /**
     * @param id (optional) The id of the Unit
     * @return Payload of ControlMeasureGroupResponse
     */
    updateControlMeasureGroup(body: UpdateControlMeasureGroupRequest, id?: number | undefined): Promise<ControlMeasureGroupResponse>;
    /**
     * @param id (optional) The id of the ControlMeasureGroup
     */
    deleteControlMeasureGroup(id?: number | undefined): Promise<void>;
    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Payload of ValuesDto containing ControlMeasureResponse
     */
    listControlMeasures(page?: number | undefined, pageSize?: number | undefined, search?: string | undefined): Promise<ValuesDto_controlMeasureResponse>;
    /**
     * @return Payload of ControlMeasureResponse
     */
    createControlMeasure(body: CreateControlMeasureRequest): Promise<ControlMeasureResponse>;
    /**
     * @return CSV format
     */
    listControlMeasuresCsv(language: string): Promise<ContentResult>;
    /**
     * @param id (optional) The id of the ControlMeasure
     * @return Payload of ControlMeasureResponse
     */
    readControlMeasure(id?: number | undefined): Promise<ControlMeasureResponse>;
    /**
     * @param id (optional) The id of the Unit
     * @return Payload of ControlMeasureResponse
     */
    updateControlMeasure(body: UpdateControlMeasureRequest, id?: number | undefined): Promise<ControlMeasureResponse>;
    /**
     * @param id (optional) The id of the ControlMeasure
     */
    deleteControlMeasure(id?: number | undefined): Promise<void>;
    /**
     * @param language (optional) 
     * @return CSV format
     */
    listCountriesCsv(language?: string | undefined): Promise<ContentResult>;
    /**
     * @return Payload of ValuesDto containing CountryResponse
     */
    listCountries(): Promise<ValuesDto_countryResponse>;
    /**
     * @param id (optional) The id of the Country
     * @return Payload of CountryResponse
     */
    readCountry(id?: number | undefined): Promise<CountryResponse>;
    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing DocumentResponse
     */
    listDocuments(page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_documentResponse>;
    /**
     * @return Payload of DocumentResponse
     */
    createDocument(body: CreateDocumentRequest): Promise<DocumentResponse>;
    /**
     * @param id (optional) The id of the Document
     * @return Payload of DocumentResponse
     */
    readDocument(id?: string | undefined): Promise<DocumentResponse>;
    readDocumentsFile(file?: string | undefined): Promise<void>;
    readIncomingSamplesFile(file?: string | undefined): Promise<void>;
    /**
     * @param search (optional) 
     * @param dateReceivedFrom (optional) 
     * @param dateReceivedTo (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing EdiIncomingSampleEmailResponse
     */
    listEdiIncomingSampleEmails(search?: string | undefined, dateReceivedFrom?: Date | undefined, dateReceivedTo?: Date | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_ediIncomingSampleEmailResponse>;
    /**
     * @return Payload of ValuesDto containing EdiIncomingSampleEmailResponse
     */
    listEdiIncomingSampleEmail(id: string): Promise<ValuesDto_ediIncomingSampleEmailResponse>;
    /**
     * @return Payload of Array of Object
     */
    readHazardDefaults(): Promise<any[]>;
    /**
     * @return Payload of HazardsControlMeasureResponse
     */
    createHazardsControlMeasure(body: CreateHazardsControlMeasureRequest): Promise<HazardsControlMeasureResponse>;
    /**
     * @param id (optional) The id of the HazardsControlMeasure
     */
    deleteHazardsControlMeasure(id?: number | undefined): Promise<void>;
    /**
     * @param hazardId (optional) 
     * @param language (optional) 
     * @param path (optional) 
     * @return Payload of HazardsFactsheetFileReferenceResponse
     */
    createHazardsFactsheetFileReference(hazardId?: number | undefined, language?: string | undefined, path?: string | undefined): Promise<HazardsFactsheetFileReferenceResponse>;
    /**
     * @param hazardId (optional) The hazardId of the Hazard
     * @param id (optional) The id of the HazardsFactsheetFileReference
     * @return Payload of HazardsFactsheetFileReferenceResponse
     */
    updateHazardsFactsheetFileReference(body: UpdateHazardsFactsheetFileReferenceRequest, hazardId?: number | undefined, id?: number | undefined): Promise<HazardsFactsheetFileReferenceResponse>;
    /**
     * @param hazardId (optional) The hazardId of the Hazard
     * @param id (optional) The id of the HazardsFactsheetFileReference
     */
    deleteHazardsFactsheetFileReference(hazardId?: number | undefined, id?: number | undefined): Promise<void>;
    /**
     * @param language (optional) 
     * @return CSV format
     */
    listHazardsCsv(language?: string | undefined): Promise<ContentResult>;
    /**
     * @param search (optional) 
     * @param category (optional) 
     * @param severity (optional) 
     * @param parentHazardIds (optional) 
     * @param factsheetIncluded (optional) 
     * @param isActiveForRiskAssessment (optional) 
     * @param isActiveMonitoring (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @param orderByDesc (optional) 
     * @return Payload of ValuesDto containing HazardResponse
     */
    listHazards(search?: string | undefined, category?: string | undefined, severity?: string | undefined, parentHazardIds?: string | undefined, factsheetIncluded?: boolean | undefined, isActiveForRiskAssessment?: boolean | undefined, isActiveMonitoring?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined, orderByDesc?: string | undefined): Promise<ValuesDto_hazardResponse>;
    /**
     * @return Payload of HazardResponse
     */
    createHazard(body: CreateHazardRequest): Promise<HazardResponse>;
    /**
     * @param isActiveForRiskAssessment (optional) 
     * @param isActiveMonitoring (optional) 
     * @param search (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing HazardAutocompleteResponse
     */
    listHazardsAutocomplete(isActiveForRiskAssessment?: boolean | undefined, isActiveMonitoring?: boolean | undefined, search?: string | undefined, limit?: number | undefined): Promise<ValuesDto_hazardAutocompleteResponse>;
    /**
     * @param id (optional) The id of the Hazard
     * @return Payload of HazardResponse
     */
    readHazard(id?: number | undefined): Promise<HazardResponse>;
    /**
     * @param id (optional) The id of the Hazard
     * @return Payload of HazardResponse
     */
    updateHazard(body: UpdateHazardRequest, id?: number | undefined): Promise<HazardResponse>;
    /**
     * @param id (optional) The id of the Hazard
     */
    deleteHazard(id?: number | undefined): Promise<void>;
    /**
     * @return Payload of HazardsLimitResponse
     */
    createHazardsLimit(body: CreateHazardRequest): Promise<HazardsLimitResponse>;
    /**
     * @param id (optional) The id of the HazardsLimit
     * @return Payload of HazardsLimitResponse
     */
    updateHazardsLimit(body: UpdateHazardsLimitRequest, id?: number | undefined): Promise<HazardsLimitResponse>;
    /**
     * @param id (optional) The id of the HazardsLimit
     */
    deleteHazardsLimit(id?: number | undefined): Promise<void>;
    /**
     * @param hazardId (optional) 
     * @param language (optional) 
     * @param path (optional) 
     * @return Payload of HazardsStandardDocumentFileReferenceResponse
     */
    createHazardsStandardDocumentFileReference(hazardId?: number | undefined, language?: string | undefined, path?: string | undefined): Promise<HazardsStandardDocumentFileReferenceResponse>;
    /**
     * @param hazardId (optional) The hazardId of the Hazard
     * @param id (optional) The id of the HazardsStandardDocumentFileReference
     * @return Payload of HazardsStandardDocumentFileReferenceResponse
     */
    updateHazardsStandardDocumentFileReference(body: UpdateHazardsStandardDocumentFileReferenceRequest, hazardId?: number | undefined, id?: number | undefined): Promise<HazardsStandardDocumentFileReferenceResponse>;
    /**
     * @param hazardId (optional) The hazardId of the Hazard
     * @param id (optional) The id of the HazardsStandardDocumentFileReference
     */
    deleteHazardsStandardDocumentFileReference(hazardId?: number | undefined, id?: number | undefined): Promise<void>;
    /**
     * @param search (optional) 
     * @param laboratory (optional) 
     * @param producer (optional) 
     * @param supplier (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing LocationAutocompleteResponse
     */
    listLocationsAutocomplete(search?: string | undefined, laboratory?: boolean | undefined, producer?: boolean | undefined, supplier?: boolean | undefined, limit?: number | undefined): Promise<ValuesDto_locationAutocompleteResponse>;
    /**
     * @param id (optional) The id of the Location
     * @return Payload of LocationResponse
     */
    readLocation(id?: number | undefined): Promise<LocationResponse>;
    /**
     * @param id (optional) The id of the Location
     * @return Payload of LocationResponse
     */
    updateLocation(body: UpdateLocationRequest, id?: number | undefined): Promise<LocationResponse>;
    /**
     * @param id (optional) The id of the Location
     */
    deleteLocation(id?: number | undefined): Promise<void>;
    /**
     * @return Payload of LocationResponse
     */
    createLocation(body: CreateLocationRequest): Promise<LocationResponse>;
    /**
     * @param language (optional) 
     * @return CSV format
     */
    listMethodsCsv(language?: string | undefined): Promise<ContentResult>;
    /**
     * @return Payload of ValuesDto containing MethodResponse
     */
    listMethods(): Promise<ValuesDto_methodResponse>;
    /**
     * @return Payload of MethodResponse
     */
    createMethod(body: CreateMethodRequest): Promise<MethodResponse>;
    /**
     * @param id (optional) The id of the Method
     * @return Payload of MethodResponse
     */
    readMethod(id?: number | undefined): Promise<MethodResponse>;
    /**
     * @param id (optional) The id of the Unit
     * @return Payload of MethodResponse
     */
    updateMethod(body: UpdateMethodRequest, id?: number | undefined): Promise<MethodResponse>;
    /**
     * @param id (optional) The id of the Method
     */
    deleteMethod(id?: number | undefined): Promise<void>;
    /**
     * @param search (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing MonitoringGroupAutocompleteResponse
     */
    listMonitoringGroupsAutocomplete(search?: string | undefined, limit?: number | undefined): Promise<ValuesDto_monitoringGroupAutocompleteResponse>;
    /**
     * @return Payload of ValuesDto containing MonitoringGroupResponse
     */
    listMonitoringGroups(): Promise<ValuesDto_monitoringGroupResponse>;
    /**
     * @return Payload of MonitoringGroupResponse
     */
    createMonitoringGroup(body: CreateMonitoringGroupRequest): Promise<MonitoringGroupResponse>;
    /**
     * @param id (optional) The id of the MonitoringGroup
     * @return Payload of MonitoringGroupResponse
     */
    readMonitoringGroup(id?: number | undefined): Promise<MonitoringGroupResponse>;
    /**
     * @param id (optional) The id of the Unit
     * @return Payload of MonitoringGroupResponse
     */
    updateMonitoringGroup(body: UpdateMonitoringGroupRequest, id?: number | undefined): Promise<MonitoringGroupResponse>;
    /**
     * @param id (optional) The id of the MonitoringGroup
     */
    deleteMonitoringGroup(id?: number | undefined): Promise<void>;
    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing PlannedSampleResponse
     */
    listPlannedSamples(page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_plannedSampleResponse>;
    /**
     * @return Payload of PlannedSampleResponse
     */
    createPlannedSample(body: CreatePlannedSampleRequest): Promise<PlannedSampleResponse>;
    /**
     * @param id (optional) The id of the PlannedSample
     * @return Payload of PlannedSampleResponse
     */
    readPlannedSample(id?: string | undefined): Promise<PlannedSampleResponse>;
    /**
     * @param id (optional) The id of the Unit
     * @return Payload of PlannedSampleResponse
     */
    updatePlannedSample(body: UpdatePlannedSampleRequest, id?: string | undefined): Promise<PlannedSampleResponse>;
    /**
     * @param id (optional) The id of the PlannedSample
     */
    deletePlannedSample(id?: string | undefined): Promise<void>;
    /**
     * @param monitoringGroupId (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing LocationsMonitoringGroupForGroupManagerResponse
     */
    listPortalGroupManagerLocationsMonitoringGroups(monitoringGroupId?: number | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_locationsMonitoringGroupForGroupManagerResponse>;
    /**
     * @return Payload of LocationsMonitoringGroupResponse
     */
    createPortalLocationsMonitoringGroup(body: CreateLocationsMonitoringGroupRequest): Promise<LocationsMonitoringGroupResponse>;
    /**
     * @param id (optional) The id of the Unit
     * @return Payload of LocationsMonitoringGroupResponse
     */
    updateLocationsMonitoringGroupAsManager(body: UpdateLocationsMonitoringGroupAsManagerRequest, id?: number | undefined): Promise<LocationsMonitoringGroupResponse>;
    /**
     * @param search (optional) 
     * @param laboratory (optional) 
     * @param producer (optional) 
     * @param supplier (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing LocationAutocompleteResponse
     */
    listPortalLocationsAutocomplete(search?: string | undefined, laboratory?: boolean | undefined, producer?: boolean | undefined, supplier?: boolean | undefined, limit?: number | undefined): Promise<ValuesDto_locationAutocompleteResponse>;
    /**
     * @param search (optional) 
     * @param laboratory (optional) 
     * @param producer (optional) 
     * @param supplier (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing LocationAutocompleteResponse
     */
    listPortalLocationsOwnAutocomplete(search?: string | undefined, laboratory?: boolean | undefined, producer?: boolean | undefined, supplier?: boolean | undefined, limit?: number | undefined): Promise<ValuesDto_locationAutocompleteResponse>;
    /**
     * @param laboratory (optional) 
     * @param producer (optional) 
     * @param supplier (optional) 
     * @return CSV format
     */
    listPortalLocationsCsv(language: string, laboratory?: boolean | undefined, producer?: boolean | undefined, supplier?: boolean | undefined): Promise<ContentResult>;
    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param laboratory (optional) 
     * @param producer (optional) 
     * @param supplier (optional) 
     * @param excludeByMonitoringGroupIds (optional) 
     * @param search (optional) 
     * @param orderBy (optional) 
     * @param orderByDesc (optional) 
     * @return Payload of ValuesDto containing LocationResponse
     */
    listPortalLocations(page?: number | undefined, pageSize?: number | undefined, laboratory?: boolean | undefined, producer?: boolean | undefined, supplier?: boolean | undefined, excludeByMonitoringGroupIds?: string | undefined, search?: string | undefined, orderBy?: string | undefined, orderByDesc?: string | undefined): Promise<ValuesDto_locationResponse>;
    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing LocationResponse
     */
    listPortalSampleCopiedToLocations(sampleId: string, page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_locationResponse>;
    /**
     * @param search (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing LocationAutocompleteResponse
     */
    listPortalLocationsLaboratoriesAutocomplete(search?: string | undefined, limit?: number | undefined): Promise<ValuesDto_locationAutocompleteResponse>;
    /**
     * @return CSV format
     */
    listPortalLocationsLaboratoriesCsv(language: string): Promise<ContentResult>;
    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing LocationResponse
     */
    listPortalLocationsLaboratories(page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_locationResponse>;
    /**
     * @param id (optional) The id of the Location
     * @return Payload of LocationResponse
     */
    readPortalLocationsLaboratory(id?: number | undefined): Promise<LocationResponse>;
    /**
     * @param search (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing LocationAutocompleteResponse
     */
    listPortalLocationsProducersAutocomplete(search?: string | undefined, limit?: number | undefined): Promise<ValuesDto_locationAutocompleteResponse>;
    /**
     * @return CSV format
     */
    listPortalLocationsProducersCsv(language: string): Promise<ContentResult>;
    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing LocationResponse
     */
    listPortalLocationsProducers(page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_locationResponse>;
    /**
     * @param id (optional) The id of the Location
     * @return Payload of LocationResponse
     */
    readPortalLocationsProducer(id?: number | undefined): Promise<LocationResponse>;
    /**
     * @param search (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing LocationAutocompleteResponse
     */
    listPortalLocationsSuppliersAutocomplete(search?: string | undefined, limit?: number | undefined): Promise<ValuesDto_locationAutocompleteResponse>;
    /**
     * @return CSV format
     */
    listPortalLocationsSuppliersCsv(language: string): Promise<ContentResult>;
    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing LocationResponse
     */
    listPortalLocationsSuppliers(page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_locationResponse>;
    /**
     * @param id (optional) The id of the Location
     * @return Payload of LocationResponse
     */
    readPortalLocationsSupplier(id?: number | undefined): Promise<LocationResponse>;
    /**
     * @param sampleId (optional) The sampleId of the Sample
     * @return Payload of AnalysisReportResponse
     */
    createAnalysisReport(body: CreateAnalysisReportRequest, sampleId?: string | undefined): Promise<AnalysisReportResponse>;
    /**
     * @param sampleId (optional) The sampleId of the Sample
     * @param id (optional) The id of the AnalysisReport
     * @return Payload of AnalysisReportResponse
     */
    updateAnalysisReport(body: UpdateAnalysisReportRequest, sampleId?: string | undefined, id?: string | undefined): Promise<AnalysisReportResponse>;
    /**
     * @param sampleId (optional) The sampleId of the Sample
     * @param id (optional) The id of the AnalysisReport
     */
    deleteAnalysisReport(sampleId?: string | undefined, id?: string | undefined): Promise<void>;
    /**
     * @param sampleId (optional) The sampleId of the Sample
     * @param analysisReportId (optional) The analysisReportId of the AnalysisReport
     * @return Payload of AnalysisResultResponse
     */
    createAnalysisResult(body: CreateAnalysisResultRequest, sampleId?: string | undefined, analysisReportId?: string | undefined): Promise<AnalysisResultResponse>;
    /**
     * @param sampleId (optional) The sampleId of the Sample
     * @param analysisReportId (optional) The analysisReportId of the AnalysisReport
     * @param id (optional) The id of the AnalysisResult
     * @return Payload of AnalysisResultResponse
     */
    updateAnalysisResult(body: UpdateAnalysisResultRequest, sampleId?: string | undefined, analysisReportId?: string | undefined, id?: string | undefined): Promise<AnalysisResultResponse>;
    /**
     * @param sampleId (optional) The sampleId of the Sample
     * @param analysisReportId (optional) The analysisReportId of the AnalysisReport
     * @param id (optional) The id of the AnalysisResult
     */
    deleteAnalysisResult(sampleId?: string | undefined, analysisReportId?: string | undefined, id?: string | undefined): Promise<void>;
    /**
     * @param locationId (optional) 
     * @param search (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing AnalysisSetAutocompleteResponse
     */
    listPortalAnalysisSetsAutocomplete(locationId?: number | undefined, search?: string | undefined, limit?: number | undefined): Promise<ValuesDto_analysisSetAutocompleteResponse>;
    /**
     * @param locationId (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing AnalysisSetResponse
     */
    listPortalAnalysisSets(locationId?: number | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_analysisSetResponse>;
    /**
     * @return Payload of AnalysisSetResponse
     */
    createPortalAnalysisSet(body: CreateAnalysisSetRequest): Promise<AnalysisSetResponse>;
    /**
     * @param id (optional) The id of the AnalysisSet
     * @return Payload of AnalysisSetResponse
     */
    readPortalAnalysisSet(id?: number | undefined): Promise<AnalysisSetResponse>;
    /**
     * @param id (optional) The id of the Unit
     * @return Payload of AnalysisSetResponse
     */
    updatePortalAnalysisSet(body: UpdateAnalysisSetRequest, id?: number | undefined): Promise<AnalysisSetResponse>;
    /**
     * @param id (optional) The id of the AnalysisSet
     */
    deletePortalAnalysisSet(id?: number | undefined): Promise<void>;
    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param status (optional) 
     * @param sampleType (optional) 
     * @param locationId (optional) 
     * @param productId (optional) 
     * @param own (optional) 
     * @param copied (optional) 
     * @param forCommunity (optional) 
     * @param group (optional) 
     * @param fromEdi (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param lastModifiedAtFrom (optional) 
     * @param lastModifiedAtTo (optional) 
     * @param search (optional) 
     * @param orderBy (optional) 
     * @param orderByDesc (optional) 
     * @return Payload of ValuesDto containing CombinedSampleResponse
     */
    listPortalCombinedSamples(page?: number | undefined, pageSize?: number | undefined, status?: string | undefined, sampleType?: string | undefined, locationId?: number | undefined, productId?: number | undefined, own?: boolean | undefined, copied?: boolean | undefined, forCommunity?: boolean | undefined, group?: boolean | undefined, fromEdi?: boolean | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, lastModifiedAtFrom?: Date | undefined, lastModifiedAtTo?: Date | undefined, search?: string | undefined, orderBy?: string | undefined, orderByDesc?: string | undefined): Promise<ValuesDto_combinedSampleResponse>;
    /**
     * @param status (optional) 
     * @param sampleType (optional) 
     * @param locationId (optional) 
     * @param productId (optional) 
     * @param own (optional) 
     * @param copied (optional) 
     * @param forCommunity (optional) 
     * @param group (optional) 
     * @param fromEdi (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param lastModifiedAtFrom (optional) 
     * @param lastModifiedAtTo (optional) 
     * @param search (optional) 
     * @param orderBy (optional) 
     * @param orderByDesc (optional) 
     * @return CSV format
     */
    listPortalCombinedSamplesCsv(language: string, status?: string | undefined, sampleType?: string | undefined, locationId?: number | undefined, productId?: number | undefined, own?: boolean | undefined, copied?: boolean | undefined, forCommunity?: boolean | undefined, group?: boolean | undefined, fromEdi?: boolean | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, lastModifiedAtFrom?: Date | undefined, lastModifiedAtTo?: Date | undefined, search?: string | undefined, orderBy?: string | undefined, orderByDesc?: string | undefined): Promise<ContentResult>;
    /**
     * @param id (optional) The id of the CopiedSample
     * @return Payload of CopiedSampleResponse
     */
    readPortalCopiedSample(id?: string | undefined): Promise<CopiedSampleResponse>;
    /**
     * @param id (optional) The id of the Unit
     * @return Payload of CopiedSampleResponse
     */
    updatePortalCopiedSample(body: UpdateCopiedSampleRequest, id?: string | undefined): Promise<CopiedSampleResponse>;
    /**
     * @param id (optional) The id of the CopiedSample
     */
    deletePortalCopiedSample(id?: string | undefined): Promise<void>;
    /**
     * @return Payload of CopiedSampleResponse
     */
    createPortalCopiedSample(body: CreateCopiedSampleRequest): Promise<CopiedSampleResponse>;
    /**
     * @param id (optional) The id of the CopiedSample
     * @return Payload of CopiedSampleResponse
     */
    finalisePortalSample(id?: string | undefined): Promise<CopiedSampleResponse>;
    /**
     * @return Payload of ValuesDto containing CountryResponse
     */
    listPortalCountries(): Promise<ValuesDto_countryResponse>;
    /**
     * @param search (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing CountryAutocompleteResponse
     */
    listPortalCountriesAutocomplete(search?: string | undefined, limit?: number | undefined): Promise<ValuesDto_countryAutocompleteResponse>;
    /**
     * @return CSV format
     */
    listPortalCountriesCsv(language: string): Promise<ContentResult>;
    /**
     * @param id (optional) The id of the Country
     * @return Payload of CountryResponse
     */
    readPortalCountry(id?: number | undefined): Promise<CountryResponse>;
    readPortalDocumentsFile(file?: string | undefined): Promise<void>;
    readPortalIncomingSamplesFile(file?: string | undefined): Promise<void>;
    /**
     * @param locationId (optional) 
     * @param monitoringGroupId (optional) 
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing LocationsMonitoringGroupResponse
     */
    listPortalLocationsMonitoringGroups(locationId?: number | undefined, monitoringGroupId?: number | undefined, search?: string | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_locationsMonitoringGroupResponse>;
    /**
     * @param id (optional) The id of the Unit
     * @return Payload of LocationsMonitoringGroupResponse
     */
    updateLocationsMonitoringGroup(body: UpdateStatusLocationsMonitoringGroupRequest, id?: number | undefined): Promise<LocationsMonitoringGroupResponse>;
    /**
     * @param id (optional) The id of the Unit
     * @return Payload of LocationsMonitoringGroupResponse
     */
    updateLocationsMonitoringGroup2(body: UpdateAutoInsertLocationsMonitoringGroupRequest, id?: number | undefined): Promise<LocationsMonitoringGroupResponse>;
    /**
     * @param locationId (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing MonitoringGroupResponse
     */
    listPortalMonitoringGroups(locationId?: number | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_monitoringGroupResponse>;
    /**
     * @param locationId (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing MyProductResponse
     */
    listPortalMyProducts(locationId?: number | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_myProductResponse>;
    /**
     * @return Payload of MyProductResponse
     */
    createPortalMyProduct(body: CreateMyProductRequest): Promise<MyProductResponse>;
    /**
     * @param id (optional) The id of the MyProduct
     * @return Payload of MyProductResponse
     */
    readPortalMyProduct(id?: number | undefined): Promise<MyProductResponse>;
    /**
     * @param id (optional) The id of the Unit
     * @return Payload of MyProductResponse
     */
    updatePortalMyProduct(body: UpdateMyProductRequest, id?: number | undefined): Promise<MyProductResponse>;
    /**
     * @param id (optional) The id of the MyProduct
     */
    deletePortalMyProduct(id?: number | undefined): Promise<void>;
    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing PlannedSampleResponse
     */
    listPortalPlannedSamples(page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_plannedSampleResponse>;
    /**
     * @return Payload of PlannedSampleResponse
     */
    createPortalPlannedSample(body: CreatePlannedSampleRequest): Promise<PlannedSampleResponse>;
    /**
     * @param id (optional) The id of the PlannedSample
     * @return Payload of PlannedSampleResponse
     */
    readPortalPlannedSample(id?: string | undefined): Promise<PlannedSampleResponse>;
    /**
     * @param id (optional) The id of the Unit
     * @return Payload of PlannedSampleResponse
     */
    updatePortalPlannedSample(body: UpdatePlannedSampleRequest, id?: string | undefined): Promise<PlannedSampleResponse>;
    /**
     * @param id (optional) The id of the PlannedSample
     */
    deletePortalPlannedSample(id?: string | undefined): Promise<void>;
    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @param factsheetIncluded (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing ProcessingAidAutocompleteResponse
     */
    listPortalProcessingAidsAutocomplete(page?: number | undefined, pageSize?: number | undefined, search?: string | undefined, factsheetIncluded?: boolean | undefined, limit?: number | undefined): Promise<ValuesDto_processingAidAutocompleteResponse>;
    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @param factsheetIncluded (optional) 
     * @return Payload of ValuesDto containing ProcessingAidResponse
     */
    listPortalProcessingAids(page?: number | undefined, pageSize?: number | undefined, search?: string | undefined, factsheetIncluded?: boolean | undefined): Promise<ValuesDto_processingAidResponse>;
    /**
     * @param id (optional) The id of the ProcessingAid
     * @return Payload of ProcessingAidResponse
     */
    readPortalProcessingAid(id?: number | undefined): Promise<ProcessingAidResponse>;
    /**
     * @param path (optional) 
     * @return Returns JSON response
     */
    readPortalProxyRequest(path?: string | undefined): Promise<any>;
    /**
     * @param language (optional) 
     * @return Returns JSON response
     */
    readPortalSchemaDocumentsStructured(language?: string | undefined): Promise<any>;
    /**
     * @param language (optional) 
     * @return Returns JSON response
     */
    readPortalSchemaDocuments(language?: string | undefined): Promise<any>;
    /**
     * @param id (optional) 
     * @return Returns JSON response
     */
    readPortalSchemaDocument(id?: string | undefined): Promise<any>;
    /**
     * @param id (optional) 
     * @param language (optional) 
     * @return Returns JSON response
     */
    readPortalSchemaDocumentVersionsDiff(id?: string | undefined, language?: string | undefined): Promise<any>;
    /**
     * @param sampleId (optional) 
     * @return Payload of ValuesDto containing MonitoringGroupResponse
     */
    listPortalSampleMonitoringGroups(sampleId?: string | undefined): Promise<ValuesDto_monitoringGroupResponse>;
    /**
     * @param search (optional) 
     * @param locationId (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing SampleAutocompleteResponse
     */
    listPortalSamplesAutocomplete(search?: string | undefined, locationId?: number | undefined, limit?: number | undefined): Promise<ValuesDto_sampleAutocompleteResponse>;
    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param registrationNumber (optional) 
     * @param own (optional) 
     * @param copied (optional) 
     * @param fromEdi (optional) 
     * @return Payload of ValuesDto containing SampleResponse
     */
    listPortalSamples(page?: number | undefined, pageSize?: number | undefined, registrationNumber?: string | undefined, own?: boolean | undefined, copied?: boolean | undefined, fromEdi?: boolean | undefined): Promise<ValuesDto_sampleResponse>;
    /**
     * @return Payload of SampleResponse
     */
    createPortalSample(body: CreateSampleRequest): Promise<SampleResponse>;
    /**
     * @param id (optional) The id of the Sample
     * @return Payload of SampleResponse
     */
    readPortalSample(id?: string | undefined): Promise<SampleResponse>;
    /**
     * @param id (optional) The id of the Unit
     * @return Payload of SampleResponse
     */
    updatePortalSample(body: UpdateSampleRequest, id?: string | undefined): Promise<SampleResponse>;
    /**
     * @param id (optional) The id of the Sample
     */
    deletePortalSample(id?: string | undefined): Promise<void>;
    /**
     * @param id (optional) The id of the Unit
     * @return Payload of SampleResponse
     */
    updateWithForCommunityPortalSample(body: UpdateSampleRequest, id?: string | undefined): Promise<SampleResponse>;
    /**
     * @param id (optional) The id of the Sample
     * @return Payload of SampleResponse
     */
    finalisePortalSample2(id?: string | undefined): Promise<SampleResponse>;
    /**
     * @return Payload of SampleResponse
     */
    batchFinalisePortalSamples(): Promise<SampleResponse>;
    /**
     * @param processingAidGroupId (optional) 
     * @param language (optional) 
     * @param path (optional) 
     * @return Payload of ProcessingAidGroupsFactsheetFileReferenceResponse
     */
    createProcessingAidGroupsFactsheetFileReference(processingAidGroupId?: number | undefined, language?: string | undefined, path?: string | undefined): Promise<ProcessingAidGroupsFactsheetFileReferenceResponse>;
    /**
     * @param processingAidGroupId (optional) The processingAidGroupId of the ProcessingAidGroup
     * @param id (optional) The id of the ProcessingAidGroupsFactsheetFileReference
     * @return Payload of ProcessingAidGroupsFactsheetFileReferenceResponse
     */
    updateProcessingAidGroupsFactsheetFileReference(body: UpdateProcessingAidGroupsFactsheetFileReferenceRequest, processingAidGroupId?: number | undefined, id?: number | undefined): Promise<ProcessingAidGroupsFactsheetFileReferenceResponse>;
    /**
     * @param processingAidGroupId (optional) The processingAidGroupId of the ProcessingAidGroup
     * @param id (optional) The id of the ProcessingAidGroupsFactsheetFileReference
     */
    deleteProcessingAidGroupsFactsheetFileReference(processingAidGroupId?: number | undefined, id?: number | undefined): Promise<void>;
    /**
     * @param search (optional) 
     * @param factsheetIncluded (optional) 
     * @return Payload of ValuesDto containing ProcessingAidGroupResponse
     */
    listProcessingAidGroups(search?: string | undefined, factsheetIncluded?: boolean | undefined): Promise<ValuesDto_processingAidGroupResponse>;
    /**
     * @return Payload of ProcessingAidGroupResponse
     */
    createProcessingAidGroup(body: CreateProcessingAidGroupRequest): Promise<ProcessingAidGroupResponse>;
    /**
     * @return CSV format
     */
    listProcessingAidGroupsCsv(language: string): Promise<ContentResult>;
    /**
     * @param id (optional) The id of the ProcessingAidGroup
     * @return Payload of ProcessingAidGroupResponse
     */
    readProcessingAidGroup(id?: number | undefined): Promise<ProcessingAidGroupResponse>;
    /**
     * @param id (optional) The id of the Unit
     * @return Payload of ProcessingAidGroupResponse
     */
    updateProcessingAidGroup(body: UpdateProcessingAidGroupRequest, id?: number | undefined): Promise<ProcessingAidGroupResponse>;
    /**
     * @param id (optional) The id of the ProcessingAidGroup
     */
    deleteProcessingAidGroup(id?: number | undefined): Promise<void>;
    /**
     * @param search (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing ProcessingAidAutocompleteResponse
     */
    listProcessingAidsAutocomplete(search?: string | undefined, limit?: number | undefined): Promise<ValuesDto_processingAidAutocompleteResponse>;
    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @param factsheetIncluded (optional) 
     * @return Payload of ValuesDto containing ProcessingAidResponse
     */
    listProcessingAids(page?: number | undefined, pageSize?: number | undefined, search?: string | undefined, factsheetIncluded?: boolean | undefined): Promise<ValuesDto_processingAidResponse>;
    /**
     * @return Payload of ProcessingAidResponse
     */
    createProcessingAid(body: CreateProcessingAidRequest): Promise<ProcessingAidResponse>;
    /**
     * @param language (optional) 
     * @return CSV format
     */
    listProcessingAidsCsv(language?: string | undefined): Promise<ContentResult>;
    /**
     * @param id (optional) The id of the ProcessingAid
     * @return Payload of ProcessingAidResponse
     */
    readProcessingAid(id?: number | undefined): Promise<ProcessingAidResponse>;
    /**
     * @param id (optional) The id of the Unit
     * @return Payload of ProcessingAidResponse
     */
    updateProcessingAid(body: UpdateProcessingAidRequest, id?: number | undefined): Promise<ProcessingAidResponse>;
    /**
     * @param id (optional) The id of the ProcessingAid
     */
    deleteProcessingAid(id?: number | undefined): Promise<void>;
    /**
     * @return Payload of ValuesDto containing ProcessStepGroupResponse
     */
    listProcessStepGroups(): Promise<ValuesDto_processStepGroupResponse>;
    /**
     * @return Payload of ProcessStepGroupResponse
     */
    createProcessStepGroup(body: CreateProcessStepGroupRequest): Promise<ProcessStepGroupResponse>;
    /**
     * @param id (optional) The id of the ProcessStepGroup
     * @return Payload of ProcessStepGroupResponse
     */
    readProcessStepGroup(id?: number | undefined): Promise<ProcessStepGroupResponse>;
    /**
     * @param id (optional) The id of the Unit
     * @return Payload of ProcessStepGroupResponse
     */
    updateProcessStepGroup(body: UpdateProcessStepGroupRequest, id?: number | undefined): Promise<ProcessStepGroupResponse>;
    /**
     * @param id (optional) The id of the ProcessStepGroup
     */
    deleteProcessStepGroup(id?: number | undefined): Promise<void>;
    /**
     * @return Payload of ValuesDto containing ProcessStepResponse
     */
    listProcessSteps(): Promise<ValuesDto_processStepResponse>;
    /**
     * @return Payload of ProcessStepResponse
     */
    createProcessStep(body: CreateProcessStepRequest): Promise<ProcessStepResponse>;
    /**
     * @return CSV format
     */
    listProcessStepsCsv(language: string): Promise<ContentResult>;
    /**
     * @param id (optional) The id of the ProcessStep
     * @return Payload of ProcessStepResponse
     */
    readProcessStep(id?: number | undefined): Promise<ProcessStepResponse>;
    /**
     * @param id (optional) The id of the Unit
     * @return Payload of ProcessStepResponse
     */
    updateProcessStep(body: UpdateProcessStepRequest, id?: number | undefined): Promise<ProcessStepResponse>;
    /**
     * @param id (optional) The id of the ProcessStep
     */
    deleteProcessStep(id?: number | undefined): Promise<void>;
    /**
     * @return Payload of RiskAssessmentResponse
     */
    listProcessStepRiskAssessments(): Promise<RiskAssessmentResponse>;
    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @param productGroupCode (optional) 
     * @param productGroupCategory (optional) 
     * @param isActiveMonitoring (optional) 
     * @param isExpired (optional) 
     * @param isActiveRiskAssessment (optional) 
     * @param isEuProduct (optional) 
     * @param isFavourite (optional) 
     * @return List of products
     */
    listProducts(page?: number | undefined, pageSize?: number | undefined, search?: string | undefined, productGroupCode?: string | undefined, productGroupCategory?: string | undefined, isActiveMonitoring?: boolean | undefined, isExpired?: boolean | undefined, isActiveRiskAssessment?: boolean | undefined, isEuProduct?: boolean | undefined, isFavourite?: boolean | undefined): Promise<ValuesDto_productResponse>;
    /**
     * @return Payload of ProductResponse
     */
    createProduct(body: CreateProductRequest): Promise<ProductResponse>;
    /**
     * @return CSV format
     */
    listPortalProductsCsv(language: string): Promise<ContentResult>;
    /**
     * @param id (optional) The id of the Product
     * @return Payload of ProductResponse
     */
    readProduct(id?: number | undefined): Promise<ProductResponse>;
    /**
     * @param id (optional) The id of the Unit
     * @return Payload of ProductResponse
     */
    updateProduct(body: UpdateProductRequest, id?: number | undefined): Promise<ProductResponse>;
    /**
     * @param id (optional) The id of the Product
     */
    deleteProduct(id?: number | undefined): Promise<void>;
    /**
     * @return Payload of Array of Object
     */
    readProductGroupDefaults(): Promise<any[]>;
    /**
     * @return Payload of ValuesDto containing ProductGroupResponse
     */
    listProductGroups(): Promise<ValuesDto_productGroupResponse>;
    /**
     * @return Payload of ProductGroupResponse
     */
    createProductGroup(body: CreateProductGroupRequest): Promise<ProductGroupResponse>;
    /**
     * @param id (optional) The id of the ProductGroup
     * @return Payload of ProductGroupResponse
     */
    readProductGroup(id?: number | undefined): Promise<ProductGroupResponse>;
    /**
     * @param id (optional) The id of the Unit
     * @return Payload of ProductGroupResponse
     */
    updateProductGroup(body: UpdateProductGroupRequest, id?: number | undefined): Promise<ProductGroupResponse>;
    /**
     * @param id (optional) The id of the ProductGroup
     */
    deleteProductGroup(id?: number | undefined): Promise<void>;
    /**
     * @param language (optional) 
     * @return CSV format
     */
    listRiskAssessmentsCsv(language?: string | undefined): Promise<ContentResult>;
    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @param status (optional) 
     * @param publicationDateFrom (optional) 
     * @param publicationDateTo (optional) 
     * @param lastModifiedAtFrom (optional) 
     * @param lastModifiedAtTo (optional) 
     * @param hazardIds (optional) 
     * @param processingAidIds (optional) 
     * @param orderBy (optional) 
     * @param orderByDesc (optional) 
     * @return Payload of ValuesDto containing RiskAssessmentResponse
     */
    listRiskAssessments(page?: number | undefined, pageSize?: number | undefined, search?: string | undefined, status?: string | undefined, publicationDateFrom?: Date | undefined, publicationDateTo?: Date | undefined, lastModifiedAtFrom?: Date | undefined, lastModifiedAtTo?: Date | undefined, hazardIds?: string | undefined, processingAidIds?: string | undefined, orderBy?: string | undefined, orderByDesc?: string | undefined): Promise<ValuesDto_riskAssessmentResponse>;
    /**
     * @return Payload of RiskAssessmentResponse
     */
    createRiskAssessment(body: CreateRiskAssessmentRequest): Promise<RiskAssessmentResponse>;
    /**
     * @param id (optional) The id of the RiskAssessment
     * @return Payload of RiskAssessmentResponse
     */
    readRiskAssessment(id?: number | undefined): Promise<RiskAssessmentResponse>;
    /**
     * @param id (optional) The id of the RiskAssessment
     * @return Payload of RiskAssessmentResponse
     */
    updateRiskAssessment(body: UpdateRiskAssessmentRequest, id?: number | undefined): Promise<RiskAssessmentResponse>;
    /**
     * @param id (optional) The id of the RiskAssessment
     */
    deleteRiskAssessment(id?: number | undefined): Promise<void>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @return Payload of RiskAssessmentsProcessingAidResponse
     */
    createRiskAssessmentsProcessingAid(body: CreateRiskAssessmentsProcessingAidRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined): Promise<RiskAssessmentsProcessingAidResponse>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param id (optional) The id of the RiskAssessmentsProcessingAid
     * @return Payload of RiskAssessmentsProcessingAidResponse
     */
    updateRiskAssessmentsProcessingAid(body: UpdateRiskAssessmentsProcessingAidRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined, id?: number | undefined): Promise<RiskAssessmentsProcessingAidResponse>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param id (optional) The id of the RiskAssessmentsProcessingAid
     */
    deleteRiskAssessmentsProcessingAid(riskAssessmentId?: number | undefined, versionId?: number | undefined, id?: number | undefined): Promise<void>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @return Payload of RiskAssessmentsProcessStepResponse
     */
    createRiskAssessmentsProcessStep(body: CreateRiskAssessmentsProcessStepRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined): Promise<RiskAssessmentsProcessStepResponse>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param id (optional) The id of the RiskAssessmentsProcessStep
     * @return Payload of RiskAssessmentsProcessStepResponse
     */
    updateRiskAssessmentsProcessStep(body: UpdateRiskAssessmentsProcessStepRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined, id?: number | undefined): Promise<RiskAssessmentsProcessStepResponse>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param id (optional) The id of the RiskAssessmentsProcessStep
     */
    deleteRiskAssessmentsProcessStep(riskAssessmentId?: number | undefined, versionId?: number | undefined, id?: number | undefined): Promise<void>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param processStepId (optional) The processStepId of the RiskAssessmentsProcessStep
     * @param hazardId (optional) The hazardId of the RiskAssessmentsProcessStepsHazard
     * @return Payload of RiskAssessmentsProcessStepsHazardsControlMeasureResponse
     */
    createRiskAssessmentsProcessStepsHazardsControlMeasure(body: CreateRiskAssessmentsProcessStepsHazardsControlMeasureRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined, processStepId?: number | undefined, hazardId?: number | undefined): Promise<RiskAssessmentsProcessStepsHazardsControlMeasureResponse>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param processStepId (optional) The processStepId of the RiskAssessmentsProcessStep
     * @param hazardId (optional) The hazardId of the RiskAssessmentsProcessStepsHazard
     * @param id (optional) The id of the RiskAssessmentsProcessStepsHazardsControlMeasure
     * @return Payload of RiskAssessmentsProcessStepsHazardsControlMeasureResponse
     */
    updateRiskAssessmentsProcessStepsHazardsControlMeasure(body: UpdateRiskAssessmentsProcessStepsHazardsControlMeasureRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined, processStepId?: number | undefined, hazardId?: number | undefined, id?: number | undefined): Promise<RiskAssessmentsProcessStepsHazardsControlMeasureResponse>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param processStepId (optional) The processStepId of the RiskAssessmentsProcessStep
     * @param hazardId (optional) The hazardId of the RiskAssessmentsProcessStepsHazard
     * @param id (optional) The id of the RiskAssessmentsProcessStepsHazardsControlMeasure
     */
    deleteRiskAssessmentsProcessStepsHazardsControlMeasure(riskAssessmentId?: number | undefined, versionId?: number | undefined, processStepId?: number | undefined, hazardId?: number | undefined, id?: number | undefined): Promise<void>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param processStepId (optional) The processStepId of the RiskAssessmentsProcessStep
     * @return Payload of RiskAssessmentsProcessStepsHazardResponse
     */
    createRiskAssessmentsProcessStepsHazard(body: CreateRiskAssessmentsProcessStepsHazardRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined, processStepId?: number | undefined): Promise<RiskAssessmentsProcessStepsHazardResponse>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param processStepId (optional) The processStepId of the RiskAssessmentsProcessStep
     * @param id (optional) The id of the RiskAssessmentsProcessStepsHazard
     * @return Payload of RiskAssessmentsProcessStepsHazardResponse
     */
    updateRiskAssessmentsProcessStepsHazard(body: UpdateRiskAssessmentsProcessStepsHazardRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined, processStepId?: number | undefined, id?: number | undefined): Promise<RiskAssessmentsProcessStepsHazardResponse>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param processStepId (optional) The processStepId of the RiskAssessmentsProcessStep
     * @param id (optional) The id of the RiskAssessmentsProcessStepsHazard
     */
    deleteRiskAssessmentsProcessStepsHazard(riskAssessmentId?: number | undefined, versionId?: number | undefined, processStepId?: number | undefined, id?: number | undefined): Promise<void>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param processStepId (optional) The processStepId of the RiskAssessmentsProcessStep
     * @return Payload of RiskAssessmentsProcessStepsProductResponse
     */
    createRiskAssessmentsProcessStepsProduct(body: CreateRiskAssessmentsProcessStepsProductRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined, processStepId?: number | undefined): Promise<RiskAssessmentsProcessStepsProductResponse>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param processStepId (optional) The processStepId of the RiskAssessmentsProcessStep
     * @param id (optional) The id of the RiskAssessmentsProcessStepsProduct
     * @return Payload of RiskAssessmentsProcessStepsProductResponse
     */
    updateRiskAssessmentsProcessStepsProduct(body: UpdateRiskAssessmentsProcessStepsProductRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined, processStepId?: number | undefined, id?: number | undefined): Promise<RiskAssessmentsProcessStepsProductResponse>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param processStepId (optional) The processStepId of the RiskAssessmentsProcessStep
     * @param id (optional) The id of the RiskAssessmentsProcessStepsProduct
     */
    deleteRiskAssessmentsProcessStepsProduct(riskAssessmentId?: number | undefined, versionId?: number | undefined, processStepId?: number | undefined, id?: number | undefined): Promise<void>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @return Payload of RiskAssessmentsProductResponse
     */
    createRiskAssessmentsProduct(body: CreateRiskAssessmentsProductRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined): Promise<RiskAssessmentsProductResponse>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param id (optional) The id of the RiskAssessmentsProduct
     * @return Payload of RiskAssessmentsProductResponse
     */
    updateRiskAssessmentsProduct(body: UpdateRiskAssessmentsProductRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined, id?: number | undefined): Promise<RiskAssessmentsProductResponse>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param id (optional) The id of the RiskAssessmentsProduct
     */
    deleteRiskAssessmentsProduct(riskAssessmentId?: number | undefined, versionId?: number | undefined, id?: number | undefined): Promise<void>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param riskAssessmentVersionId (optional) 
     * @param language (optional) 
     * @param name (optional) 
     * @param position (optional) 
     * @param path (optional) 
     * @param flowChartVersionDate (optional) 
     * @return Payload of RiskAssessmentVersionFlowChartFileReferenceResponse
     */
    createRiskAssessmentVersionFlowChartFileReference(riskAssessmentId?: number | undefined, versionId?: number | undefined, riskAssessmentVersionId?: number | undefined, language?: string | undefined, name?: string | undefined, position?: number | null | undefined, path?: string | undefined, flowChartVersionDate?: Date | null | undefined): Promise<RiskAssessmentVersionFlowChartFileReferenceResponse>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param id (optional) The id of the RiskAssessmentVersionFlowChartFileReference
     * @return Payload of RiskAssessmentVersionFlowChartFileReferenceResponse
     */
    updateRiskAssessmentVersionFlowChartFileReference(body: UpdateRiskAssessmentVersionFlowChartFileReferenceRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined, id?: number | undefined): Promise<RiskAssessmentVersionFlowChartFileReferenceResponse>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param id (optional) The id of the RiskAssessmentVersionFlowChartFileReference
     */
    deleteRiskAssessmentVersionFlowChartFileReference(riskAssessmentId?: number | undefined, versionId?: number | undefined, id?: number | undefined): Promise<void>;
    /**
     * @param status (optional) 
     * @return Payload of ValuesDto containing RiskAssessmentVersionResponse
     */
    listRiskAssessmentVersions(status?: string | undefined): Promise<ValuesDto_riskAssessmentVersionResponse>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @return Payload of RiskAssessmentVersionResponse
     */
    createRiskAssessmentVersion(body: CreateRiskAssessmentVersionRequest, riskAssessmentId?: number | undefined): Promise<RiskAssessmentVersionResponse>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param id (optional) The id of the RiskAssessmentVersion
     * @return Payload of RiskAssessmentVersionResponse
     */
    updateRiskAssessmentVersion(body: UpdateRiskAssessmentVersionRequest, riskAssessmentId?: number | undefined, id?: number | undefined): Promise<RiskAssessmentVersionResponse>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param id (optional) The id of the RiskAssessmentVersion
     */
    deleteRiskAssessmentVersion(riskAssessmentId?: number | undefined, id?: number | undefined): Promise<void>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param id (optional) The id of the RiskAssessmentVersion
     * @return Payload of RiskAssessmentVersionResponse
     */
    forkRiskAssessmentVersion(riskAssessmentId?: number | undefined, id?: number | undefined): Promise<RiskAssessmentVersionResponse>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param id (optional) The id of the RiskAssessmentVersion
     * @return Payload of RiskAssessmentVersionResponse
     */
    finaliseRiskAssessmentVersion(riskAssessmentId?: number | undefined, id?: number | undefined): Promise<RiskAssessmentVersionResponse>;
    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param id (optional) The id of the RiskAssessmentVersion
     * @return Payload of RiskAssessmentVersionResponse
     */
    revokeRiskAssessmentVersion(riskAssessmentId?: number | undefined, id?: number | undefined): Promise<RiskAssessmentVersionResponse>;
    /**
     * @return Payload of Object
     */
    readSampleDefaults(): Promise<any>;
    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param registrationNumber (optional) 
     * @param own (optional) 
     * @param copied (optional) 
     * @param fromEdi (optional) 
     * @return Payload of ValuesDto containing SampleResponse
     */
    listSamples(page?: number | undefined, pageSize?: number | undefined, registrationNumber?: string | undefined, own?: boolean | undefined, copied?: boolean | undefined, fromEdi?: boolean | undefined): Promise<ValuesDto_sampleResponse>;
    /**
     * @return Payload of SampleResponse
     */
    createSample(body: CreateSampleRequest): Promise<SampleResponse>;
    /**
     * @param id (optional) The id of the Sample
     * @return Payload of SampleResponse
     */
    readSample(id?: string | undefined): Promise<SampleResponse>;
    /**
     * @param id (optional) The id of the Unit
     * @return Payload of SampleResponse
     */
    updateSample(body: UpdateSampleRequest, id?: string | undefined): Promise<SampleResponse>;
    /**
     * @param id (optional) The id of the Sample
     */
    deleteSample(id?: string | undefined): Promise<void>;
    /**
     * @param id (optional) The id of the Unit
     * @return Payload of SampleResponse
     */
    revertSample(body: RevertSampleRequest, id?: string | undefined): Promise<SampleResponse>;
    /**
     * @return Payload of ValuesDto containing UnitResponse
     */
    listUnits(): Promise<ValuesDto_unitResponse>;
    /**
     * @return Payload of UnitResponse
     */
    createUnit(body: CreateUnitRequest): Promise<UnitResponse>;
    /**
     * @param id (optional) The id of the Unit
     * @return Payload of UnitResponse
     */
    readUnit(id?: number | undefined): Promise<UnitResponse>;
    /**
     * @param id (optional) The id of the Unit
     * @return Payload of UnitResponse
     */
    updateUnit(body: UpdateUnitRequest, id?: number | undefined): Promise<UnitResponse>;
    /**
     * @param id (optional) The id of the Unit
     */
    deleteUnit(id?: number | undefined): Promise<void>;
    /**
     * @return Payload of CurrentUserDto
     */
    readCurrentUser(): Promise<CurrentUserDto>;
    /**
     * @param laboratory (optional) 
     * @param producer (optional) 
     * @param supplier (optional) 
     * @param limit (optional) 
     * @return Payload of LocationForCurrentUserResponse
     */
    listCurrentUserLocations(laboratory?: boolean | undefined, producer?: boolean | undefined, supplier?: boolean | undefined, limit?: number | undefined): Promise<LocationForCurrentUserResponse>;
    /**
     * @param limit (optional) 
     * @return Payload of MonitoringGroupForCurrentUserResponse
     */
    listCurrentUserMonitoringGroups(limit?: number | undefined): Promise<MonitoringGroupForCurrentUserResponse>;
    /**
     * @param body (optional) 
     * @return Payload of CurrentUserRolesDto
     */
    readUserRoles(body?: UpdateOrCreateUserRolesRequest | undefined): Promise<CurrentUserRolesDto>;
    /**
     * @param countryId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param own (optional) 
     * @param forCommunity (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing ReportCombinedSampleAnalysisResultResponse
     */
    listReportsSamplesAnalysisResultsReport(hazardId: number, productId: number, countryId?: number | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, own?: boolean | undefined, forCommunity?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_reportCombinedSampleAnalysisResultResponse>;
    /**
     * @param language (optional) 
     * @param countryId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param own (optional) 
     * @param forCommunity (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing ReportCombinedSampleAnalysisResultResponse
     */
    listReportsSamplesAnalysisResultsReportCsv(hazardId: number, productId: number, language?: string | undefined, countryId?: number | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, own?: boolean | undefined, forCommunity?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_reportCombinedSampleAnalysisResultResponse>;
    /**
     * @param countryId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param own (optional) 
     * @param forCommunity (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing CombinedSamplesBenchmarkReportResponse
     */
    listReportsSamplesBenchmarkReport(hazardId: number, productId: number, countryId?: number | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, own?: boolean | undefined, forCommunity?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_combinedSamplesBenchmarkReportResponse>;
    /**
     * @param language (optional) 
     * @param countryId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param own (optional) 
     * @param forCommunity (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing CombinedSamplesBenchmarkReportResponse
     */
    listReportsSamplesBenchmarkReportCsv(hazardId: number, productId: number, language?: string | undefined, countryId?: number | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, own?: boolean | undefined, forCommunity?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_combinedSamplesBenchmarkReportResponse>;
    /**
     * @param countryId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param own (optional) 
     * @param forCommunity (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing CombinedSamplesGroupedByCountryReportResponse
     */
    listReportsSamplesGroupedByCountryReport(hazardId: number, productId: number, countryId?: number | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, own?: boolean | undefined, forCommunity?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_combinedSamplesGroupedByCountryReportResponse>;
    /**
     * @param language (optional) 
     * @param countryId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param own (optional) 
     * @param forCommunity (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing CombinedSamplesGroupedByCountryReportResponse
     */
    listReportsSamplesGroupedByCountryReportCsv(hazardId: number, productId: number, language?: string | undefined, countryId?: number | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, own?: boolean | undefined, forCommunity?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_combinedSamplesGroupedByCountryReportResponse>;
    /**
     * @param countryId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param own (optional) 
     * @param forCommunity (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing CombinedSamplesHazardsReportResponse
     */
    listReportsSamplesHazardsReport(productId: number, countryId?: number | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, own?: boolean | undefined, forCommunity?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_combinedSamplesHazardsReportResponse>;
    /**
     * @param language (optional) 
     * @param countryId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param own (optional) 
     * @param forCommunity (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing CombinedSamplesHazardsReportResponse
     */
    listReportsSamplesHazardsReportCsv(productId: number, language?: string | undefined, countryId?: number | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, own?: boolean | undefined, forCommunity?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_combinedSamplesHazardsReportResponse>;
    /**
     * @param countryId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param own (optional) 
     * @param forCommunity (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing CombinedSamplesProductsReportResponse
     */
    listReportsSamplesProductsReport(hazardId: number, countryId?: number | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, own?: boolean | undefined, forCommunity?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_combinedSamplesProductsReportResponse>;
    /**
     * @param language (optional) 
     * @param countryId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param own (optional) 
     * @param forCommunity (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing CombinedSamplesProductsReportResponse
     */
    listReportsSamplesProductsReportCsv(language?: string | undefined, countryId?: number | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, own?: boolean | undefined, forCommunity?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_combinedSamplesProductsReportResponse>;
    /**
     * @param laboratory (optional) 
     * @param producer (optional) 
     * @param supplier (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing LocationResponse
     */
    listPortalCurrentUserLocations(laboratory?: boolean | undefined, producer?: boolean | undefined, supplier?: boolean | undefined, limit?: number | undefined): Promise<ValuesDto_locationResponse>;
    /**
     * @param id (optional) The id of the Location
     * @return Payload of LocationResponse
     */
    readPortalCurrentUserLocation(id?: number | undefined): Promise<LocationResponse>;
    /**
     * @param id (optional) The Guid of the EdiIncomingSampleUpload
     * @return Payload of EdiIncomingSampleUploadResponse
     */
    readEdiIncomingSampleUpload(id?: string | undefined): Promise<EdiIncomingSampleUploadResponse>;
    /**
     * @return Payload of EdiIncomingSampleUploadResponse
     */
    createEdiIncomingSampleUpload(body: CreateEdiIncomingSampleUploadRequest): Promise<EdiIncomingSampleUploadResponse>;
    /**
     * @param limit (optional) 
     * @return Payload of ValuesDto containing FavouriteResponse
     */
    listPortalFavourites(kindOf: string, limit?: number | undefined): Promise<ValuesDto_favouriteResponse>;
    /**
     * @return Payload of FavouriteResponse
     */
    createPortalFavourite(body: CreateFavouriteRequest): Promise<FavouriteResponse>;
    /**
     * @param id (optional) The id of the Favourite
     */
    deletePortalFavourite(id?: string | undefined): Promise<void>;
    /**
     * @param search (optional) 
     * @param productGroupCode (optional) 
     * @param isActiveMonitoring (optional) 
     * @param isExpired (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing ProductAutocompleteResponse
     */
    listPortalFeedMaterialsAutocomplete(search?: string | undefined, productGroupCode?: string | undefined, isActiveMonitoring?: boolean | undefined, isExpired?: boolean | undefined, limit?: number | undefined): Promise<ValuesDto_productAutocompleteResponse>;
    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @param productGroupCode (optional) 
     * @param isActiveMonitoring (optional) 
     * @param isExpired (optional) 
     * @param productIds (optional) 
     * @return List of products
     */
    listPortalFeedMaterials(page?: number | undefined, pageSize?: number | undefined, search?: string | undefined, productGroupCode?: string | undefined, isActiveMonitoring?: boolean | undefined, isExpired?: boolean | undefined, productIds?: string | undefined): Promise<ValuesDto_productResponse>;
    /**
     * @param search (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing HazardAutocompleteResponse
     */
    listPortalHazardsAutocomplete(search?: string | undefined, limit?: number | undefined): Promise<ValuesDto_hazardAutocompleteResponse>;
    /**
     * @return CSV format
     */
    listPortalHazardsCsv(language: string): Promise<ContentResult>;
    /**
     * @param productIds (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing HazardResponse
     */
    listPortalHazardsReport(productIds?: string | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_hazardResponse>;
    /**
     * @param search (optional) 
     * @param category (optional) 
     * @param severity (optional) 
     * @param parentHazardIds (optional) 
     * @param hazardIds (optional) 
     * @param factsheetIncluded (optional) 
     * @param isFavourite (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @param orderByDesc (optional) 
     * @return Payload of ValuesDto containing HazardResponse
     */
    listPortalHazards(search?: string | undefined, category?: string | undefined, severity?: string | undefined, parentHazardIds?: string | undefined, hazardIds?: string | undefined, factsheetIncluded?: boolean | undefined, isFavourite?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined, orderByDesc?: string | undefined): Promise<ValuesDto_hazardResponse>;
    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @param orderByDesc (optional) 
     * @return Payload of ValuesDto containing HazardResponse
     */
    listPortalParentHazards(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined, orderByDesc?: string | undefined): Promise<ValuesDto_hazardResponse>;
    /**
     * @param id (optional) The id of the Hazard
     * @return Payload of HazardResponse
     */
    readPortalHazard(id?: number | undefined): Promise<HazardResponse>;
    /**
     * @param search (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing MethodAutocompleteResponse
     */
    listPortalMethodsAutocomplete(search?: string | undefined, limit?: number | undefined): Promise<ValuesDto_methodAutocompleteResponse>;
    /**
     * @return CSV format
     */
    listPortalMethodsCsv(language: string): Promise<ContentResult>;
    /**
     * @param search (optional) 
     * @param orderBy (optional) 
     * @param orderByDesc (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing MethodResponse
     */
    listPortalMethods(search?: string | undefined, orderBy?: string | undefined, orderByDesc?: string | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_methodResponse>;
    /**
     * @param id (optional) The id of the Method
     * @return Payload of MethodResponse
     */
    readPortalMethod(id?: number | undefined): Promise<MethodResponse>;
    /**
     * @param id (optional) The id of the ProcessingAidGroup
     * @param language (optional) The language to read
     * @return Payload of File
     */
    readPortalPdfProcessingAidGroup(id?: number | undefined, language?: string | undefined): Promise<File>;
    /**
     * @param id (optional) The id of the Hazard
     * @param language (optional) The language to read
     * @return Payload of File
     */
    readPortalPdfHazard(id?: number | undefined, language?: string | undefined): Promise<File>;
    /**
     * @param id (optional) The id of the RiskAssessment
     * @param language (optional) The language to read
     * @return Payload of File
     */
    readPortalPdfRiskAssessment(id?: number | undefined, language?: string | undefined): Promise<File>;
    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing ProductResponse
     */
    listPortalProducts(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined): Promise<ValuesDto_productResponse>;
    /**
     * @param search (optional) 
     * @param productGroupCode (optional) 
     * @param productGroupCategory (optional) 
     * @param isActiveMonitoring (optional) 
     * @param isExpired (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing ProductAutocompleteResponse
     */
    listPortalProductsAutocomplete(search?: string | undefined, productGroupCode?: string | undefined, productGroupCategory?: string | undefined, isActiveMonitoring?: boolean | undefined, isExpired?: boolean | undefined, limit?: number | undefined): Promise<ValuesDto_productAutocompleteResponse>;
    /**
     * @return CSV format
     */
    listPortalProductsCsv2(language: string): Promise<ContentResult>;
    /**
     * @param id (optional) The id of the Product
     * @return Payload of ProductResponse
     */
    readPortalProduct(id?: number | undefined): Promise<ProductResponse>;
    /**
     * @param search (optional) 
     * @param productGroupCode (optional) 
     * @param productGroupCategory (optional) 
     * @param isActiveMonitoring (optional) 
     * @param isExpired (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing ProductOrMyProductAutocompleteResponse
     */
    listPortalProductsOrMyProductsAutocomplete(search?: string | undefined, productGroupCode?: string | undefined, productGroupCategory?: string | undefined, isActiveMonitoring?: boolean | undefined, isExpired?: boolean | undefined, limit?: number | undefined): Promise<ValuesDto_productOrMyProductAutocompleteResponse>;
    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @param publicationDateFrom (optional) 
     * @param publicationDateTo (optional) 
     * @param lastModifiedAtFrom (optional) 
     * @param lastModifiedAtTo (optional) 
     * @param orderBy (optional) 
     * @param orderByDesc (optional) 
     * @param hazardIds (optional) 
     * @param productIds (optional) 
     * @param processingAidIds (optional) 
     * @param isFavourite (optional) 
     * @return Payload of ValuesDto containing RiskAssessmentResponse
     */
    listPortalRiskAssessmentsPublished(page?: number | undefined, pageSize?: number | undefined, search?: string | undefined, publicationDateFrom?: Date | undefined, publicationDateTo?: Date | undefined, lastModifiedAtFrom?: Date | undefined, lastModifiedAtTo?: Date | undefined, orderBy?: string | undefined, orderByDesc?: string | undefined, hazardIds?: string | undefined, productIds?: string | undefined, processingAidIds?: string | undefined, isFavourite?: boolean | undefined): Promise<ValuesDto_riskAssessmentResponse>;
    /**
     * @param id (optional) The id of the RiskAssessment
     * @return Payload of RiskAssessmentResponse
     */
    readPortalRiskAssessment(id?: number | undefined): Promise<RiskAssessmentResponse>;
    /**
     * @param sampleId (optional) The sampleId of the Sample
     * @return Payload of SampleDataMonitoringGroupResponse
     */
    createPortalSampleDataMonitoringGroup(body: CreateSampleDataMonitoringGroupRequest, sampleId?: string | undefined): Promise<SampleDataMonitoringGroupResponse>;
    /**
     * @param sampleId (optional) The sampleId of the Sample
     * @param id (optional) The id of the SampleDataMonitoringGroup
     */
    deletePortalSampleDataMonitoringGroup(sampleId?: string | undefined, id?: string | undefined): Promise<void>;
    /**
     * @param id (optional) The id of the Hazard
     * @return Payload of HazardResponse
     */
    readPdfHazard(id?: number | undefined): Promise<HazardResponse>;
    /**
     * @param id (optional) The id of the ProcessingAidGroup
     * @return Payload of ProcessingAidGroupResponse
     */
    readPdfProcessingAidGroup(id?: number | undefined): Promise<ProcessingAidGroupResponse>;
    /**
     * @param id (optional) The id of the RiskAssessment
     * @return Payload of RiskAssessmentResponse
     */
    readPdfRiskAssessment(id?: number | undefined): Promise<RiskAssessmentResponse>;
    /**
     * @return Payload of EdiIncomingSampleExcelResponse
     */
    createEdiIncomingSampleExcel(body: CreateEdiIncomingSampleExcelRequest): Promise<EdiIncomingSampleExcelResponse>;
    /**
     * @return Payload of EdiIncomingSampleExcelResponse
     */
    createEdiIncomingSampleExcel2(body: ValidateEdiIncomingSampleExcelRequest): Promise<EdiIncomingSampleExcelResponse>;
    /**
     * @return Payload of EdiIncomingSampleXmlResponse
     */
    createEdiIncomingSampleXml(body: CreateEdiIncomingSampleXmlRequest): Promise<EdiIncomingSampleXmlResponse>;
    /**
     * @return Payload of EdiIncomingSampleXmlResponse
     */
    createEdiIncomingSampleXml2(body: ValidateEdiIncomingSampleXmlRequest): Promise<EdiIncomingSampleXmlResponse>;
}

export class Client implements IClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7071/api";

    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param status (optional) 
     * @param locationId (optional) 
     * @param productId (optional) 
     * @param own (optional) 
     * @param copied (optional) 
     * @param forCommunity (optional) 
     * @param fromEdi (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param lastModifiedAtFrom (optional) 
     * @param lastModifiedAtTo (optional) 
     * @param search (optional) 
     * @param orderBy (optional) 
     * @param orderByDesc (optional) 
     * @return Payload of ValuesDto containing CombinedSampleResponse
     */
    listCombinedSamples(page?: number | undefined, pageSize?: number | undefined, status?: string | undefined, locationId?: number | undefined, productId?: number | undefined, own?: boolean | undefined, copied?: boolean | undefined, forCommunity?: boolean | undefined, fromEdi?: boolean | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, lastModifiedAtFrom?: Date | undefined, lastModifiedAtTo?: Date | undefined, search?: string | undefined, orderBy?: string | undefined, orderByDesc?: string | undefined, signal?: AbortSignal): Promise<ValuesDto_combinedSampleResponse> {
        let url_ = this.baseUrl + "/combined-samples?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (own === null)
            throw new Error("The parameter 'own' cannot be null.");
        else if (own !== undefined)
            url_ += "own=" + encodeURIComponent("" + own) + "&";
        if (copied === null)
            throw new Error("The parameter 'copied' cannot be null.");
        else if (copied !== undefined)
            url_ += "copied=" + encodeURIComponent("" + copied) + "&";
        if (forCommunity === null)
            throw new Error("The parameter 'forCommunity' cannot be null.");
        else if (forCommunity !== undefined)
            url_ += "forCommunity=" + encodeURIComponent("" + forCommunity) + "&";
        if (fromEdi === null)
            throw new Error("The parameter 'fromEdi' cannot be null.");
        else if (fromEdi !== undefined)
            url_ += "fromEdi=" + encodeURIComponent("" + fromEdi) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (lastModifiedAtFrom === null)
            throw new Error("The parameter 'lastModifiedAtFrom' cannot be null.");
        else if (lastModifiedAtFrom !== undefined)
            url_ += "lastModifiedAtFrom=" + encodeURIComponent(lastModifiedAtFrom ? "" + lastModifiedAtFrom.toISOString() : "") + "&";
        if (lastModifiedAtTo === null)
            throw new Error("The parameter 'lastModifiedAtTo' cannot be null.");
        else if (lastModifiedAtTo !== undefined)
            url_ += "lastModifiedAtTo=" + encodeURIComponent(lastModifiedAtTo ? "" + lastModifiedAtTo.toISOString() : "") + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDesc === null)
            throw new Error("The parameter 'orderByDesc' cannot be null.");
        else if (orderByDesc !== undefined)
            url_ += "orderByDesc=" + encodeURIComponent("" + orderByDesc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListCombinedSamples(_response);
        });
    }

    protected processListCombinedSamples(response: AxiosResponse): Promise<ValuesDto_combinedSampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_combinedSampleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_combinedSampleResponse>(null as any);
    }

    /**
     * @return Payload of Object
     */
    readConfig(signal?: AbortSignal): Promise<any> {
        let url_ = this.baseUrl + "/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadConfig(_response);
        });
    }

    protected processReadConfig(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Payload of ValuesDto containing ControlMeasureGroupResponse
     */
    listControlMeasureGroups(signal?: AbortSignal): Promise<ValuesDto_controlMeasureGroupResponse> {
        let url_ = this.baseUrl + "/control-measure-groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListControlMeasureGroups(_response);
        });
    }

    protected processListControlMeasureGroups(response: AxiosResponse): Promise<ValuesDto_controlMeasureGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_controlMeasureGroupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_controlMeasureGroupResponse>(null as any);
    }

    /**
     * @return Payload of ControlMeasureGroupResponse
     */
    createControlMeasureGroup(body: CreateControlMeasureGroupRequest, signal?: AbortSignal): Promise<ControlMeasureGroupResponse> {
        let url_ = this.baseUrl + "/control-measure-groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateControlMeasureGroup(_response);
        });
    }

    protected processCreateControlMeasureGroup(response: AxiosResponse): Promise<ControlMeasureGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ControlMeasureGroupResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControlMeasureGroupResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the ControlMeasureGroup
     * @return Payload of ControlMeasureGroupResponse
     */
    readControlMeasureGroup(id?: number | undefined, signal?: AbortSignal): Promise<ControlMeasureGroupResponse> {
        let url_ = this.baseUrl + "/control-measure-groups/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadControlMeasureGroup(_response);
        });
    }

    protected processReadControlMeasureGroup(response: AxiosResponse): Promise<ControlMeasureGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ControlMeasureGroupResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControlMeasureGroupResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Unit
     * @return Payload of ControlMeasureGroupResponse
     */
    updateControlMeasureGroup(body: UpdateControlMeasureGroupRequest, id?: number | undefined, signal?: AbortSignal): Promise<ControlMeasureGroupResponse> {
        let url_ = this.baseUrl + "/control-measure-groups/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateControlMeasureGroup(_response);
        });
    }

    protected processUpdateControlMeasureGroup(response: AxiosResponse): Promise<ControlMeasureGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ControlMeasureGroupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControlMeasureGroupResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the ControlMeasureGroup
     */
    deleteControlMeasureGroup(id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/control-measure-groups/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteControlMeasureGroup(_response);
        });
    }

    protected processDeleteControlMeasureGroup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @return Payload of ValuesDto containing ControlMeasureResponse
     */
    listControlMeasures(page?: number | undefined, pageSize?: number | undefined, search?: string | undefined, signal?: AbortSignal): Promise<ValuesDto_controlMeasureResponse> {
        let url_ = this.baseUrl + "/control-measures?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListControlMeasures(_response);
        });
    }

    protected processListControlMeasures(response: AxiosResponse): Promise<ValuesDto_controlMeasureResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_controlMeasureResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_controlMeasureResponse>(null as any);
    }

    /**
     * @return Payload of ControlMeasureResponse
     */
    createControlMeasure(body: CreateControlMeasureRequest, signal?: AbortSignal): Promise<ControlMeasureResponse> {
        let url_ = this.baseUrl + "/control-measures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateControlMeasure(_response);
        });
    }

    protected processCreateControlMeasure(response: AxiosResponse): Promise<ControlMeasureResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ControlMeasureResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControlMeasureResponse>(null as any);
    }

    /**
     * @return CSV format
     */
    listControlMeasuresCsv(language: string, signal?: AbortSignal): Promise<ContentResult> {
        let url_ = this.baseUrl + "/control-measures/csv/{language}";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/csv"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListControlMeasuresCsv(_response);
        });
    }

    protected processListControlMeasuresCsv(response: AxiosResponse): Promise<ContentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ContentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentResult>(null as any);
    }

    /**
     * @param id (optional) The id of the ControlMeasure
     * @return Payload of ControlMeasureResponse
     */
    readControlMeasure(id?: number | undefined, signal?: AbortSignal): Promise<ControlMeasureResponse> {
        let url_ = this.baseUrl + "/control-measures/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadControlMeasure(_response);
        });
    }

    protected processReadControlMeasure(response: AxiosResponse): Promise<ControlMeasureResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ControlMeasureResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControlMeasureResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Unit
     * @return Payload of ControlMeasureResponse
     */
    updateControlMeasure(body: UpdateControlMeasureRequest, id?: number | undefined, signal?: AbortSignal): Promise<ControlMeasureResponse> {
        let url_ = this.baseUrl + "/control-measures/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateControlMeasure(_response);
        });
    }

    protected processUpdateControlMeasure(response: AxiosResponse): Promise<ControlMeasureResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ControlMeasureResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ControlMeasureResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the ControlMeasure
     */
    deleteControlMeasure(id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/control-measures/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteControlMeasure(_response);
        });
    }

    protected processDeleteControlMeasure(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param language (optional) 
     * @return CSV format
     */
    listCountriesCsv(language?: string | undefined, signal?: AbortSignal): Promise<ContentResult> {
        let url_ = this.baseUrl + "/countries/csv/{language}";
        if (language !== null && language !== undefined)
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        else
            url_ = url_.replace("/{language}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/csv"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListCountriesCsv(_response);
        });
    }

    protected processListCountriesCsv(response: AxiosResponse): Promise<ContentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ContentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentResult>(null as any);
    }

    /**
     * @return Payload of ValuesDto containing CountryResponse
     */
    listCountries(signal?: AbortSignal): Promise<ValuesDto_countryResponse> {
        let url_ = this.baseUrl + "/countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListCountries(_response);
        });
    }

    protected processListCountries(response: AxiosResponse): Promise<ValuesDto_countryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_countryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_countryResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Country
     * @return Payload of CountryResponse
     */
    readCountry(id?: number | undefined, signal?: AbortSignal): Promise<CountryResponse> {
        let url_ = this.baseUrl + "/countries/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadCountry(_response);
        });
    }

    protected processReadCountry(response: AxiosResponse): Promise<CountryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountryResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountryResponse>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing DocumentResponse
     */
    listDocuments(page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_documentResponse> {
        let url_ = this.baseUrl + "/documents?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListDocuments(_response);
        });
    }

    protected processListDocuments(response: AxiosResponse): Promise<ValuesDto_documentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_documentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_documentResponse>(null as any);
    }

    /**
     * @return Payload of DocumentResponse
     */
    createDocument(body: CreateDocumentRequest, signal?: AbortSignal): Promise<DocumentResponse> {
        let url_ = this.baseUrl + "/documents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDocument(_response);
        });
    }

    protected processCreateDocument(response: AxiosResponse): Promise<DocumentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Document
     * @return Payload of DocumentResponse
     */
    readDocument(id?: string | undefined, signal?: AbortSignal): Promise<DocumentResponse> {
        let url_ = this.baseUrl + "/documents/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadDocument(_response);
        });
    }

    protected processReadDocument(response: AxiosResponse): Promise<DocumentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentResponse>(null as any);
    }

    readDocumentsFile(file?: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/download/documents/{*file}";
        if (file !== null && file !== undefined)
        url_ = url_.replace("{file}", encodeURIComponent("" + file));
        else
            url_ = url_.replace("/{file}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadDocumentsFile(_response);
        });
    }

    protected processReadDocumentsFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    readIncomingSamplesFile(file?: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/download/incoming-samples/{*file}";
        if (file !== null && file !== undefined)
        url_ = url_.replace("{file}", encodeURIComponent("" + file));
        else
            url_ = url_.replace("/{file}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadIncomingSamplesFile(_response);
        });
    }

    protected processReadIncomingSamplesFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param search (optional) 
     * @param dateReceivedFrom (optional) 
     * @param dateReceivedTo (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing EdiIncomingSampleEmailResponse
     */
    listEdiIncomingSampleEmails(search?: string | undefined, dateReceivedFrom?: Date | undefined, dateReceivedTo?: Date | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_ediIncomingSampleEmailResponse> {
        let url_ = this.baseUrl + "/edi-incoming-sample-emails?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (dateReceivedFrom === null)
            throw new Error("The parameter 'dateReceivedFrom' cannot be null.");
        else if (dateReceivedFrom !== undefined)
            url_ += "dateReceivedFrom=" + encodeURIComponent(dateReceivedFrom ? "" + dateReceivedFrom.toISOString() : "") + "&";
        if (dateReceivedTo === null)
            throw new Error("The parameter 'dateReceivedTo' cannot be null.");
        else if (dateReceivedTo !== undefined)
            url_ += "dateReceivedTo=" + encodeURIComponent(dateReceivedTo ? "" + dateReceivedTo.toISOString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListEdiIncomingSampleEmails(_response);
        });
    }

    protected processListEdiIncomingSampleEmails(response: AxiosResponse): Promise<ValuesDto_ediIncomingSampleEmailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_ediIncomingSampleEmailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_ediIncomingSampleEmailResponse>(null as any);
    }

    /**
     * @return Payload of ValuesDto containing EdiIncomingSampleEmailResponse
     */
    listEdiIncomingSampleEmail(id: string, signal?: AbortSignal): Promise<ValuesDto_ediIncomingSampleEmailResponse> {
        let url_ = this.baseUrl + "/edi-incoming-sample-emails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListEdiIncomingSampleEmail(_response);
        });
    }

    protected processListEdiIncomingSampleEmail(response: AxiosResponse): Promise<ValuesDto_ediIncomingSampleEmailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_ediIncomingSampleEmailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_ediIncomingSampleEmailResponse>(null as any);
    }

    /**
     * @return Payload of Array of Object
     */
    readHazardDefaults(signal?: AbortSignal): Promise<any[]> {
        let url_ = this.baseUrl + "/hazard-defaults";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadHazardDefaults(_response);
        });
    }

    protected processReadHazardDefaults(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<any[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(null as any);
    }

    /**
     * @return Payload of HazardsControlMeasureResponse
     */
    createHazardsControlMeasure(body: CreateHazardsControlMeasureRequest, signal?: AbortSignal): Promise<HazardsControlMeasureResponse> {
        let url_ = this.baseUrl + "/hazards-control-measures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateHazardsControlMeasure(_response);
        });
    }

    protected processCreateHazardsControlMeasure(response: AxiosResponse): Promise<HazardsControlMeasureResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HazardsControlMeasureResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HazardsControlMeasureResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the HazardsControlMeasure
     */
    deleteHazardsControlMeasure(id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/hazards-control-measures/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteHazardsControlMeasure(_response);
        });
    }

    protected processDeleteHazardsControlMeasure(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param hazardId (optional) 
     * @param language (optional) 
     * @param path (optional) 
     * @return Payload of HazardsFactsheetFileReferenceResponse
     */
    createHazardsFactsheetFileReference(hazardId?: number | undefined, language?: string | undefined, path?: string | undefined, signal?: AbortSignal): Promise<HazardsFactsheetFileReferenceResponse> {
        let url_ = this.baseUrl + "/hazards/{hazardId}/factsheet-file-references";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (hazardId === null || hazardId === undefined)
            throw new Error("The parameter 'hazardId' cannot be null.");
        else
            content_.append("hazardId", hazardId.toString());
        if (language === null || language === undefined)
            throw new Error("The parameter 'language' cannot be null.");
        else
            content_.append("language", language.toString());
        if (path === null || path === undefined)
            throw new Error("The parameter 'path' cannot be null.");
        else
            content_.append("path", path.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateHazardsFactsheetFileReference(_response);
        });
    }

    protected processCreateHazardsFactsheetFileReference(response: AxiosResponse): Promise<HazardsFactsheetFileReferenceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HazardsFactsheetFileReferenceResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HazardsFactsheetFileReferenceResponse>(null as any);
    }

    /**
     * @param hazardId (optional) The hazardId of the Hazard
     * @param id (optional) The id of the HazardsFactsheetFileReference
     * @return Payload of HazardsFactsheetFileReferenceResponse
     */
    updateHazardsFactsheetFileReference(body: UpdateHazardsFactsheetFileReferenceRequest, hazardId?: number | undefined, id?: number | undefined, signal?: AbortSignal): Promise<HazardsFactsheetFileReferenceResponse> {
        let url_ = this.baseUrl + "/hazards/{hazardId}/factsheet-file-references/{id}";
        if (hazardId !== null && hazardId !== undefined)
        url_ = url_.replace("{hazardId}", encodeURIComponent("" + hazardId));
        else
            url_ = url_.replace("/{hazardId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateHazardsFactsheetFileReference(_response);
        });
    }

    protected processUpdateHazardsFactsheetFileReference(response: AxiosResponse): Promise<HazardsFactsheetFileReferenceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HazardsFactsheetFileReferenceResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HazardsFactsheetFileReferenceResponse>(null as any);
    }

    /**
     * @param hazardId (optional) The hazardId of the Hazard
     * @param id (optional) The id of the HazardsFactsheetFileReference
     */
    deleteHazardsFactsheetFileReference(hazardId?: number | undefined, id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/hazards/{hazardId}/factsheet-file-references/{id}";
        if (hazardId !== null && hazardId !== undefined)
        url_ = url_.replace("{hazardId}", encodeURIComponent("" + hazardId));
        else
            url_ = url_.replace("/{hazardId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteHazardsFactsheetFileReference(_response);
        });
    }

    protected processDeleteHazardsFactsheetFileReference(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param language (optional) 
     * @return CSV format
     */
    listHazardsCsv(language?: string | undefined, signal?: AbortSignal): Promise<ContentResult> {
        let url_ = this.baseUrl + "/hazards/csv/{language}";
        if (language !== null && language !== undefined)
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        else
            url_ = url_.replace("/{language}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/csv"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListHazardsCsv(_response);
        });
    }

    protected processListHazardsCsv(response: AxiosResponse): Promise<ContentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ContentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentResult>(null as any);
    }

    /**
     * @param search (optional) 
     * @param category (optional) 
     * @param severity (optional) 
     * @param parentHazardIds (optional) 
     * @param factsheetIncluded (optional) 
     * @param isActiveForRiskAssessment (optional) 
     * @param isActiveMonitoring (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @param orderByDesc (optional) 
     * @return Payload of ValuesDto containing HazardResponse
     */
    listHazards(search?: string | undefined, category?: string | undefined, severity?: string | undefined, parentHazardIds?: string | undefined, factsheetIncluded?: boolean | undefined, isActiveForRiskAssessment?: boolean | undefined, isActiveMonitoring?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined, orderByDesc?: string | undefined, signal?: AbortSignal): Promise<ValuesDto_hazardResponse> {
        let url_ = this.baseUrl + "/hazards?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        if (severity === null)
            throw new Error("The parameter 'severity' cannot be null.");
        else if (severity !== undefined)
            url_ += "severity=" + encodeURIComponent("" + severity) + "&";
        if (parentHazardIds === null)
            throw new Error("The parameter 'parentHazardIds' cannot be null.");
        else if (parentHazardIds !== undefined)
            url_ += "parentHazardIds=" + encodeURIComponent("" + parentHazardIds) + "&";
        if (factsheetIncluded === null)
            throw new Error("The parameter 'factsheetIncluded' cannot be null.");
        else if (factsheetIncluded !== undefined)
            url_ += "factsheetIncluded=" + encodeURIComponent("" + factsheetIncluded) + "&";
        if (isActiveForRiskAssessment === null)
            throw new Error("The parameter 'isActiveForRiskAssessment' cannot be null.");
        else if (isActiveForRiskAssessment !== undefined)
            url_ += "isActiveForRiskAssessment=" + encodeURIComponent("" + isActiveForRiskAssessment) + "&";
        if (isActiveMonitoring === null)
            throw new Error("The parameter 'isActiveMonitoring' cannot be null.");
        else if (isActiveMonitoring !== undefined)
            url_ += "isActiveMonitoring=" + encodeURIComponent("" + isActiveMonitoring) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDesc === null)
            throw new Error("The parameter 'orderByDesc' cannot be null.");
        else if (orderByDesc !== undefined)
            url_ += "orderByDesc=" + encodeURIComponent("" + orderByDesc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListHazards(_response);
        });
    }

    protected processListHazards(response: AxiosResponse): Promise<ValuesDto_hazardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_hazardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_hazardResponse>(null as any);
    }

    /**
     * @return Payload of HazardResponse
     */
    createHazard(body: CreateHazardRequest, signal?: AbortSignal): Promise<HazardResponse> {
        let url_ = this.baseUrl + "/hazards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateHazard(_response);
        });
    }

    protected processCreateHazard(response: AxiosResponse): Promise<HazardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HazardResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HazardResponse>(null as any);
    }

    /**
     * @param isActiveForRiskAssessment (optional) 
     * @param isActiveMonitoring (optional) 
     * @param search (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing HazardAutocompleteResponse
     */
    listHazardsAutocomplete(isActiveForRiskAssessment?: boolean | undefined, isActiveMonitoring?: boolean | undefined, search?: string | undefined, limit?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_hazardAutocompleteResponse> {
        let url_ = this.baseUrl + "/hazards:autocomplete?";
        if (isActiveForRiskAssessment === null)
            throw new Error("The parameter 'isActiveForRiskAssessment' cannot be null.");
        else if (isActiveForRiskAssessment !== undefined)
            url_ += "isActiveForRiskAssessment=" + encodeURIComponent("" + isActiveForRiskAssessment) + "&";
        if (isActiveMonitoring === null)
            throw new Error("The parameter 'isActiveMonitoring' cannot be null.");
        else if (isActiveMonitoring !== undefined)
            url_ += "isActiveMonitoring=" + encodeURIComponent("" + isActiveMonitoring) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListHazardsAutocomplete(_response);
        });
    }

    protected processListHazardsAutocomplete(response: AxiosResponse): Promise<ValuesDto_hazardAutocompleteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_hazardAutocompleteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_hazardAutocompleteResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Hazard
     * @return Payload of HazardResponse
     */
    readHazard(id?: number | undefined, signal?: AbortSignal): Promise<HazardResponse> {
        let url_ = this.baseUrl + "/hazards/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadHazard(_response);
        });
    }

    protected processReadHazard(response: AxiosResponse): Promise<HazardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HazardResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HazardResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Hazard
     * @return Payload of HazardResponse
     */
    updateHazard(body: UpdateHazardRequest, id?: number | undefined, signal?: AbortSignal): Promise<HazardResponse> {
        let url_ = this.baseUrl + "/hazards/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateHazard(_response);
        });
    }

    protected processUpdateHazard(response: AxiosResponse): Promise<HazardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HazardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HazardResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Hazard
     */
    deleteHazard(id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/hazards/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteHazard(_response);
        });
    }

    protected processDeleteHazard(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Payload of HazardsLimitResponse
     */
    createHazardsLimit(body: CreateHazardRequest, signal?: AbortSignal): Promise<HazardsLimitResponse> {
        let url_ = this.baseUrl + "/hazard-limits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateHazardsLimit(_response);
        });
    }

    protected processCreateHazardsLimit(response: AxiosResponse): Promise<HazardsLimitResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HazardsLimitResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HazardsLimitResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the HazardsLimit
     * @return Payload of HazardsLimitResponse
     */
    updateHazardsLimit(body: UpdateHazardsLimitRequest, id?: number | undefined, signal?: AbortSignal): Promise<HazardsLimitResponse> {
        let url_ = this.baseUrl + "/hazard-limits/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateHazardsLimit(_response);
        });
    }

    protected processUpdateHazardsLimit(response: AxiosResponse): Promise<HazardsLimitResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HazardsLimitResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HazardsLimitResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the HazardsLimit
     */
    deleteHazardsLimit(id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/hazards-limits/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteHazardsLimit(_response);
        });
    }

    protected processDeleteHazardsLimit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param hazardId (optional) 
     * @param language (optional) 
     * @param path (optional) 
     * @return Payload of HazardsStandardDocumentFileReferenceResponse
     */
    createHazardsStandardDocumentFileReference(hazardId?: number | undefined, language?: string | undefined, path?: string | undefined, signal?: AbortSignal): Promise<HazardsStandardDocumentFileReferenceResponse> {
        let url_ = this.baseUrl + "/hazards/{hazardId}/standard-document-file-references";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (hazardId === null || hazardId === undefined)
            throw new Error("The parameter 'hazardId' cannot be null.");
        else
            content_.append("hazardId", hazardId.toString());
        if (language === null || language === undefined)
            throw new Error("The parameter 'language' cannot be null.");
        else
            content_.append("language", language.toString());
        if (path === null || path === undefined)
            throw new Error("The parameter 'path' cannot be null.");
        else
            content_.append("path", path.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateHazardsStandardDocumentFileReference(_response);
        });
    }

    protected processCreateHazardsStandardDocumentFileReference(response: AxiosResponse): Promise<HazardsStandardDocumentFileReferenceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HazardsStandardDocumentFileReferenceResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HazardsStandardDocumentFileReferenceResponse>(null as any);
    }

    /**
     * @param hazardId (optional) The hazardId of the Hazard
     * @param id (optional) The id of the HazardsStandardDocumentFileReference
     * @return Payload of HazardsStandardDocumentFileReferenceResponse
     */
    updateHazardsStandardDocumentFileReference(body: UpdateHazardsStandardDocumentFileReferenceRequest, hazardId?: number | undefined, id?: number | undefined, signal?: AbortSignal): Promise<HazardsStandardDocumentFileReferenceResponse> {
        let url_ = this.baseUrl + "/hazards/{hazardId}/standard-document-file-references/{id}";
        if (hazardId !== null && hazardId !== undefined)
        url_ = url_.replace("{hazardId}", encodeURIComponent("" + hazardId));
        else
            url_ = url_.replace("/{hazardId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateHazardsStandardDocumentFileReference(_response);
        });
    }

    protected processUpdateHazardsStandardDocumentFileReference(response: AxiosResponse): Promise<HazardsStandardDocumentFileReferenceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HazardsStandardDocumentFileReferenceResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HazardsStandardDocumentFileReferenceResponse>(null as any);
    }

    /**
     * @param hazardId (optional) The hazardId of the Hazard
     * @param id (optional) The id of the HazardsStandardDocumentFileReference
     */
    deleteHazardsStandardDocumentFileReference(hazardId?: number | undefined, id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/hazards/{hazardId}/standard-document-file-references/{id}";
        if (hazardId !== null && hazardId !== undefined)
        url_ = url_.replace("{hazardId}", encodeURIComponent("" + hazardId));
        else
            url_ = url_.replace("/{hazardId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteHazardsStandardDocumentFileReference(_response);
        });
    }

    protected processDeleteHazardsStandardDocumentFileReference(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param search (optional) 
     * @param laboratory (optional) 
     * @param producer (optional) 
     * @param supplier (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing LocationAutocompleteResponse
     */
    listLocationsAutocomplete(search?: string | undefined, laboratory?: boolean | undefined, producer?: boolean | undefined, supplier?: boolean | undefined, limit?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_locationAutocompleteResponse> {
        let url_ = this.baseUrl + "/locations:autocomplete?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (laboratory === null)
            throw new Error("The parameter 'laboratory' cannot be null.");
        else if (laboratory !== undefined)
            url_ += "laboratory=" + encodeURIComponent("" + laboratory) + "&";
        if (producer === null)
            throw new Error("The parameter 'producer' cannot be null.");
        else if (producer !== undefined)
            url_ += "producer=" + encodeURIComponent("" + producer) + "&";
        if (supplier === null)
            throw new Error("The parameter 'supplier' cannot be null.");
        else if (supplier !== undefined)
            url_ += "supplier=" + encodeURIComponent("" + supplier) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListLocationsAutocomplete(_response);
        });
    }

    protected processListLocationsAutocomplete(response: AxiosResponse): Promise<ValuesDto_locationAutocompleteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_locationAutocompleteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_locationAutocompleteResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Location
     * @return Payload of LocationResponse
     */
    readLocation(id?: number | undefined, signal?: AbortSignal): Promise<LocationResponse> {
        let url_ = this.baseUrl + "/locations/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadLocation(_response);
        });
    }

    protected processReadLocation(response: AxiosResponse): Promise<LocationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LocationResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Location
     * @return Payload of LocationResponse
     */
    updateLocation(body: UpdateLocationRequest, id?: number | undefined, signal?: AbortSignal): Promise<LocationResponse> {
        let url_ = this.baseUrl + "/locations/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLocation(_response);
        });
    }

    protected processUpdateLocation(response: AxiosResponse): Promise<LocationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LocationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Location
     */
    deleteLocation(id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/locations/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteLocation(_response);
        });
    }

    protected processDeleteLocation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Payload of LocationResponse
     */
    createLocation(body: CreateLocationRequest, signal?: AbortSignal): Promise<LocationResponse> {
        let url_ = this.baseUrl + "/locations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateLocation(_response);
        });
    }

    protected processCreateLocation(response: AxiosResponse): Promise<LocationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LocationResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationResponse>(null as any);
    }

    /**
     * @param language (optional) 
     * @return CSV format
     */
    listMethodsCsv(language?: string | undefined, signal?: AbortSignal): Promise<ContentResult> {
        let url_ = this.baseUrl + "/methods/csv/{language}";
        if (language !== null && language !== undefined)
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        else
            url_ = url_.replace("/{language}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/csv"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListMethodsCsv(_response);
        });
    }

    protected processListMethodsCsv(response: AxiosResponse): Promise<ContentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ContentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentResult>(null as any);
    }

    /**
     * @return Payload of ValuesDto containing MethodResponse
     */
    listMethods(signal?: AbortSignal): Promise<ValuesDto_methodResponse> {
        let url_ = this.baseUrl + "/methods";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListMethods(_response);
        });
    }

    protected processListMethods(response: AxiosResponse): Promise<ValuesDto_methodResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_methodResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_methodResponse>(null as any);
    }

    /**
     * @return Payload of MethodResponse
     */
    createMethod(body: CreateMethodRequest, signal?: AbortSignal): Promise<MethodResponse> {
        let url_ = this.baseUrl + "/methods";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMethod(_response);
        });
    }

    protected processCreateMethod(response: AxiosResponse): Promise<MethodResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MethodResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MethodResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Method
     * @return Payload of MethodResponse
     */
    readMethod(id?: number | undefined, signal?: AbortSignal): Promise<MethodResponse> {
        let url_ = this.baseUrl + "/methods/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadMethod(_response);
        });
    }

    protected processReadMethod(response: AxiosResponse): Promise<MethodResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MethodResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MethodResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Unit
     * @return Payload of MethodResponse
     */
    updateMethod(body: UpdateMethodRequest, id?: number | undefined, signal?: AbortSignal): Promise<MethodResponse> {
        let url_ = this.baseUrl + "/methods/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMethod(_response);
        });
    }

    protected processUpdateMethod(response: AxiosResponse): Promise<MethodResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MethodResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MethodResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Method
     */
    deleteMethod(id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/methods/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMethod(_response);
        });
    }

    protected processDeleteMethod(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param search (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing MonitoringGroupAutocompleteResponse
     */
    listMonitoringGroupsAutocomplete(search?: string | undefined, limit?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_monitoringGroupAutocompleteResponse> {
        let url_ = this.baseUrl + "/monitoring-groups:autocomplete?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListMonitoringGroupsAutocomplete(_response);
        });
    }

    protected processListMonitoringGroupsAutocomplete(response: AxiosResponse): Promise<ValuesDto_monitoringGroupAutocompleteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_monitoringGroupAutocompleteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_monitoringGroupAutocompleteResponse>(null as any);
    }

    /**
     * @return Payload of ValuesDto containing MonitoringGroupResponse
     */
    listMonitoringGroups(signal?: AbortSignal): Promise<ValuesDto_monitoringGroupResponse> {
        let url_ = this.baseUrl + "/monitoring-groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListMonitoringGroups(_response);
        });
    }

    protected processListMonitoringGroups(response: AxiosResponse): Promise<ValuesDto_monitoringGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_monitoringGroupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_monitoringGroupResponse>(null as any);
    }

    /**
     * @return Payload of MonitoringGroupResponse
     */
    createMonitoringGroup(body: CreateMonitoringGroupRequest, signal?: AbortSignal): Promise<MonitoringGroupResponse> {
        let url_ = this.baseUrl + "/monitoring-groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMonitoringGroup(_response);
        });
    }

    protected processCreateMonitoringGroup(response: AxiosResponse): Promise<MonitoringGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MonitoringGroupResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonitoringGroupResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the MonitoringGroup
     * @return Payload of MonitoringGroupResponse
     */
    readMonitoringGroup(id?: number | undefined, signal?: AbortSignal): Promise<MonitoringGroupResponse> {
        let url_ = this.baseUrl + "/monitoring-groups/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadMonitoringGroup(_response);
        });
    }

    protected processReadMonitoringGroup(response: AxiosResponse): Promise<MonitoringGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MonitoringGroupResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonitoringGroupResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Unit
     * @return Payload of MonitoringGroupResponse
     */
    updateMonitoringGroup(body: UpdateMonitoringGroupRequest, id?: number | undefined, signal?: AbortSignal): Promise<MonitoringGroupResponse> {
        let url_ = this.baseUrl + "/monitoring-groups/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMonitoringGroup(_response);
        });
    }

    protected processUpdateMonitoringGroup(response: AxiosResponse): Promise<MonitoringGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MonitoringGroupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonitoringGroupResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the MonitoringGroup
     */
    deleteMonitoringGroup(id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/monitoring-groups/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMonitoringGroup(_response);
        });
    }

    protected processDeleteMonitoringGroup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing PlannedSampleResponse
     */
    listPlannedSamples(page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_plannedSampleResponse> {
        let url_ = this.baseUrl + "/planned-samples?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPlannedSamples(_response);
        });
    }

    protected processListPlannedSamples(response: AxiosResponse): Promise<ValuesDto_plannedSampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_plannedSampleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_plannedSampleResponse>(null as any);
    }

    /**
     * @return Payload of PlannedSampleResponse
     */
    createPlannedSample(body: CreatePlannedSampleRequest, signal?: AbortSignal): Promise<PlannedSampleResponse> {
        let url_ = this.baseUrl + "/planned-samples";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePlannedSample(_response);
        });
    }

    protected processCreatePlannedSample(response: AxiosResponse): Promise<PlannedSampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PlannedSampleResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlannedSampleResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the PlannedSample
     * @return Payload of PlannedSampleResponse
     */
    readPlannedSample(id?: string | undefined, signal?: AbortSignal): Promise<PlannedSampleResponse> {
        let url_ = this.baseUrl + "/planned-samples/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPlannedSample(_response);
        });
    }

    protected processReadPlannedSample(response: AxiosResponse): Promise<PlannedSampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PlannedSampleResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlannedSampleResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Unit
     * @return Payload of PlannedSampleResponse
     */
    updatePlannedSample(body: UpdatePlannedSampleRequest, id?: string | undefined, signal?: AbortSignal): Promise<PlannedSampleResponse> {
        let url_ = this.baseUrl + "/planned-samples/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePlannedSample(_response);
        });
    }

    protected processUpdatePlannedSample(response: AxiosResponse): Promise<PlannedSampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PlannedSampleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlannedSampleResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the PlannedSample
     */
    deletePlannedSample(id?: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/planned-samples/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePlannedSample(_response);
        });
    }

    protected processDeletePlannedSample(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param monitoringGroupId (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing LocationsMonitoringGroupForGroupManagerResponse
     */
    listPortalGroupManagerLocationsMonitoringGroups(monitoringGroupId?: number | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_locationsMonitoringGroupForGroupManagerResponse> {
        let url_ = this.baseUrl + "/portal/group-manager/locations-monitoring-groups?";
        if (monitoringGroupId === null)
            throw new Error("The parameter 'monitoringGroupId' cannot be null.");
        else if (monitoringGroupId !== undefined)
            url_ += "monitoringGroupId=" + encodeURIComponent("" + monitoringGroupId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalGroupManagerLocationsMonitoringGroups(_response);
        });
    }

    protected processListPortalGroupManagerLocationsMonitoringGroups(response: AxiosResponse): Promise<ValuesDto_locationsMonitoringGroupForGroupManagerResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_locationsMonitoringGroupForGroupManagerResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_locationsMonitoringGroupForGroupManagerResponse>(null as any);
    }

    /**
     * @return Payload of LocationsMonitoringGroupResponse
     */
    createPortalLocationsMonitoringGroup(body: CreateLocationsMonitoringGroupRequest, signal?: AbortSignal): Promise<LocationsMonitoringGroupResponse> {
        let url_ = this.baseUrl + "/portal/group-manager/locations-monitoring-groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePortalLocationsMonitoringGroup(_response);
        });
    }

    protected processCreatePortalLocationsMonitoringGroup(response: AxiosResponse): Promise<LocationsMonitoringGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LocationsMonitoringGroupResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationsMonitoringGroupResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Unit
     * @return Payload of LocationsMonitoringGroupResponse
     */
    updateLocationsMonitoringGroupAsManager(body: UpdateLocationsMonitoringGroupAsManagerRequest, id?: number | undefined, signal?: AbortSignal): Promise<LocationsMonitoringGroupResponse> {
        let url_ = this.baseUrl + "/portal/group-manager/locations-monitoring-groups/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLocationsMonitoringGroupAsManager(_response);
        });
    }

    protected processUpdateLocationsMonitoringGroupAsManager(response: AxiosResponse): Promise<LocationsMonitoringGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LocationsMonitoringGroupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationsMonitoringGroupResponse>(null as any);
    }

    /**
     * @param search (optional) 
     * @param laboratory (optional) 
     * @param producer (optional) 
     * @param supplier (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing LocationAutocompleteResponse
     */
    listPortalLocationsAutocomplete(search?: string | undefined, laboratory?: boolean | undefined, producer?: boolean | undefined, supplier?: boolean | undefined, limit?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_locationAutocompleteResponse> {
        let url_ = this.baseUrl + "/portal/locations:autocomplete?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (laboratory === null)
            throw new Error("The parameter 'laboratory' cannot be null.");
        else if (laboratory !== undefined)
            url_ += "laboratory=" + encodeURIComponent("" + laboratory) + "&";
        if (producer === null)
            throw new Error("The parameter 'producer' cannot be null.");
        else if (producer !== undefined)
            url_ += "producer=" + encodeURIComponent("" + producer) + "&";
        if (supplier === null)
            throw new Error("The parameter 'supplier' cannot be null.");
        else if (supplier !== undefined)
            url_ += "supplier=" + encodeURIComponent("" + supplier) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalLocationsAutocomplete(_response);
        });
    }

    protected processListPortalLocationsAutocomplete(response: AxiosResponse): Promise<ValuesDto_locationAutocompleteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_locationAutocompleteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_locationAutocompleteResponse>(null as any);
    }

    /**
     * @param search (optional) 
     * @param laboratory (optional) 
     * @param producer (optional) 
     * @param supplier (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing LocationAutocompleteResponse
     */
    listPortalLocationsOwnAutocomplete(search?: string | undefined, laboratory?: boolean | undefined, producer?: boolean | undefined, supplier?: boolean | undefined, limit?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_locationAutocompleteResponse> {
        let url_ = this.baseUrl + "/portal/locations/own:autocomplete?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (laboratory === null)
            throw new Error("The parameter 'laboratory' cannot be null.");
        else if (laboratory !== undefined)
            url_ += "laboratory=" + encodeURIComponent("" + laboratory) + "&";
        if (producer === null)
            throw new Error("The parameter 'producer' cannot be null.");
        else if (producer !== undefined)
            url_ += "producer=" + encodeURIComponent("" + producer) + "&";
        if (supplier === null)
            throw new Error("The parameter 'supplier' cannot be null.");
        else if (supplier !== undefined)
            url_ += "supplier=" + encodeURIComponent("" + supplier) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalLocationsOwnAutocomplete(_response);
        });
    }

    protected processListPortalLocationsOwnAutocomplete(response: AxiosResponse): Promise<ValuesDto_locationAutocompleteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_locationAutocompleteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_locationAutocompleteResponse>(null as any);
    }

    /**
     * @param laboratory (optional) 
     * @param producer (optional) 
     * @param supplier (optional) 
     * @return CSV format
     */
    listPortalLocationsCsv(language: string, laboratory?: boolean | undefined, producer?: boolean | undefined, supplier?: boolean | undefined, signal?: AbortSignal): Promise<ContentResult> {
        let url_ = this.baseUrl + "/portal/locations/csv/{language}?";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        if (laboratory === null)
            throw new Error("The parameter 'laboratory' cannot be null.");
        else if (laboratory !== undefined)
            url_ += "laboratory=" + encodeURIComponent("" + laboratory) + "&";
        if (producer === null)
            throw new Error("The parameter 'producer' cannot be null.");
        else if (producer !== undefined)
            url_ += "producer=" + encodeURIComponent("" + producer) + "&";
        if (supplier === null)
            throw new Error("The parameter 'supplier' cannot be null.");
        else if (supplier !== undefined)
            url_ += "supplier=" + encodeURIComponent("" + supplier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/csv"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalLocationsCsv(_response);
        });
    }

    protected processListPortalLocationsCsv(response: AxiosResponse): Promise<ContentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ContentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentResult>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param laboratory (optional) 
     * @param producer (optional) 
     * @param supplier (optional) 
     * @param excludeByMonitoringGroupIds (optional) 
     * @param search (optional) 
     * @param orderBy (optional) 
     * @param orderByDesc (optional) 
     * @return Payload of ValuesDto containing LocationResponse
     */
    listPortalLocations(page?: number | undefined, pageSize?: number | undefined, laboratory?: boolean | undefined, producer?: boolean | undefined, supplier?: boolean | undefined, excludeByMonitoringGroupIds?: string | undefined, search?: string | undefined, orderBy?: string | undefined, orderByDesc?: string | undefined, signal?: AbortSignal): Promise<ValuesDto_locationResponse> {
        let url_ = this.baseUrl + "/portal/locations?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (laboratory === null)
            throw new Error("The parameter 'laboratory' cannot be null.");
        else if (laboratory !== undefined)
            url_ += "laboratory=" + encodeURIComponent("" + laboratory) + "&";
        if (producer === null)
            throw new Error("The parameter 'producer' cannot be null.");
        else if (producer !== undefined)
            url_ += "producer=" + encodeURIComponent("" + producer) + "&";
        if (supplier === null)
            throw new Error("The parameter 'supplier' cannot be null.");
        else if (supplier !== undefined)
            url_ += "supplier=" + encodeURIComponent("" + supplier) + "&";
        if (excludeByMonitoringGroupIds === null)
            throw new Error("The parameter 'excludeByMonitoringGroupIds' cannot be null.");
        else if (excludeByMonitoringGroupIds !== undefined)
            url_ += "excludeByMonitoringGroupIds=" + encodeURIComponent("" + excludeByMonitoringGroupIds) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDesc === null)
            throw new Error("The parameter 'orderByDesc' cannot be null.");
        else if (orderByDesc !== undefined)
            url_ += "orderByDesc=" + encodeURIComponent("" + orderByDesc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalLocations(_response);
        });
    }

    protected processListPortalLocations(response: AxiosResponse): Promise<ValuesDto_locationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_locationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_locationResponse>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing LocationResponse
     */
    listPortalSampleCopiedToLocations(sampleId: string, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_locationResponse> {
        let url_ = this.baseUrl + "/portal/samples/{sampleId}/copied-to-locations?";
        if (sampleId === undefined || sampleId === null)
            throw new Error("The parameter 'sampleId' must be defined.");
        url_ = url_.replace("{sampleId}", encodeURIComponent("" + sampleId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalSampleCopiedToLocations(_response);
        });
    }

    protected processListPortalSampleCopiedToLocations(response: AxiosResponse): Promise<ValuesDto_locationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_locationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_locationResponse>(null as any);
    }

    /**
     * @param search (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing LocationAutocompleteResponse
     */
    listPortalLocationsLaboratoriesAutocomplete(search?: string | undefined, limit?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_locationAutocompleteResponse> {
        let url_ = this.baseUrl + "/portal/locations/laboratories:autocomplete?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalLocationsLaboratoriesAutocomplete(_response);
        });
    }

    protected processListPortalLocationsLaboratoriesAutocomplete(response: AxiosResponse): Promise<ValuesDto_locationAutocompleteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_locationAutocompleteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_locationAutocompleteResponse>(null as any);
    }

    /**
     * @return CSV format
     */
    listPortalLocationsLaboratoriesCsv(language: string, signal?: AbortSignal): Promise<ContentResult> {
        let url_ = this.baseUrl + "/portal/locations/laboratories/csv/{language}";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/csv"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalLocationsLaboratoriesCsv(_response);
        });
    }

    protected processListPortalLocationsLaboratoriesCsv(response: AxiosResponse): Promise<ContentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ContentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentResult>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing LocationResponse
     */
    listPortalLocationsLaboratories(page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_locationResponse> {
        let url_ = this.baseUrl + "/portal/locations/laboratories?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalLocationsLaboratories(_response);
        });
    }

    protected processListPortalLocationsLaboratories(response: AxiosResponse): Promise<ValuesDto_locationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_locationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_locationResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Location
     * @return Payload of LocationResponse
     */
    readPortalLocationsLaboratory(id?: number | undefined, signal?: AbortSignal): Promise<LocationResponse> {
        let url_ = this.baseUrl + "/portal/locations/laboratories/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPortalLocationsLaboratory(_response);
        });
    }

    protected processReadPortalLocationsLaboratory(response: AxiosResponse): Promise<LocationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LocationResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationResponse>(null as any);
    }

    /**
     * @param search (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing LocationAutocompleteResponse
     */
    listPortalLocationsProducersAutocomplete(search?: string | undefined, limit?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_locationAutocompleteResponse> {
        let url_ = this.baseUrl + "/portal/locations/producers:autocomplete?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalLocationsProducersAutocomplete(_response);
        });
    }

    protected processListPortalLocationsProducersAutocomplete(response: AxiosResponse): Promise<ValuesDto_locationAutocompleteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_locationAutocompleteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_locationAutocompleteResponse>(null as any);
    }

    /**
     * @return CSV format
     */
    listPortalLocationsProducersCsv(language: string, signal?: AbortSignal): Promise<ContentResult> {
        let url_ = this.baseUrl + "/portal/locations/producers/csv/{language}";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/csv"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalLocationsProducersCsv(_response);
        });
    }

    protected processListPortalLocationsProducersCsv(response: AxiosResponse): Promise<ContentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ContentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentResult>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing LocationResponse
     */
    listPortalLocationsProducers(page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_locationResponse> {
        let url_ = this.baseUrl + "/portal/locations/producers?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalLocationsProducers(_response);
        });
    }

    protected processListPortalLocationsProducers(response: AxiosResponse): Promise<ValuesDto_locationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_locationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_locationResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Location
     * @return Payload of LocationResponse
     */
    readPortalLocationsProducer(id?: number | undefined, signal?: AbortSignal): Promise<LocationResponse> {
        let url_ = this.baseUrl + "/portal/locations/producers/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPortalLocationsProducer(_response);
        });
    }

    protected processReadPortalLocationsProducer(response: AxiosResponse): Promise<LocationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LocationResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationResponse>(null as any);
    }

    /**
     * @param search (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing LocationAutocompleteResponse
     */
    listPortalLocationsSuppliersAutocomplete(search?: string | undefined, limit?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_locationAutocompleteResponse> {
        let url_ = this.baseUrl + "/portal/locations/suppliers:autocomplete?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalLocationsSuppliersAutocomplete(_response);
        });
    }

    protected processListPortalLocationsSuppliersAutocomplete(response: AxiosResponse): Promise<ValuesDto_locationAutocompleteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_locationAutocompleteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_locationAutocompleteResponse>(null as any);
    }

    /**
     * @return CSV format
     */
    listPortalLocationsSuppliersCsv(language: string, signal?: AbortSignal): Promise<ContentResult> {
        let url_ = this.baseUrl + "/portal/locations/suppliers/csv/{language}";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/csv"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalLocationsSuppliersCsv(_response);
        });
    }

    protected processListPortalLocationsSuppliersCsv(response: AxiosResponse): Promise<ContentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ContentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentResult>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing LocationResponse
     */
    listPortalLocationsSuppliers(page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_locationResponse> {
        let url_ = this.baseUrl + "/portal/locations/suppliers?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalLocationsSuppliers(_response);
        });
    }

    protected processListPortalLocationsSuppliers(response: AxiosResponse): Promise<ValuesDto_locationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_locationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_locationResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Location
     * @return Payload of LocationResponse
     */
    readPortalLocationsSupplier(id?: number | undefined, signal?: AbortSignal): Promise<LocationResponse> {
        let url_ = this.baseUrl + "/portal/locations/suppliers/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPortalLocationsSupplier(_response);
        });
    }

    protected processReadPortalLocationsSupplier(response: AxiosResponse): Promise<LocationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LocationResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationResponse>(null as any);
    }

    /**
     * @param sampleId (optional) The sampleId of the Sample
     * @return Payload of AnalysisReportResponse
     */
    createAnalysisReport(body: CreateAnalysisReportRequest, sampleId?: string | undefined, signal?: AbortSignal): Promise<AnalysisReportResponse> {
        let url_ = this.baseUrl + "/portal/samples/{sampleId}/analysis-reports";
        if (sampleId !== null && sampleId !== undefined)
        url_ = url_.replace("{sampleId}", encodeURIComponent("" + sampleId));
        else
            url_ = url_.replace("/{sampleId}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAnalysisReport(_response);
        });
    }

    protected processCreateAnalysisReport(response: AxiosResponse): Promise<AnalysisReportResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AnalysisReportResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AnalysisReportResponse>(null as any);
    }

    /**
     * @param sampleId (optional) The sampleId of the Sample
     * @param id (optional) The id of the AnalysisReport
     * @return Payload of AnalysisReportResponse
     */
    updateAnalysisReport(body: UpdateAnalysisReportRequest, sampleId?: string | undefined, id?: string | undefined, signal?: AbortSignal): Promise<AnalysisReportResponse> {
        let url_ = this.baseUrl + "/portal/samples/{sampleId}/analysis-reports/{id}";
        if (sampleId !== null && sampleId !== undefined)
        url_ = url_.replace("{sampleId}", encodeURIComponent("" + sampleId));
        else
            url_ = url_.replace("/{sampleId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAnalysisReport(_response);
        });
    }

    protected processUpdateAnalysisReport(response: AxiosResponse): Promise<AnalysisReportResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AnalysisReportResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AnalysisReportResponse>(null as any);
    }

    /**
     * @param sampleId (optional) The sampleId of the Sample
     * @param id (optional) The id of the AnalysisReport
     */
    deleteAnalysisReport(sampleId?: string | undefined, id?: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/portal/samples/{sampleId}/analysis-reports/{id}";
        if (sampleId !== null && sampleId !== undefined)
        url_ = url_.replace("{sampleId}", encodeURIComponent("" + sampleId));
        else
            url_ = url_.replace("/{sampleId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAnalysisReport(_response);
        });
    }

    protected processDeleteAnalysisReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param sampleId (optional) The sampleId of the Sample
     * @param analysisReportId (optional) The analysisReportId of the AnalysisReport
     * @return Payload of AnalysisResultResponse
     */
    createAnalysisResult(body: CreateAnalysisResultRequest, sampleId?: string | undefined, analysisReportId?: string | undefined, signal?: AbortSignal): Promise<AnalysisResultResponse> {
        let url_ = this.baseUrl + "/portal/samples/{sampleId}/analysis-reports/{analysisReportId}/analysis-result";
        if (sampleId !== null && sampleId !== undefined)
        url_ = url_.replace("{sampleId}", encodeURIComponent("" + sampleId));
        else
            url_ = url_.replace("/{sampleId}", "");
        if (analysisReportId !== null && analysisReportId !== undefined)
        url_ = url_.replace("{analysisReportId}", encodeURIComponent("" + analysisReportId));
        else
            url_ = url_.replace("/{analysisReportId}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAnalysisResult(_response);
        });
    }

    protected processCreateAnalysisResult(response: AxiosResponse): Promise<AnalysisResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AnalysisResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AnalysisResultResponse>(null as any);
    }

    /**
     * @param sampleId (optional) The sampleId of the Sample
     * @param analysisReportId (optional) The analysisReportId of the AnalysisReport
     * @param id (optional) The id of the AnalysisResult
     * @return Payload of AnalysisResultResponse
     */
    updateAnalysisResult(body: UpdateAnalysisResultRequest, sampleId?: string | undefined, analysisReportId?: string | undefined, id?: string | undefined, signal?: AbortSignal): Promise<AnalysisResultResponse> {
        let url_ = this.baseUrl + "/portal/samples/{sampleId}/analysis-reports/{analysisReportId}/analysis-result/{id}";
        if (sampleId !== null && sampleId !== undefined)
        url_ = url_.replace("{sampleId}", encodeURIComponent("" + sampleId));
        else
            url_ = url_.replace("/{sampleId}", "");
        if (analysisReportId !== null && analysisReportId !== undefined)
        url_ = url_.replace("{analysisReportId}", encodeURIComponent("" + analysisReportId));
        else
            url_ = url_.replace("/{analysisReportId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAnalysisResult(_response);
        });
    }

    protected processUpdateAnalysisResult(response: AxiosResponse): Promise<AnalysisResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AnalysisResultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AnalysisResultResponse>(null as any);
    }

    /**
     * @param sampleId (optional) The sampleId of the Sample
     * @param analysisReportId (optional) The analysisReportId of the AnalysisReport
     * @param id (optional) The id of the AnalysisResult
     */
    deleteAnalysisResult(sampleId?: string | undefined, analysisReportId?: string | undefined, id?: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/portal/samples/{sampleId}/analysis-reports/{analysisReportId}/analysis-result/{id}";
        if (sampleId !== null && sampleId !== undefined)
        url_ = url_.replace("{sampleId}", encodeURIComponent("" + sampleId));
        else
            url_ = url_.replace("/{sampleId}", "");
        if (analysisReportId !== null && analysisReportId !== undefined)
        url_ = url_.replace("{analysisReportId}", encodeURIComponent("" + analysisReportId));
        else
            url_ = url_.replace("/{analysisReportId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAnalysisResult(_response);
        });
    }

    protected processDeleteAnalysisResult(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param search (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing AnalysisSetAutocompleteResponse
     */
    listPortalAnalysisSetsAutocomplete(locationId?: number | undefined, search?: string | undefined, limit?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_analysisSetAutocompleteResponse> {
        let url_ = this.baseUrl + "/portal/analysis-sets:autocomplete?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalAnalysisSetsAutocomplete(_response);
        });
    }

    protected processListPortalAnalysisSetsAutocomplete(response: AxiosResponse): Promise<ValuesDto_analysisSetAutocompleteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_analysisSetAutocompleteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_analysisSetAutocompleteResponse>(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing AnalysisSetResponse
     */
    listPortalAnalysisSets(locationId?: number | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_analysisSetResponse> {
        let url_ = this.baseUrl + "/portal/analysis-sets?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalAnalysisSets(_response);
        });
    }

    protected processListPortalAnalysisSets(response: AxiosResponse): Promise<ValuesDto_analysisSetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_analysisSetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_analysisSetResponse>(null as any);
    }

    /**
     * @return Payload of AnalysisSetResponse
     */
    createPortalAnalysisSet(body: CreateAnalysisSetRequest, signal?: AbortSignal): Promise<AnalysisSetResponse> {
        let url_ = this.baseUrl + "/portal/analysis-sets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePortalAnalysisSet(_response);
        });
    }

    protected processCreatePortalAnalysisSet(response: AxiosResponse): Promise<AnalysisSetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AnalysisSetResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AnalysisSetResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the AnalysisSet
     * @return Payload of AnalysisSetResponse
     */
    readPortalAnalysisSet(id?: number | undefined, signal?: AbortSignal): Promise<AnalysisSetResponse> {
        let url_ = this.baseUrl + "/portal/analysis-sets/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPortalAnalysisSet(_response);
        });
    }

    protected processReadPortalAnalysisSet(response: AxiosResponse): Promise<AnalysisSetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AnalysisSetResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AnalysisSetResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Unit
     * @return Payload of AnalysisSetResponse
     */
    updatePortalAnalysisSet(body: UpdateAnalysisSetRequest, id?: number | undefined, signal?: AbortSignal): Promise<AnalysisSetResponse> {
        let url_ = this.baseUrl + "/portal/analysis-sets/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePortalAnalysisSet(_response);
        });
    }

    protected processUpdatePortalAnalysisSet(response: AxiosResponse): Promise<AnalysisSetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AnalysisSetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AnalysisSetResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the AnalysisSet
     */
    deletePortalAnalysisSet(id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/portal/analysis-sets/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePortalAnalysisSet(_response);
        });
    }

    protected processDeletePortalAnalysisSet(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param status (optional) 
     * @param sampleType (optional) 
     * @param locationId (optional) 
     * @param productId (optional) 
     * @param own (optional) 
     * @param copied (optional) 
     * @param forCommunity (optional) 
     * @param group (optional) 
     * @param fromEdi (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param lastModifiedAtFrom (optional) 
     * @param lastModifiedAtTo (optional) 
     * @param search (optional) 
     * @param orderBy (optional) 
     * @param orderByDesc (optional) 
     * @return Payload of ValuesDto containing CombinedSampleResponse
     */
    listPortalCombinedSamples(page?: number | undefined, pageSize?: number | undefined, status?: string | undefined, sampleType?: string | undefined, locationId?: number | undefined, productId?: number | undefined, own?: boolean | undefined, copied?: boolean | undefined, forCommunity?: boolean | undefined, group?: boolean | undefined, fromEdi?: boolean | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, lastModifiedAtFrom?: Date | undefined, lastModifiedAtTo?: Date | undefined, search?: string | undefined, orderBy?: string | undefined, orderByDesc?: string | undefined, signal?: AbortSignal): Promise<ValuesDto_combinedSampleResponse> {
        let url_ = this.baseUrl + "/portal/combined-samples?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (sampleType === null)
            throw new Error("The parameter 'sampleType' cannot be null.");
        else if (sampleType !== undefined)
            url_ += "sampleType=" + encodeURIComponent("" + sampleType) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (own === null)
            throw new Error("The parameter 'own' cannot be null.");
        else if (own !== undefined)
            url_ += "own=" + encodeURIComponent("" + own) + "&";
        if (copied === null)
            throw new Error("The parameter 'copied' cannot be null.");
        else if (copied !== undefined)
            url_ += "copied=" + encodeURIComponent("" + copied) + "&";
        if (forCommunity === null)
            throw new Error("The parameter 'forCommunity' cannot be null.");
        else if (forCommunity !== undefined)
            url_ += "forCommunity=" + encodeURIComponent("" + forCommunity) + "&";
        if (group === null)
            throw new Error("The parameter 'group' cannot be null.");
        else if (group !== undefined)
            url_ += "group=" + encodeURIComponent("" + group) + "&";
        if (fromEdi === null)
            throw new Error("The parameter 'fromEdi' cannot be null.");
        else if (fromEdi !== undefined)
            url_ += "fromEdi=" + encodeURIComponent("" + fromEdi) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (lastModifiedAtFrom === null)
            throw new Error("The parameter 'lastModifiedAtFrom' cannot be null.");
        else if (lastModifiedAtFrom !== undefined)
            url_ += "lastModifiedAtFrom=" + encodeURIComponent(lastModifiedAtFrom ? "" + lastModifiedAtFrom.toISOString() : "") + "&";
        if (lastModifiedAtTo === null)
            throw new Error("The parameter 'lastModifiedAtTo' cannot be null.");
        else if (lastModifiedAtTo !== undefined)
            url_ += "lastModifiedAtTo=" + encodeURIComponent(lastModifiedAtTo ? "" + lastModifiedAtTo.toISOString() : "") + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDesc === null)
            throw new Error("The parameter 'orderByDesc' cannot be null.");
        else if (orderByDesc !== undefined)
            url_ += "orderByDesc=" + encodeURIComponent("" + orderByDesc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalCombinedSamples(_response);
        });
    }

    protected processListPortalCombinedSamples(response: AxiosResponse): Promise<ValuesDto_combinedSampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_combinedSampleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_combinedSampleResponse>(null as any);
    }

    /**
     * @param status (optional) 
     * @param sampleType (optional) 
     * @param locationId (optional) 
     * @param productId (optional) 
     * @param own (optional) 
     * @param copied (optional) 
     * @param forCommunity (optional) 
     * @param group (optional) 
     * @param fromEdi (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param lastModifiedAtFrom (optional) 
     * @param lastModifiedAtTo (optional) 
     * @param search (optional) 
     * @param orderBy (optional) 
     * @param orderByDesc (optional) 
     * @return CSV format
     */
    listPortalCombinedSamplesCsv(language: string, status?: string | undefined, sampleType?: string | undefined, locationId?: number | undefined, productId?: number | undefined, own?: boolean | undefined, copied?: boolean | undefined, forCommunity?: boolean | undefined, group?: boolean | undefined, fromEdi?: boolean | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, lastModifiedAtFrom?: Date | undefined, lastModifiedAtTo?: Date | undefined, search?: string | undefined, orderBy?: string | undefined, orderByDesc?: string | undefined, signal?: AbortSignal): Promise<ContentResult> {
        let url_ = this.baseUrl + "/portal/my-monitoring/csv/{language}?";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (sampleType === null)
            throw new Error("The parameter 'sampleType' cannot be null.");
        else if (sampleType !== undefined)
            url_ += "sampleType=" + encodeURIComponent("" + sampleType) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (own === null)
            throw new Error("The parameter 'own' cannot be null.");
        else if (own !== undefined)
            url_ += "own=" + encodeURIComponent("" + own) + "&";
        if (copied === null)
            throw new Error("The parameter 'copied' cannot be null.");
        else if (copied !== undefined)
            url_ += "copied=" + encodeURIComponent("" + copied) + "&";
        if (forCommunity === null)
            throw new Error("The parameter 'forCommunity' cannot be null.");
        else if (forCommunity !== undefined)
            url_ += "forCommunity=" + encodeURIComponent("" + forCommunity) + "&";
        if (group === null)
            throw new Error("The parameter 'group' cannot be null.");
        else if (group !== undefined)
            url_ += "group=" + encodeURIComponent("" + group) + "&";
        if (fromEdi === null)
            throw new Error("The parameter 'fromEdi' cannot be null.");
        else if (fromEdi !== undefined)
            url_ += "fromEdi=" + encodeURIComponent("" + fromEdi) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (lastModifiedAtFrom === null)
            throw new Error("The parameter 'lastModifiedAtFrom' cannot be null.");
        else if (lastModifiedAtFrom !== undefined)
            url_ += "lastModifiedAtFrom=" + encodeURIComponent(lastModifiedAtFrom ? "" + lastModifiedAtFrom.toISOString() : "") + "&";
        if (lastModifiedAtTo === null)
            throw new Error("The parameter 'lastModifiedAtTo' cannot be null.");
        else if (lastModifiedAtTo !== undefined)
            url_ += "lastModifiedAtTo=" + encodeURIComponent(lastModifiedAtTo ? "" + lastModifiedAtTo.toISOString() : "") + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDesc === null)
            throw new Error("The parameter 'orderByDesc' cannot be null.");
        else if (orderByDesc !== undefined)
            url_ += "orderByDesc=" + encodeURIComponent("" + orderByDesc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/csv"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalCombinedSamplesCsv(_response);
        });
    }

    protected processListPortalCombinedSamplesCsv(response: AxiosResponse): Promise<ContentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ContentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentResult>(null as any);
    }

    /**
     * @param id (optional) The id of the CopiedSample
     * @return Payload of CopiedSampleResponse
     */
    readPortalCopiedSample(id?: string | undefined, signal?: AbortSignal): Promise<CopiedSampleResponse> {
        let url_ = this.baseUrl + "/portal/copied-samples/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPortalCopiedSample(_response);
        });
    }

    protected processReadPortalCopiedSample(response: AxiosResponse): Promise<CopiedSampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CopiedSampleResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CopiedSampleResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Unit
     * @return Payload of CopiedSampleResponse
     */
    updatePortalCopiedSample(body: UpdateCopiedSampleRequest, id?: string | undefined, signal?: AbortSignal): Promise<CopiedSampleResponse> {
        let url_ = this.baseUrl + "/portal/copied-samples/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePortalCopiedSample(_response);
        });
    }

    protected processUpdatePortalCopiedSample(response: AxiosResponse): Promise<CopiedSampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CopiedSampleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CopiedSampleResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the CopiedSample
     */
    deletePortalCopiedSample(id?: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/portal/copied-samples/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePortalCopiedSample(_response);
        });
    }

    protected processDeletePortalCopiedSample(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Payload of CopiedSampleResponse
     */
    createPortalCopiedSample(body: CreateCopiedSampleRequest, signal?: AbortSignal): Promise<CopiedSampleResponse> {
        let url_ = this.baseUrl + "/portal/copied-samples";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePortalCopiedSample(_response);
        });
    }

    protected processCreatePortalCopiedSample(response: AxiosResponse): Promise<CopiedSampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CopiedSampleResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CopiedSampleResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the CopiedSample
     * @return Payload of CopiedSampleResponse
     */
    finalisePortalSample(id?: string | undefined, signal?: AbortSignal): Promise<CopiedSampleResponse> {
        let url_ = this.baseUrl + "/portal/copied-samples/{id}/finalise";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFinalisePortalSample(_response);
        });
    }

    protected processFinalisePortalSample(response: AxiosResponse): Promise<CopiedSampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CopiedSampleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CopiedSampleResponse>(null as any);
    }

    /**
     * @return Payload of ValuesDto containing CountryResponse
     */
    listPortalCountries(signal?: AbortSignal): Promise<ValuesDto_countryResponse> {
        let url_ = this.baseUrl + "/portal/countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalCountries(_response);
        });
    }

    protected processListPortalCountries(response: AxiosResponse): Promise<ValuesDto_countryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_countryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_countryResponse>(null as any);
    }

    /**
     * @param search (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing CountryAutocompleteResponse
     */
    listPortalCountriesAutocomplete(search?: string | undefined, limit?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_countryAutocompleteResponse> {
        let url_ = this.baseUrl + "/portal/countries:autocomplete?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalCountriesAutocomplete(_response);
        });
    }

    protected processListPortalCountriesAutocomplete(response: AxiosResponse): Promise<ValuesDto_countryAutocompleteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_countryAutocompleteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_countryAutocompleteResponse>(null as any);
    }

    /**
     * @return CSV format
     */
    listPortalCountriesCsv(language: string, signal?: AbortSignal): Promise<ContentResult> {
        let url_ = this.baseUrl + "/portal/countries/csv/{language}";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/csv"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalCountriesCsv(_response);
        });
    }

    protected processListPortalCountriesCsv(response: AxiosResponse): Promise<ContentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ContentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentResult>(null as any);
    }

    /**
     * @param id (optional) The id of the Country
     * @return Payload of CountryResponse
     */
    readPortalCountry(id?: number | undefined, signal?: AbortSignal): Promise<CountryResponse> {
        let url_ = this.baseUrl + "/portal/countries/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPortalCountry(_response);
        });
    }

    protected processReadPortalCountry(response: AxiosResponse): Promise<CountryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountryResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountryResponse>(null as any);
    }

    readPortalDocumentsFile(file?: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/portal/download/documents/{*file}";
        if (file !== null && file !== undefined)
        url_ = url_.replace("{file}", encodeURIComponent("" + file));
        else
            url_ = url_.replace("/{file}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPortalDocumentsFile(_response);
        });
    }

    protected processReadPortalDocumentsFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    readPortalIncomingSamplesFile(file?: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/portal/download/incoming-samples/{*file}";
        if (file !== null && file !== undefined)
        url_ = url_.replace("{file}", encodeURIComponent("" + file));
        else
            url_ = url_.replace("/{file}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPortalIncomingSamplesFile(_response);
        });
    }

    protected processReadPortalIncomingSamplesFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param monitoringGroupId (optional) 
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing LocationsMonitoringGroupResponse
     */
    listPortalLocationsMonitoringGroups(locationId?: number | undefined, monitoringGroupId?: number | undefined, search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_locationsMonitoringGroupResponse> {
        let url_ = this.baseUrl + "/portal/locations-monitoring-groups?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (monitoringGroupId === null)
            throw new Error("The parameter 'monitoringGroupId' cannot be null.");
        else if (monitoringGroupId !== undefined)
            url_ += "monitoringGroupId=" + encodeURIComponent("" + monitoringGroupId) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalLocationsMonitoringGroups(_response);
        });
    }

    protected processListPortalLocationsMonitoringGroups(response: AxiosResponse): Promise<ValuesDto_locationsMonitoringGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_locationsMonitoringGroupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_locationsMonitoringGroupResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Unit
     * @return Payload of LocationsMonitoringGroupResponse
     */
    updateLocationsMonitoringGroup(body: UpdateStatusLocationsMonitoringGroupRequest, id?: number | undefined, signal?: AbortSignal): Promise<LocationsMonitoringGroupResponse> {
        let url_ = this.baseUrl + "/portal/locations-monitoring-groups/{id}/status";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLocationsMonitoringGroup(_response);
        });
    }

    protected processUpdateLocationsMonitoringGroup(response: AxiosResponse): Promise<LocationsMonitoringGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LocationsMonitoringGroupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationsMonitoringGroupResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Unit
     * @return Payload of LocationsMonitoringGroupResponse
     */
    updateLocationsMonitoringGroup2(body: UpdateAutoInsertLocationsMonitoringGroupRequest, id?: number | undefined, signal?: AbortSignal): Promise<LocationsMonitoringGroupResponse> {
        let url_ = this.baseUrl + "/portal/locations-monitoring-groups/{id}/auto-insert";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLocationsMonitoringGroup2(_response);
        });
    }

    protected processUpdateLocationsMonitoringGroup2(response: AxiosResponse): Promise<LocationsMonitoringGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LocationsMonitoringGroupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationsMonitoringGroupResponse>(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing MonitoringGroupResponse
     */
    listPortalMonitoringGroups(locationId?: number | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_monitoringGroupResponse> {
        let url_ = this.baseUrl + "/portal/monitoring-groups?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalMonitoringGroups(_response);
        });
    }

    protected processListPortalMonitoringGroups(response: AxiosResponse): Promise<ValuesDto_monitoringGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_monitoringGroupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_monitoringGroupResponse>(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing MyProductResponse
     */
    listPortalMyProducts(locationId?: number | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_myProductResponse> {
        let url_ = this.baseUrl + "/portal/my-products?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalMyProducts(_response);
        });
    }

    protected processListPortalMyProducts(response: AxiosResponse): Promise<ValuesDto_myProductResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_myProductResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_myProductResponse>(null as any);
    }

    /**
     * @return Payload of MyProductResponse
     */
    createPortalMyProduct(body: CreateMyProductRequest, signal?: AbortSignal): Promise<MyProductResponse> {
        let url_ = this.baseUrl + "/portal/my-products";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePortalMyProduct(_response);
        });
    }

    protected processCreatePortalMyProduct(response: AxiosResponse): Promise<MyProductResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MyProductResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MyProductResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the MyProduct
     * @return Payload of MyProductResponse
     */
    readPortalMyProduct(id?: number | undefined, signal?: AbortSignal): Promise<MyProductResponse> {
        let url_ = this.baseUrl + "/portal/my-products/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPortalMyProduct(_response);
        });
    }

    protected processReadPortalMyProduct(response: AxiosResponse): Promise<MyProductResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MyProductResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MyProductResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Unit
     * @return Payload of MyProductResponse
     */
    updatePortalMyProduct(body: UpdateMyProductRequest, id?: number | undefined, signal?: AbortSignal): Promise<MyProductResponse> {
        let url_ = this.baseUrl + "/portal/my-products/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePortalMyProduct(_response);
        });
    }

    protected processUpdatePortalMyProduct(response: AxiosResponse): Promise<MyProductResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MyProductResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MyProductResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the MyProduct
     */
    deletePortalMyProduct(id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/portal/my-products/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePortalMyProduct(_response);
        });
    }

    protected processDeletePortalMyProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing PlannedSampleResponse
     */
    listPortalPlannedSamples(page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_plannedSampleResponse> {
        let url_ = this.baseUrl + "/portal/planned-samples?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalPlannedSamples(_response);
        });
    }

    protected processListPortalPlannedSamples(response: AxiosResponse): Promise<ValuesDto_plannedSampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_plannedSampleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_plannedSampleResponse>(null as any);
    }

    /**
     * @return Payload of PlannedSampleResponse
     */
    createPortalPlannedSample(body: CreatePlannedSampleRequest, signal?: AbortSignal): Promise<PlannedSampleResponse> {
        let url_ = this.baseUrl + "/portal/planned-samples";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePortalPlannedSample(_response);
        });
    }

    protected processCreatePortalPlannedSample(response: AxiosResponse): Promise<PlannedSampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PlannedSampleResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlannedSampleResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the PlannedSample
     * @return Payload of PlannedSampleResponse
     */
    readPortalPlannedSample(id?: string | undefined, signal?: AbortSignal): Promise<PlannedSampleResponse> {
        let url_ = this.baseUrl + "/portal/planned-samples/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPortalPlannedSample(_response);
        });
    }

    protected processReadPortalPlannedSample(response: AxiosResponse): Promise<PlannedSampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PlannedSampleResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlannedSampleResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Unit
     * @return Payload of PlannedSampleResponse
     */
    updatePortalPlannedSample(body: UpdatePlannedSampleRequest, id?: string | undefined, signal?: AbortSignal): Promise<PlannedSampleResponse> {
        let url_ = this.baseUrl + "/portal/planned-samples/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePortalPlannedSample(_response);
        });
    }

    protected processUpdatePortalPlannedSample(response: AxiosResponse): Promise<PlannedSampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PlannedSampleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlannedSampleResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the PlannedSample
     */
    deletePortalPlannedSample(id?: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/portal/planned-samples/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePortalPlannedSample(_response);
        });
    }

    protected processDeletePortalPlannedSample(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @param factsheetIncluded (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing ProcessingAidAutocompleteResponse
     */
    listPortalProcessingAidsAutocomplete(page?: number | undefined, pageSize?: number | undefined, search?: string | undefined, factsheetIncluded?: boolean | undefined, limit?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_processingAidAutocompleteResponse> {
        let url_ = this.baseUrl + "/portal/processing-aids:autocomplete?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (factsheetIncluded === null)
            throw new Error("The parameter 'factsheetIncluded' cannot be null.");
        else if (factsheetIncluded !== undefined)
            url_ += "factsheetIncluded=" + encodeURIComponent("" + factsheetIncluded) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalProcessingAidsAutocomplete(_response);
        });
    }

    protected processListPortalProcessingAidsAutocomplete(response: AxiosResponse): Promise<ValuesDto_processingAidAutocompleteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_processingAidAutocompleteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_processingAidAutocompleteResponse>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @param factsheetIncluded (optional) 
     * @return Payload of ValuesDto containing ProcessingAidResponse
     */
    listPortalProcessingAids(page?: number | undefined, pageSize?: number | undefined, search?: string | undefined, factsheetIncluded?: boolean | undefined, signal?: AbortSignal): Promise<ValuesDto_processingAidResponse> {
        let url_ = this.baseUrl + "/portal/processing-aids?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (factsheetIncluded === null)
            throw new Error("The parameter 'factsheetIncluded' cannot be null.");
        else if (factsheetIncluded !== undefined)
            url_ += "factsheetIncluded=" + encodeURIComponent("" + factsheetIncluded) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalProcessingAids(_response);
        });
    }

    protected processListPortalProcessingAids(response: AxiosResponse): Promise<ValuesDto_processingAidResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_processingAidResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_processingAidResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the ProcessingAid
     * @return Payload of ProcessingAidResponse
     */
    readPortalProcessingAid(id?: number | undefined, signal?: AbortSignal): Promise<ProcessingAidResponse> {
        let url_ = this.baseUrl + "/portal/processing-aids/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPortalProcessingAid(_response);
        });
    }

    protected processReadPortalProcessingAid(response: AxiosResponse): Promise<ProcessingAidResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProcessingAidResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessingAidResponse>(null as any);
    }

    /**
     * @param path (optional) 
     * @return Returns JSON response
     */
    readPortalProxyRequest(path?: string | undefined, signal?: AbortSignal): Promise<any> {
        let url_ = this.baseUrl + "/portal/proxy/stipp/{*path}";
        if (path !== null && path !== undefined)
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        else
            url_ = url_.replace("/{path}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPortalProxyRequest(_response);
        });
    }

    protected processReadPortalProxyRequest(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<any>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param language (optional) 
     * @return Returns JSON response
     */
    readPortalSchemaDocumentsStructured(language?: string | undefined, signal?: AbortSignal): Promise<any> {
        let url_ = this.baseUrl + "/portal/proxy/stipp/GetSchemaDocumentsStructured/{language}";
        if (language !== null && language !== undefined)
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        else
            url_ = url_.replace("/{language}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPortalSchemaDocumentsStructured(_response);
        });
    }

    protected processReadPortalSchemaDocumentsStructured(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<any>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param language (optional) 
     * @return Returns JSON response
     */
    readPortalSchemaDocuments(language?: string | undefined, signal?: AbortSignal): Promise<any> {
        let url_ = this.baseUrl + "/portal/proxy/stipp/GetSchemaDocuments/{language}";
        if (language !== null && language !== undefined)
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        else
            url_ = url_.replace("/{language}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPortalSchemaDocuments(_response);
        });
    }

    protected processReadPortalSchemaDocuments(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<any>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Returns JSON response
     */
    readPortalSchemaDocument(id?: string | undefined, signal?: AbortSignal): Promise<any> {
        let url_ = this.baseUrl + "/portal/proxy/stipp/GetSchemaDocument/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPortalSchemaDocument(_response);
        });
    }

    protected processReadPortalSchemaDocument(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<any>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param id (optional) 
     * @param language (optional) 
     * @return Returns JSON response
     */
    readPortalSchemaDocumentVersionsDiff(id?: string | undefined, language?: string | undefined, signal?: AbortSignal): Promise<any> {
        let url_ = this.baseUrl + "/portal/proxy/stipp/GetSchemaDocumentVersionsDiff/{id}/{language}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        if (language !== null && language !== undefined)
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        else
            url_ = url_.replace("/{language}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPortalSchemaDocumentVersionsDiff(_response);
        });
    }

    protected processReadPortalSchemaDocumentVersionsDiff(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<any>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param sampleId (optional) 
     * @return Payload of ValuesDto containing MonitoringGroupResponse
     */
    listPortalSampleMonitoringGroups(sampleId?: string | undefined, signal?: AbortSignal): Promise<ValuesDto_monitoringGroupResponse> {
        let url_ = this.baseUrl + "/portal/samples/{sampleId}/monitoring-groups";
        if (sampleId !== null && sampleId !== undefined)
        url_ = url_.replace("{sampleId}", encodeURIComponent("" + sampleId));
        else
            url_ = url_.replace("/{sampleId}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalSampleMonitoringGroups(_response);
        });
    }

    protected processListPortalSampleMonitoringGroups(response: AxiosResponse): Promise<ValuesDto_monitoringGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_monitoringGroupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_monitoringGroupResponse>(null as any);
    }

    /**
     * @param search (optional) 
     * @param locationId (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing SampleAutocompleteResponse
     */
    listPortalSamplesAutocomplete(search?: string | undefined, locationId?: number | undefined, limit?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_sampleAutocompleteResponse> {
        let url_ = this.baseUrl + "/portal/samples:autocomplete?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalSamplesAutocomplete(_response);
        });
    }

    protected processListPortalSamplesAutocomplete(response: AxiosResponse): Promise<ValuesDto_sampleAutocompleteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_sampleAutocompleteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_sampleAutocompleteResponse>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param registrationNumber (optional) 
     * @param own (optional) 
     * @param copied (optional) 
     * @param fromEdi (optional) 
     * @return Payload of ValuesDto containing SampleResponse
     */
    listPortalSamples(page?: number | undefined, pageSize?: number | undefined, registrationNumber?: string | undefined, own?: boolean | undefined, copied?: boolean | undefined, fromEdi?: boolean | undefined, signal?: AbortSignal): Promise<ValuesDto_sampleResponse> {
        let url_ = this.baseUrl + "/portal/samples?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (registrationNumber === null)
            throw new Error("The parameter 'registrationNumber' cannot be null.");
        else if (registrationNumber !== undefined)
            url_ += "registrationNumber=" + encodeURIComponent("" + registrationNumber) + "&";
        if (own === null)
            throw new Error("The parameter 'own' cannot be null.");
        else if (own !== undefined)
            url_ += "own=" + encodeURIComponent("" + own) + "&";
        if (copied === null)
            throw new Error("The parameter 'copied' cannot be null.");
        else if (copied !== undefined)
            url_ += "copied=" + encodeURIComponent("" + copied) + "&";
        if (fromEdi === null)
            throw new Error("The parameter 'fromEdi' cannot be null.");
        else if (fromEdi !== undefined)
            url_ += "fromEdi=" + encodeURIComponent("" + fromEdi) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalSamples(_response);
        });
    }

    protected processListPortalSamples(response: AxiosResponse): Promise<ValuesDto_sampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_sampleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_sampleResponse>(null as any);
    }

    /**
     * @return Payload of SampleResponse
     */
    createPortalSample(body: CreateSampleRequest, signal?: AbortSignal): Promise<SampleResponse> {
        let url_ = this.baseUrl + "/portal/samples";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePortalSample(_response);
        });
    }

    protected processCreatePortalSample(response: AxiosResponse): Promise<SampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SampleResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SampleResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Sample
     * @return Payload of SampleResponse
     */
    readPortalSample(id?: string | undefined, signal?: AbortSignal): Promise<SampleResponse> {
        let url_ = this.baseUrl + "/portal/samples/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPortalSample(_response);
        });
    }

    protected processReadPortalSample(response: AxiosResponse): Promise<SampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SampleResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SampleResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Unit
     * @return Payload of SampleResponse
     */
    updatePortalSample(body: UpdateSampleRequest, id?: string | undefined, signal?: AbortSignal): Promise<SampleResponse> {
        let url_ = this.baseUrl + "/portal/samples/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePortalSample(_response);
        });
    }

    protected processUpdatePortalSample(response: AxiosResponse): Promise<SampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SampleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SampleResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Sample
     */
    deletePortalSample(id?: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/portal/samples/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePortalSample(_response);
        });
    }

    protected processDeletePortalSample(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) The id of the Unit
     * @return Payload of SampleResponse
     */
    updateWithForCommunityPortalSample(body: UpdateSampleRequest, id?: string | undefined, signal?: AbortSignal): Promise<SampleResponse> {
        let url_ = this.baseUrl + "/portal/samples/{id}/for-community";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateWithForCommunityPortalSample(_response);
        });
    }

    protected processUpdateWithForCommunityPortalSample(response: AxiosResponse): Promise<SampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SampleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SampleResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Sample
     * @return Payload of SampleResponse
     */
    finalisePortalSample2(id?: string | undefined, signal?: AbortSignal): Promise<SampleResponse> {
        let url_ = this.baseUrl + "/portal/samples/{id}/finalise";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFinalisePortalSample2(_response);
        });
    }

    protected processFinalisePortalSample2(response: AxiosResponse): Promise<SampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SampleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SampleResponse>(null as any);
    }

    /**
     * @return Payload of SampleResponse
     */
    batchFinalisePortalSamples(signal?: AbortSignal): Promise<SampleResponse> {
        let url_ = this.baseUrl + "/portal/samples/finalise";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchFinalisePortalSamples(_response);
        });
    }

    protected processBatchFinalisePortalSamples(response: AxiosResponse): Promise<SampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SampleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SampleResponse>(null as any);
    }

    /**
     * @param processingAidGroupId (optional) 
     * @param language (optional) 
     * @param path (optional) 
     * @return Payload of ProcessingAidGroupsFactsheetFileReferenceResponse
     */
    createProcessingAidGroupsFactsheetFileReference(processingAidGroupId?: number | undefined, language?: string | undefined, path?: string | undefined, signal?: AbortSignal): Promise<ProcessingAidGroupsFactsheetFileReferenceResponse> {
        let url_ = this.baseUrl + "/processing-aid-groups/{processingAidGroupId}/factsheet-file-references";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (processingAidGroupId === null || processingAidGroupId === undefined)
            throw new Error("The parameter 'processingAidGroupId' cannot be null.");
        else
            content_.append("processingAidGroupId", processingAidGroupId.toString());
        if (language === null || language === undefined)
            throw new Error("The parameter 'language' cannot be null.");
        else
            content_.append("language", language.toString());
        if (path === null || path === undefined)
            throw new Error("The parameter 'path' cannot be null.");
        else
            content_.append("path", path.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProcessingAidGroupsFactsheetFileReference(_response);
        });
    }

    protected processCreateProcessingAidGroupsFactsheetFileReference(response: AxiosResponse): Promise<ProcessingAidGroupsFactsheetFileReferenceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProcessingAidGroupsFactsheetFileReferenceResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessingAidGroupsFactsheetFileReferenceResponse>(null as any);
    }

    /**
     * @param processingAidGroupId (optional) The processingAidGroupId of the ProcessingAidGroup
     * @param id (optional) The id of the ProcessingAidGroupsFactsheetFileReference
     * @return Payload of ProcessingAidGroupsFactsheetFileReferenceResponse
     */
    updateProcessingAidGroupsFactsheetFileReference(body: UpdateProcessingAidGroupsFactsheetFileReferenceRequest, processingAidGroupId?: number | undefined, id?: number | undefined, signal?: AbortSignal): Promise<ProcessingAidGroupsFactsheetFileReferenceResponse> {
        let url_ = this.baseUrl + "/processing-aid-groups/{processingAidGroupId}/factsheet-file-references/{id}";
        if (processingAidGroupId !== null && processingAidGroupId !== undefined)
        url_ = url_.replace("{processingAidGroupId}", encodeURIComponent("" + processingAidGroupId));
        else
            url_ = url_.replace("/{processingAidGroupId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProcessingAidGroupsFactsheetFileReference(_response);
        });
    }

    protected processUpdateProcessingAidGroupsFactsheetFileReference(response: AxiosResponse): Promise<ProcessingAidGroupsFactsheetFileReferenceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProcessingAidGroupsFactsheetFileReferenceResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessingAidGroupsFactsheetFileReferenceResponse>(null as any);
    }

    /**
     * @param processingAidGroupId (optional) The processingAidGroupId of the ProcessingAidGroup
     * @param id (optional) The id of the ProcessingAidGroupsFactsheetFileReference
     */
    deleteProcessingAidGroupsFactsheetFileReference(processingAidGroupId?: number | undefined, id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/processing-aid-groups/{processingAidGroupId}/factsheet-file-references/{id}";
        if (processingAidGroupId !== null && processingAidGroupId !== undefined)
        url_ = url_.replace("{processingAidGroupId}", encodeURIComponent("" + processingAidGroupId));
        else
            url_ = url_.replace("/{processingAidGroupId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProcessingAidGroupsFactsheetFileReference(_response);
        });
    }

    protected processDeleteProcessingAidGroupsFactsheetFileReference(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param search (optional) 
     * @param factsheetIncluded (optional) 
     * @return Payload of ValuesDto containing ProcessingAidGroupResponse
     */
    listProcessingAidGroups(search?: string | undefined, factsheetIncluded?: boolean | undefined, signal?: AbortSignal): Promise<ValuesDto_processingAidGroupResponse> {
        let url_ = this.baseUrl + "/processing-aid-groups?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (factsheetIncluded === null)
            throw new Error("The parameter 'factsheetIncluded' cannot be null.");
        else if (factsheetIncluded !== undefined)
            url_ += "factsheetIncluded=" + encodeURIComponent("" + factsheetIncluded) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListProcessingAidGroups(_response);
        });
    }

    protected processListProcessingAidGroups(response: AxiosResponse): Promise<ValuesDto_processingAidGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_processingAidGroupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_processingAidGroupResponse>(null as any);
    }

    /**
     * @return Payload of ProcessingAidGroupResponse
     */
    createProcessingAidGroup(body: CreateProcessingAidGroupRequest, signal?: AbortSignal): Promise<ProcessingAidGroupResponse> {
        let url_ = this.baseUrl + "/processing-aid-groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProcessingAidGroup(_response);
        });
    }

    protected processCreateProcessingAidGroup(response: AxiosResponse): Promise<ProcessingAidGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProcessingAidGroupResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessingAidGroupResponse>(null as any);
    }

    /**
     * @return CSV format
     */
    listProcessingAidGroupsCsv(language: string, signal?: AbortSignal): Promise<ContentResult> {
        let url_ = this.baseUrl + "/processing-aid-groups/csv/{language}";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/csv"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListProcessingAidGroupsCsv(_response);
        });
    }

    protected processListProcessingAidGroupsCsv(response: AxiosResponse): Promise<ContentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ContentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentResult>(null as any);
    }

    /**
     * @param id (optional) The id of the ProcessingAidGroup
     * @return Payload of ProcessingAidGroupResponse
     */
    readProcessingAidGroup(id?: number | undefined, signal?: AbortSignal): Promise<ProcessingAidGroupResponse> {
        let url_ = this.baseUrl + "/processing-aid-groups/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadProcessingAidGroup(_response);
        });
    }

    protected processReadProcessingAidGroup(response: AxiosResponse): Promise<ProcessingAidGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProcessingAidGroupResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessingAidGroupResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Unit
     * @return Payload of ProcessingAidGroupResponse
     */
    updateProcessingAidGroup(body: UpdateProcessingAidGroupRequest, id?: number | undefined, signal?: AbortSignal): Promise<ProcessingAidGroupResponse> {
        let url_ = this.baseUrl + "/processing-aid-groups/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProcessingAidGroup(_response);
        });
    }

    protected processUpdateProcessingAidGroup(response: AxiosResponse): Promise<ProcessingAidGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProcessingAidGroupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessingAidGroupResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the ProcessingAidGroup
     */
    deleteProcessingAidGroup(id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/processing-aid-groups/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProcessingAidGroup(_response);
        });
    }

    protected processDeleteProcessingAidGroup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param search (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing ProcessingAidAutocompleteResponse
     */
    listProcessingAidsAutocomplete(search?: string | undefined, limit?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_processingAidAutocompleteResponse> {
        let url_ = this.baseUrl + "/processing-aids:autocomplete?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListProcessingAidsAutocomplete(_response);
        });
    }

    protected processListProcessingAidsAutocomplete(response: AxiosResponse): Promise<ValuesDto_processingAidAutocompleteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_processingAidAutocompleteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_processingAidAutocompleteResponse>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @param factsheetIncluded (optional) 
     * @return Payload of ValuesDto containing ProcessingAidResponse
     */
    listProcessingAids(page?: number | undefined, pageSize?: number | undefined, search?: string | undefined, factsheetIncluded?: boolean | undefined, signal?: AbortSignal): Promise<ValuesDto_processingAidResponse> {
        let url_ = this.baseUrl + "/processing-aids?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (factsheetIncluded === null)
            throw new Error("The parameter 'factsheetIncluded' cannot be null.");
        else if (factsheetIncluded !== undefined)
            url_ += "factsheetIncluded=" + encodeURIComponent("" + factsheetIncluded) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListProcessingAids(_response);
        });
    }

    protected processListProcessingAids(response: AxiosResponse): Promise<ValuesDto_processingAidResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_processingAidResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_processingAidResponse>(null as any);
    }

    /**
     * @return Payload of ProcessingAidResponse
     */
    createProcessingAid(body: CreateProcessingAidRequest, signal?: AbortSignal): Promise<ProcessingAidResponse> {
        let url_ = this.baseUrl + "/processing-aids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProcessingAid(_response);
        });
    }

    protected processCreateProcessingAid(response: AxiosResponse): Promise<ProcessingAidResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProcessingAidResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessingAidResponse>(null as any);
    }

    /**
     * @param language (optional) 
     * @return CSV format
     */
    listProcessingAidsCsv(language?: string | undefined, signal?: AbortSignal): Promise<ContentResult> {
        let url_ = this.baseUrl + "/processing-aids/csv/{language}";
        if (language !== null && language !== undefined)
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        else
            url_ = url_.replace("/{language}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/csv"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListProcessingAidsCsv(_response);
        });
    }

    protected processListProcessingAidsCsv(response: AxiosResponse): Promise<ContentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ContentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentResult>(null as any);
    }

    /**
     * @param id (optional) The id of the ProcessingAid
     * @return Payload of ProcessingAidResponse
     */
    readProcessingAid(id?: number | undefined, signal?: AbortSignal): Promise<ProcessingAidResponse> {
        let url_ = this.baseUrl + "/processing-aids/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadProcessingAid(_response);
        });
    }

    protected processReadProcessingAid(response: AxiosResponse): Promise<ProcessingAidResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProcessingAidResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessingAidResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Unit
     * @return Payload of ProcessingAidResponse
     */
    updateProcessingAid(body: UpdateProcessingAidRequest, id?: number | undefined, signal?: AbortSignal): Promise<ProcessingAidResponse> {
        let url_ = this.baseUrl + "/processing-aids/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProcessingAid(_response);
        });
    }

    protected processUpdateProcessingAid(response: AxiosResponse): Promise<ProcessingAidResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProcessingAidResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessingAidResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the ProcessingAid
     */
    deleteProcessingAid(id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/processing-aids/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProcessingAid(_response);
        });
    }

    protected processDeleteProcessingAid(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Payload of ValuesDto containing ProcessStepGroupResponse
     */
    listProcessStepGroups(signal?: AbortSignal): Promise<ValuesDto_processStepGroupResponse> {
        let url_ = this.baseUrl + "/process-step-groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListProcessStepGroups(_response);
        });
    }

    protected processListProcessStepGroups(response: AxiosResponse): Promise<ValuesDto_processStepGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_processStepGroupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_processStepGroupResponse>(null as any);
    }

    /**
     * @return Payload of ProcessStepGroupResponse
     */
    createProcessStepGroup(body: CreateProcessStepGroupRequest, signal?: AbortSignal): Promise<ProcessStepGroupResponse> {
        let url_ = this.baseUrl + "/process-step-groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProcessStepGroup(_response);
        });
    }

    protected processCreateProcessStepGroup(response: AxiosResponse): Promise<ProcessStepGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProcessStepGroupResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessStepGroupResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the ProcessStepGroup
     * @return Payload of ProcessStepGroupResponse
     */
    readProcessStepGroup(id?: number | undefined, signal?: AbortSignal): Promise<ProcessStepGroupResponse> {
        let url_ = this.baseUrl + "/process-step-groups/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadProcessStepGroup(_response);
        });
    }

    protected processReadProcessStepGroup(response: AxiosResponse): Promise<ProcessStepGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProcessStepGroupResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessStepGroupResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Unit
     * @return Payload of ProcessStepGroupResponse
     */
    updateProcessStepGroup(body: UpdateProcessStepGroupRequest, id?: number | undefined, signal?: AbortSignal): Promise<ProcessStepGroupResponse> {
        let url_ = this.baseUrl + "/process-step-groups/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProcessStepGroup(_response);
        });
    }

    protected processUpdateProcessStepGroup(response: AxiosResponse): Promise<ProcessStepGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProcessStepGroupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessStepGroupResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the ProcessStepGroup
     */
    deleteProcessStepGroup(id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/process-step-groups/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProcessStepGroup(_response);
        });
    }

    protected processDeleteProcessStepGroup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Payload of ValuesDto containing ProcessStepResponse
     */
    listProcessSteps(signal?: AbortSignal): Promise<ValuesDto_processStepResponse> {
        let url_ = this.baseUrl + "/process-steps";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListProcessSteps(_response);
        });
    }

    protected processListProcessSteps(response: AxiosResponse): Promise<ValuesDto_processStepResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_processStepResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_processStepResponse>(null as any);
    }

    /**
     * @return Payload of ProcessStepResponse
     */
    createProcessStep(body: CreateProcessStepRequest, signal?: AbortSignal): Promise<ProcessStepResponse> {
        let url_ = this.baseUrl + "/process-steps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProcessStep(_response);
        });
    }

    protected processCreateProcessStep(response: AxiosResponse): Promise<ProcessStepResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProcessStepResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessStepResponse>(null as any);
    }

    /**
     * @return CSV format
     */
    listProcessStepsCsv(language: string, signal?: AbortSignal): Promise<ContentResult> {
        let url_ = this.baseUrl + "/process-steps/csv/{language}";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/csv"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListProcessStepsCsv(_response);
        });
    }

    protected processListProcessStepsCsv(response: AxiosResponse): Promise<ContentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ContentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentResult>(null as any);
    }

    /**
     * @param id (optional) The id of the ProcessStep
     * @return Payload of ProcessStepResponse
     */
    readProcessStep(id?: number | undefined, signal?: AbortSignal): Promise<ProcessStepResponse> {
        let url_ = this.baseUrl + "/process-steps/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadProcessStep(_response);
        });
    }

    protected processReadProcessStep(response: AxiosResponse): Promise<ProcessStepResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProcessStepResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessStepResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Unit
     * @return Payload of ProcessStepResponse
     */
    updateProcessStep(body: UpdateProcessStepRequest, id?: number | undefined, signal?: AbortSignal): Promise<ProcessStepResponse> {
        let url_ = this.baseUrl + "/process-steps/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProcessStep(_response);
        });
    }

    protected processUpdateProcessStep(response: AxiosResponse): Promise<ProcessStepResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProcessStepResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessStepResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the ProcessStep
     */
    deleteProcessStep(id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/process-steps/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProcessStep(_response);
        });
    }

    protected processDeleteProcessStep(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Payload of RiskAssessmentResponse
     */
    listProcessStepRiskAssessments(signal?: AbortSignal): Promise<RiskAssessmentResponse> {
        let url_ = this.baseUrl + "/process-steps/{id}/risk-assessments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListProcessStepRiskAssessments(_response);
        });
    }

    protected processListProcessStepRiskAssessments(response: AxiosResponse): Promise<RiskAssessmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentResponse>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @param productGroupCode (optional) 
     * @param productGroupCategory (optional) 
     * @param isActiveMonitoring (optional) 
     * @param isExpired (optional) 
     * @param isActiveRiskAssessment (optional) 
     * @param isEuProduct (optional) 
     * @param isFavourite (optional) 
     * @return List of products
     */
    listProducts(page?: number | undefined, pageSize?: number | undefined, search?: string | undefined, productGroupCode?: string | undefined, productGroupCategory?: string | undefined, isActiveMonitoring?: boolean | undefined, isExpired?: boolean | undefined, isActiveRiskAssessment?: boolean | undefined, isEuProduct?: boolean | undefined, isFavourite?: boolean | undefined, signal?: AbortSignal): Promise<ValuesDto_productResponse> {
        let url_ = this.baseUrl + "/products?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (productGroupCode === null)
            throw new Error("The parameter 'productGroupCode' cannot be null.");
        else if (productGroupCode !== undefined)
            url_ += "productGroupCode=" + encodeURIComponent("" + productGroupCode) + "&";
        if (productGroupCategory === null)
            throw new Error("The parameter 'productGroupCategory' cannot be null.");
        else if (productGroupCategory !== undefined)
            url_ += "productGroupCategory=" + encodeURIComponent("" + productGroupCategory) + "&";
        if (isActiveMonitoring === null)
            throw new Error("The parameter 'isActiveMonitoring' cannot be null.");
        else if (isActiveMonitoring !== undefined)
            url_ += "isActiveMonitoring=" + encodeURIComponent("" + isActiveMonitoring) + "&";
        if (isExpired === null)
            throw new Error("The parameter 'isExpired' cannot be null.");
        else if (isExpired !== undefined)
            url_ += "isExpired=" + encodeURIComponent("" + isExpired) + "&";
        if (isActiveRiskAssessment === null)
            throw new Error("The parameter 'isActiveRiskAssessment' cannot be null.");
        else if (isActiveRiskAssessment !== undefined)
            url_ += "isActiveRiskAssessment=" + encodeURIComponent("" + isActiveRiskAssessment) + "&";
        if (isEuProduct === null)
            throw new Error("The parameter 'isEuProduct' cannot be null.");
        else if (isEuProduct !== undefined)
            url_ += "isEuProduct=" + encodeURIComponent("" + isEuProduct) + "&";
        if (isFavourite === null)
            throw new Error("The parameter 'isFavourite' cannot be null.");
        else if (isFavourite !== undefined)
            url_ += "isFavourite=" + encodeURIComponent("" + isFavourite) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListProducts(_response);
        });
    }

    protected processListProducts(response: AxiosResponse): Promise<ValuesDto_productResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_productResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_productResponse>(null as any);
    }

    /**
     * @return Payload of ProductResponse
     */
    createProduct(body: CreateProductRequest, signal?: AbortSignal): Promise<ProductResponse> {
        let url_ = this.baseUrl + "/products";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProduct(_response);
        });
    }

    protected processCreateProduct(response: AxiosResponse): Promise<ProductResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProductResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductResponse>(null as any);
    }

    /**
     * @return CSV format
     */
    listPortalProductsCsv(language: string, signal?: AbortSignal): Promise<ContentResult> {
        let url_ = this.baseUrl + "/products/csv/{language}";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/csv"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalProductsCsv(_response);
        });
    }

    protected processListPortalProductsCsv(response: AxiosResponse): Promise<ContentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ContentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentResult>(null as any);
    }

    /**
     * @param id (optional) The id of the Product
     * @return Payload of ProductResponse
     */
    readProduct(id?: number | undefined, signal?: AbortSignal): Promise<ProductResponse> {
        let url_ = this.baseUrl + "/products/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadProduct(_response);
        });
    }

    protected processReadProduct(response: AxiosResponse): Promise<ProductResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProductResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Unit
     * @return Payload of ProductResponse
     */
    updateProduct(body: UpdateProductRequest, id?: number | undefined, signal?: AbortSignal): Promise<ProductResponse> {
        let url_ = this.baseUrl + "/products/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProduct(_response);
        });
    }

    protected processUpdateProduct(response: AxiosResponse): Promise<ProductResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProductResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Product
     */
    deleteProduct(id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/products/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProduct(_response);
        });
    }

    protected processDeleteProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Payload of Array of Object
     */
    readProductGroupDefaults(signal?: AbortSignal): Promise<any[]> {
        let url_ = this.baseUrl + "/product-group-defaults";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadProductGroupDefaults(_response);
        });
    }

    protected processReadProductGroupDefaults(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<any[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(null as any);
    }

    /**
     * @return Payload of ValuesDto containing ProductGroupResponse
     */
    listProductGroups(signal?: AbortSignal): Promise<ValuesDto_productGroupResponse> {
        let url_ = this.baseUrl + "/product-groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListProductGroups(_response);
        });
    }

    protected processListProductGroups(response: AxiosResponse): Promise<ValuesDto_productGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_productGroupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_productGroupResponse>(null as any);
    }

    /**
     * @return Payload of ProductGroupResponse
     */
    createProductGroup(body: CreateProductGroupRequest, signal?: AbortSignal): Promise<ProductGroupResponse> {
        let url_ = this.baseUrl + "/product-groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProductGroup(_response);
        });
    }

    protected processCreateProductGroup(response: AxiosResponse): Promise<ProductGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProductGroupResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductGroupResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the ProductGroup
     * @return Payload of ProductGroupResponse
     */
    readProductGroup(id?: number | undefined, signal?: AbortSignal): Promise<ProductGroupResponse> {
        let url_ = this.baseUrl + "/product-groups/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadProductGroup(_response);
        });
    }

    protected processReadProductGroup(response: AxiosResponse): Promise<ProductGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProductGroupResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductGroupResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Unit
     * @return Payload of ProductGroupResponse
     */
    updateProductGroup(body: UpdateProductGroupRequest, id?: number | undefined, signal?: AbortSignal): Promise<ProductGroupResponse> {
        let url_ = this.baseUrl + "/product-groups/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProductGroup(_response);
        });
    }

    protected processUpdateProductGroup(response: AxiosResponse): Promise<ProductGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProductGroupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductGroupResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the ProductGroup
     */
    deleteProductGroup(id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/product-groups/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProductGroup(_response);
        });
    }

    protected processDeleteProductGroup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param language (optional) 
     * @return CSV format
     */
    listRiskAssessmentsCsv(language?: string | undefined, signal?: AbortSignal): Promise<ContentResult> {
        let url_ = this.baseUrl + "/risk-assessments/csv/{language}";
        if (language !== null && language !== undefined)
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        else
            url_ = url_.replace("/{language}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/csv"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListRiskAssessmentsCsv(_response);
        });
    }

    protected processListRiskAssessmentsCsv(response: AxiosResponse): Promise<ContentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ContentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentResult>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @param status (optional) 
     * @param publicationDateFrom (optional) 
     * @param publicationDateTo (optional) 
     * @param lastModifiedAtFrom (optional) 
     * @param lastModifiedAtTo (optional) 
     * @param hazardIds (optional) 
     * @param processingAidIds (optional) 
     * @param orderBy (optional) 
     * @param orderByDesc (optional) 
     * @return Payload of ValuesDto containing RiskAssessmentResponse
     */
    listRiskAssessments(page?: number | undefined, pageSize?: number | undefined, search?: string | undefined, status?: string | undefined, publicationDateFrom?: Date | undefined, publicationDateTo?: Date | undefined, lastModifiedAtFrom?: Date | undefined, lastModifiedAtTo?: Date | undefined, hazardIds?: string | undefined, processingAidIds?: string | undefined, orderBy?: string | undefined, orderByDesc?: string | undefined, signal?: AbortSignal): Promise<ValuesDto_riskAssessmentResponse> {
        let url_ = this.baseUrl + "/risk-assessments?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (publicationDateFrom === null)
            throw new Error("The parameter 'publicationDateFrom' cannot be null.");
        else if (publicationDateFrom !== undefined)
            url_ += "publicationDateFrom=" + encodeURIComponent(publicationDateFrom ? "" + publicationDateFrom.toISOString() : "") + "&";
        if (publicationDateTo === null)
            throw new Error("The parameter 'publicationDateTo' cannot be null.");
        else if (publicationDateTo !== undefined)
            url_ += "publicationDateTo=" + encodeURIComponent(publicationDateTo ? "" + publicationDateTo.toISOString() : "") + "&";
        if (lastModifiedAtFrom === null)
            throw new Error("The parameter 'lastModifiedAtFrom' cannot be null.");
        else if (lastModifiedAtFrom !== undefined)
            url_ += "lastModifiedAtFrom=" + encodeURIComponent(lastModifiedAtFrom ? "" + lastModifiedAtFrom.toISOString() : "") + "&";
        if (lastModifiedAtTo === null)
            throw new Error("The parameter 'lastModifiedAtTo' cannot be null.");
        else if (lastModifiedAtTo !== undefined)
            url_ += "lastModifiedAtTo=" + encodeURIComponent(lastModifiedAtTo ? "" + lastModifiedAtTo.toISOString() : "") + "&";
        if (hazardIds === null)
            throw new Error("The parameter 'hazardIds' cannot be null.");
        else if (hazardIds !== undefined)
            url_ += "hazardIds=" + encodeURIComponent("" + hazardIds) + "&";
        if (processingAidIds === null)
            throw new Error("The parameter 'processingAidIds' cannot be null.");
        else if (processingAidIds !== undefined)
            url_ += "processingAidIds=" + encodeURIComponent("" + processingAidIds) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDesc === null)
            throw new Error("The parameter 'orderByDesc' cannot be null.");
        else if (orderByDesc !== undefined)
            url_ += "orderByDesc=" + encodeURIComponent("" + orderByDesc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListRiskAssessments(_response);
        });
    }

    protected processListRiskAssessments(response: AxiosResponse): Promise<ValuesDto_riskAssessmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_riskAssessmentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_riskAssessmentResponse>(null as any);
    }

    /**
     * @return Payload of RiskAssessmentResponse
     */
    createRiskAssessment(body: CreateRiskAssessmentRequest, signal?: AbortSignal): Promise<RiskAssessmentResponse> {
        let url_ = this.baseUrl + "/risk-assessments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRiskAssessment(_response);
        });
    }

    protected processCreateRiskAssessment(response: AxiosResponse): Promise<RiskAssessmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the RiskAssessment
     * @return Payload of RiskAssessmentResponse
     */
    readRiskAssessment(id?: number | undefined, signal?: AbortSignal): Promise<RiskAssessmentResponse> {
        let url_ = this.baseUrl + "/risk-assessments/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadRiskAssessment(_response);
        });
    }

    protected processReadRiskAssessment(response: AxiosResponse): Promise<RiskAssessmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the RiskAssessment
     * @return Payload of RiskAssessmentResponse
     */
    updateRiskAssessment(body: UpdateRiskAssessmentRequest, id?: number | undefined, signal?: AbortSignal): Promise<RiskAssessmentResponse> {
        let url_ = this.baseUrl + "/risk-assessments/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRiskAssessment(_response);
        });
    }

    protected processUpdateRiskAssessment(response: AxiosResponse): Promise<RiskAssessmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the RiskAssessment
     */
    deleteRiskAssessment(id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/risk-assessments/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRiskAssessment(_response);
        });
    }

    protected processDeleteRiskAssessment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @return Payload of RiskAssessmentsProcessingAidResponse
     */
    createRiskAssessmentsProcessingAid(body: CreateRiskAssessmentsProcessingAidRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined, signal?: AbortSignal): Promise<RiskAssessmentsProcessingAidResponse> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{versionId}/processing-aids";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (versionId !== null && versionId !== undefined)
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        else
            url_ = url_.replace("/{versionId}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRiskAssessmentsProcessingAid(_response);
        });
    }

    protected processCreateRiskAssessmentsProcessingAid(response: AxiosResponse): Promise<RiskAssessmentsProcessingAidResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentsProcessingAidResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentsProcessingAidResponse>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param id (optional) The id of the RiskAssessmentsProcessingAid
     * @return Payload of RiskAssessmentsProcessingAidResponse
     */
    updateRiskAssessmentsProcessingAid(body: UpdateRiskAssessmentsProcessingAidRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined, id?: number | undefined, signal?: AbortSignal): Promise<RiskAssessmentsProcessingAidResponse> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{versionId}/processing-aids/{id}";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (versionId !== null && versionId !== undefined)
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        else
            url_ = url_.replace("/{versionId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRiskAssessmentsProcessingAid(_response);
        });
    }

    protected processUpdateRiskAssessmentsProcessingAid(response: AxiosResponse): Promise<RiskAssessmentsProcessingAidResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentsProcessingAidResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentsProcessingAidResponse>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param id (optional) The id of the RiskAssessmentsProcessingAid
     */
    deleteRiskAssessmentsProcessingAid(riskAssessmentId?: number | undefined, versionId?: number | undefined, id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{versionId}/processing-aids/{id}";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (versionId !== null && versionId !== undefined)
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        else
            url_ = url_.replace("/{versionId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRiskAssessmentsProcessingAid(_response);
        });
    }

    protected processDeleteRiskAssessmentsProcessingAid(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @return Payload of RiskAssessmentsProcessStepResponse
     */
    createRiskAssessmentsProcessStep(body: CreateRiskAssessmentsProcessStepRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined, signal?: AbortSignal): Promise<RiskAssessmentsProcessStepResponse> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{versionId}/process-steps";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (versionId !== null && versionId !== undefined)
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        else
            url_ = url_.replace("/{versionId}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRiskAssessmentsProcessStep(_response);
        });
    }

    protected processCreateRiskAssessmentsProcessStep(response: AxiosResponse): Promise<RiskAssessmentsProcessStepResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentsProcessStepResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentsProcessStepResponse>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param id (optional) The id of the RiskAssessmentsProcessStep
     * @return Payload of RiskAssessmentsProcessStepResponse
     */
    updateRiskAssessmentsProcessStep(body: UpdateRiskAssessmentsProcessStepRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined, id?: number | undefined, signal?: AbortSignal): Promise<RiskAssessmentsProcessStepResponse> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{versionId}/process-steps/{id}";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (versionId !== null && versionId !== undefined)
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        else
            url_ = url_.replace("/{versionId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRiskAssessmentsProcessStep(_response);
        });
    }

    protected processUpdateRiskAssessmentsProcessStep(response: AxiosResponse): Promise<RiskAssessmentsProcessStepResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentsProcessStepResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentsProcessStepResponse>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param id (optional) The id of the RiskAssessmentsProcessStep
     */
    deleteRiskAssessmentsProcessStep(riskAssessmentId?: number | undefined, versionId?: number | undefined, id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{versionId}/process-steps/{id}";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (versionId !== null && versionId !== undefined)
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        else
            url_ = url_.replace("/{versionId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRiskAssessmentsProcessStep(_response);
        });
    }

    protected processDeleteRiskAssessmentsProcessStep(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param processStepId (optional) The processStepId of the RiskAssessmentsProcessStep
     * @param hazardId (optional) The hazardId of the RiskAssessmentsProcessStepsHazard
     * @return Payload of RiskAssessmentsProcessStepsHazardsControlMeasureResponse
     */
    createRiskAssessmentsProcessStepsHazardsControlMeasure(body: CreateRiskAssessmentsProcessStepsHazardsControlMeasureRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined, processStepId?: number | undefined, hazardId?: number | undefined, signal?: AbortSignal): Promise<RiskAssessmentsProcessStepsHazardsControlMeasureResponse> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{versionId}/process-steps/{processStepId}/hazards/{hazardId}/control-measures";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (versionId !== null && versionId !== undefined)
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        else
            url_ = url_.replace("/{versionId}", "");
        if (processStepId !== null && processStepId !== undefined)
        url_ = url_.replace("{processStepId}", encodeURIComponent("" + processStepId));
        else
            url_ = url_.replace("/{processStepId}", "");
        if (hazardId !== null && hazardId !== undefined)
        url_ = url_.replace("{hazardId}", encodeURIComponent("" + hazardId));
        else
            url_ = url_.replace("/{hazardId}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRiskAssessmentsProcessStepsHazardsControlMeasure(_response);
        });
    }

    protected processCreateRiskAssessmentsProcessStepsHazardsControlMeasure(response: AxiosResponse): Promise<RiskAssessmentsProcessStepsHazardsControlMeasureResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentsProcessStepsHazardsControlMeasureResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentsProcessStepsHazardsControlMeasureResponse>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param processStepId (optional) The processStepId of the RiskAssessmentsProcessStep
     * @param hazardId (optional) The hazardId of the RiskAssessmentsProcessStepsHazard
     * @param id (optional) The id of the RiskAssessmentsProcessStepsHazardsControlMeasure
     * @return Payload of RiskAssessmentsProcessStepsHazardsControlMeasureResponse
     */
    updateRiskAssessmentsProcessStepsHazardsControlMeasure(body: UpdateRiskAssessmentsProcessStepsHazardsControlMeasureRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined, processStepId?: number | undefined, hazardId?: number | undefined, id?: number | undefined, signal?: AbortSignal): Promise<RiskAssessmentsProcessStepsHazardsControlMeasureResponse> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{versionId}/process-steps/{processStepId}/hazards/{hazardId}/control-measures/{id}";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (versionId !== null && versionId !== undefined)
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        else
            url_ = url_.replace("/{versionId}", "");
        if (processStepId !== null && processStepId !== undefined)
        url_ = url_.replace("{processStepId}", encodeURIComponent("" + processStepId));
        else
            url_ = url_.replace("/{processStepId}", "");
        if (hazardId !== null && hazardId !== undefined)
        url_ = url_.replace("{hazardId}", encodeURIComponent("" + hazardId));
        else
            url_ = url_.replace("/{hazardId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRiskAssessmentsProcessStepsHazardsControlMeasure(_response);
        });
    }

    protected processUpdateRiskAssessmentsProcessStepsHazardsControlMeasure(response: AxiosResponse): Promise<RiskAssessmentsProcessStepsHazardsControlMeasureResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentsProcessStepsHazardsControlMeasureResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentsProcessStepsHazardsControlMeasureResponse>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param processStepId (optional) The processStepId of the RiskAssessmentsProcessStep
     * @param hazardId (optional) The hazardId of the RiskAssessmentsProcessStepsHazard
     * @param id (optional) The id of the RiskAssessmentsProcessStepsHazardsControlMeasure
     */
    deleteRiskAssessmentsProcessStepsHazardsControlMeasure(riskAssessmentId?: number | undefined, versionId?: number | undefined, processStepId?: number | undefined, hazardId?: number | undefined, id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{versionId}/process-steps/{processStepId}/hazards/{hazardId}/control-measures/{id}";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (versionId !== null && versionId !== undefined)
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        else
            url_ = url_.replace("/{versionId}", "");
        if (processStepId !== null && processStepId !== undefined)
        url_ = url_.replace("{processStepId}", encodeURIComponent("" + processStepId));
        else
            url_ = url_.replace("/{processStepId}", "");
        if (hazardId !== null && hazardId !== undefined)
        url_ = url_.replace("{hazardId}", encodeURIComponent("" + hazardId));
        else
            url_ = url_.replace("/{hazardId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRiskAssessmentsProcessStepsHazardsControlMeasure(_response);
        });
    }

    protected processDeleteRiskAssessmentsProcessStepsHazardsControlMeasure(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param processStepId (optional) The processStepId of the RiskAssessmentsProcessStep
     * @return Payload of RiskAssessmentsProcessStepsHazardResponse
     */
    createRiskAssessmentsProcessStepsHazard(body: CreateRiskAssessmentsProcessStepsHazardRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined, processStepId?: number | undefined, signal?: AbortSignal): Promise<RiskAssessmentsProcessStepsHazardResponse> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{versionId}/process-steps/{processStepId}/hazards";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (versionId !== null && versionId !== undefined)
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        else
            url_ = url_.replace("/{versionId}", "");
        if (processStepId !== null && processStepId !== undefined)
        url_ = url_.replace("{processStepId}", encodeURIComponent("" + processStepId));
        else
            url_ = url_.replace("/{processStepId}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRiskAssessmentsProcessStepsHazard(_response);
        });
    }

    protected processCreateRiskAssessmentsProcessStepsHazard(response: AxiosResponse): Promise<RiskAssessmentsProcessStepsHazardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentsProcessStepsHazardResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentsProcessStepsHazardResponse>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param processStepId (optional) The processStepId of the RiskAssessmentsProcessStep
     * @param id (optional) The id of the RiskAssessmentsProcessStepsHazard
     * @return Payload of RiskAssessmentsProcessStepsHazardResponse
     */
    updateRiskAssessmentsProcessStepsHazard(body: UpdateRiskAssessmentsProcessStepsHazardRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined, processStepId?: number | undefined, id?: number | undefined, signal?: AbortSignal): Promise<RiskAssessmentsProcessStepsHazardResponse> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{versionId}/process-steps/{processStepId}/hazards/{id}";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (versionId !== null && versionId !== undefined)
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        else
            url_ = url_.replace("/{versionId}", "");
        if (processStepId !== null && processStepId !== undefined)
        url_ = url_.replace("{processStepId}", encodeURIComponent("" + processStepId));
        else
            url_ = url_.replace("/{processStepId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRiskAssessmentsProcessStepsHazard(_response);
        });
    }

    protected processUpdateRiskAssessmentsProcessStepsHazard(response: AxiosResponse): Promise<RiskAssessmentsProcessStepsHazardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentsProcessStepsHazardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentsProcessStepsHazardResponse>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param processStepId (optional) The processStepId of the RiskAssessmentsProcessStep
     * @param id (optional) The id of the RiskAssessmentsProcessStepsHazard
     */
    deleteRiskAssessmentsProcessStepsHazard(riskAssessmentId?: number | undefined, versionId?: number | undefined, processStepId?: number | undefined, id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{versionId}/process-steps/{processStepId}/hazards/{id}";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (versionId !== null && versionId !== undefined)
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        else
            url_ = url_.replace("/{versionId}", "");
        if (processStepId !== null && processStepId !== undefined)
        url_ = url_.replace("{processStepId}", encodeURIComponent("" + processStepId));
        else
            url_ = url_.replace("/{processStepId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRiskAssessmentsProcessStepsHazard(_response);
        });
    }

    protected processDeleteRiskAssessmentsProcessStepsHazard(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param processStepId (optional) The processStepId of the RiskAssessmentsProcessStep
     * @return Payload of RiskAssessmentsProcessStepsProductResponse
     */
    createRiskAssessmentsProcessStepsProduct(body: CreateRiskAssessmentsProcessStepsProductRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined, processStepId?: number | undefined, signal?: AbortSignal): Promise<RiskAssessmentsProcessStepsProductResponse> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{versionId}/process-steps/{processStepId}/products";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (versionId !== null && versionId !== undefined)
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        else
            url_ = url_.replace("/{versionId}", "");
        if (processStepId !== null && processStepId !== undefined)
        url_ = url_.replace("{processStepId}", encodeURIComponent("" + processStepId));
        else
            url_ = url_.replace("/{processStepId}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRiskAssessmentsProcessStepsProduct(_response);
        });
    }

    protected processCreateRiskAssessmentsProcessStepsProduct(response: AxiosResponse): Promise<RiskAssessmentsProcessStepsProductResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentsProcessStepsProductResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentsProcessStepsProductResponse>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param processStepId (optional) The processStepId of the RiskAssessmentsProcessStep
     * @param id (optional) The id of the RiskAssessmentsProcessStepsProduct
     * @return Payload of RiskAssessmentsProcessStepsProductResponse
     */
    updateRiskAssessmentsProcessStepsProduct(body: UpdateRiskAssessmentsProcessStepsProductRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined, processStepId?: number | undefined, id?: number | undefined, signal?: AbortSignal): Promise<RiskAssessmentsProcessStepsProductResponse> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{versionId}/process-steps/{processStepId}/products/{id}";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (versionId !== null && versionId !== undefined)
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        else
            url_ = url_.replace("/{versionId}", "");
        if (processStepId !== null && processStepId !== undefined)
        url_ = url_.replace("{processStepId}", encodeURIComponent("" + processStepId));
        else
            url_ = url_.replace("/{processStepId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRiskAssessmentsProcessStepsProduct(_response);
        });
    }

    protected processUpdateRiskAssessmentsProcessStepsProduct(response: AxiosResponse): Promise<RiskAssessmentsProcessStepsProductResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentsProcessStepsProductResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentsProcessStepsProductResponse>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param processStepId (optional) The processStepId of the RiskAssessmentsProcessStep
     * @param id (optional) The id of the RiskAssessmentsProcessStepsProduct
     */
    deleteRiskAssessmentsProcessStepsProduct(riskAssessmentId?: number | undefined, versionId?: number | undefined, processStepId?: number | undefined, id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{versionId}/process-steps/{processStepId}/products/{id}";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (versionId !== null && versionId !== undefined)
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        else
            url_ = url_.replace("/{versionId}", "");
        if (processStepId !== null && processStepId !== undefined)
        url_ = url_.replace("{processStepId}", encodeURIComponent("" + processStepId));
        else
            url_ = url_.replace("/{processStepId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRiskAssessmentsProcessStepsProduct(_response);
        });
    }

    protected processDeleteRiskAssessmentsProcessStepsProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @return Payload of RiskAssessmentsProductResponse
     */
    createRiskAssessmentsProduct(body: CreateRiskAssessmentsProductRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined, signal?: AbortSignal): Promise<RiskAssessmentsProductResponse> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{versionId}/products";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (versionId !== null && versionId !== undefined)
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        else
            url_ = url_.replace("/{versionId}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRiskAssessmentsProduct(_response);
        });
    }

    protected processCreateRiskAssessmentsProduct(response: AxiosResponse): Promise<RiskAssessmentsProductResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentsProductResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentsProductResponse>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param id (optional) The id of the RiskAssessmentsProduct
     * @return Payload of RiskAssessmentsProductResponse
     */
    updateRiskAssessmentsProduct(body: UpdateRiskAssessmentsProductRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined, id?: number | undefined, signal?: AbortSignal): Promise<RiskAssessmentsProductResponse> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{versionId}/products/{id}";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (versionId !== null && versionId !== undefined)
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        else
            url_ = url_.replace("/{versionId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRiskAssessmentsProduct(_response);
        });
    }

    protected processUpdateRiskAssessmentsProduct(response: AxiosResponse): Promise<RiskAssessmentsProductResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentsProductResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentsProductResponse>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param id (optional) The id of the RiskAssessmentsProduct
     */
    deleteRiskAssessmentsProduct(riskAssessmentId?: number | undefined, versionId?: number | undefined, id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{versionId}/products/{id}";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (versionId !== null && versionId !== undefined)
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        else
            url_ = url_.replace("/{versionId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRiskAssessmentsProduct(_response);
        });
    }

    protected processDeleteRiskAssessmentsProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param riskAssessmentVersionId (optional) 
     * @param language (optional) 
     * @param name (optional) 
     * @param position (optional) 
     * @param path (optional) 
     * @param flowChartVersionDate (optional) 
     * @return Payload of RiskAssessmentVersionFlowChartFileReferenceResponse
     */
    createRiskAssessmentVersionFlowChartFileReference(riskAssessmentId?: number | undefined, versionId?: number | undefined, riskAssessmentVersionId?: number | undefined, language?: string | undefined, name?: string | undefined, position?: number | null | undefined, path?: string | undefined, flowChartVersionDate?: Date | null | undefined, signal?: AbortSignal): Promise<RiskAssessmentVersionFlowChartFileReferenceResponse> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{versionId}/flowchart-file-references";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (versionId !== null && versionId !== undefined)
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        else
            url_ = url_.replace("/{versionId}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (riskAssessmentVersionId === null || riskAssessmentVersionId === undefined)
            throw new Error("The parameter 'riskAssessmentVersionId' cannot be null.");
        else
            content_.append("riskAssessmentVersionId", riskAssessmentVersionId.toString());
        if (language === null || language === undefined)
            throw new Error("The parameter 'language' cannot be null.");
        else
            content_.append("language", language.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("name", name.toString());
        if (position !== null && position !== undefined)
            content_.append("position", position.toString());
        if (path === null || path === undefined)
            throw new Error("The parameter 'path' cannot be null.");
        else
            content_.append("path", path.toString());
        if (flowChartVersionDate !== null && flowChartVersionDate !== undefined)
            content_.append("flowChartVersionDate", flowChartVersionDate.toJSON());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRiskAssessmentVersionFlowChartFileReference(_response);
        });
    }

    protected processCreateRiskAssessmentVersionFlowChartFileReference(response: AxiosResponse): Promise<RiskAssessmentVersionFlowChartFileReferenceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentVersionFlowChartFileReferenceResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentVersionFlowChartFileReferenceResponse>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param id (optional) The id of the RiskAssessmentVersionFlowChartFileReference
     * @return Payload of RiskAssessmentVersionFlowChartFileReferenceResponse
     */
    updateRiskAssessmentVersionFlowChartFileReference(body: UpdateRiskAssessmentVersionFlowChartFileReferenceRequest, riskAssessmentId?: number | undefined, versionId?: number | undefined, id?: number | undefined, signal?: AbortSignal): Promise<RiskAssessmentVersionFlowChartFileReferenceResponse> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{versionId}/flowchart-file-references/{id}";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (versionId !== null && versionId !== undefined)
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        else
            url_ = url_.replace("/{versionId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRiskAssessmentVersionFlowChartFileReference(_response);
        });
    }

    protected processUpdateRiskAssessmentVersionFlowChartFileReference(response: AxiosResponse): Promise<RiskAssessmentVersionFlowChartFileReferenceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentVersionFlowChartFileReferenceResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentVersionFlowChartFileReferenceResponse>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param versionId (optional) The versionId of the RiskAssessmentVersion
     * @param id (optional) The id of the RiskAssessmentVersionFlowChartFileReference
     */
    deleteRiskAssessmentVersionFlowChartFileReference(riskAssessmentId?: number | undefined, versionId?: number | undefined, id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{versionId}/flowchart-file-references/{id}";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (versionId !== null && versionId !== undefined)
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        else
            url_ = url_.replace("/{versionId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRiskAssessmentVersionFlowChartFileReference(_response);
        });
    }

    protected processDeleteRiskAssessmentVersionFlowChartFileReference(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param status (optional) 
     * @return Payload of ValuesDto containing RiskAssessmentVersionResponse
     */
    listRiskAssessmentVersions(status?: string | undefined, signal?: AbortSignal): Promise<ValuesDto_riskAssessmentVersionResponse> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListRiskAssessmentVersions(_response);
        });
    }

    protected processListRiskAssessmentVersions(response: AxiosResponse): Promise<ValuesDto_riskAssessmentVersionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_riskAssessmentVersionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_riskAssessmentVersionResponse>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @return Payload of RiskAssessmentVersionResponse
     */
    createRiskAssessmentVersion(body: CreateRiskAssessmentVersionRequest, riskAssessmentId?: number | undefined, signal?: AbortSignal): Promise<RiskAssessmentVersionResponse> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRiskAssessmentVersion(_response);
        });
    }

    protected processCreateRiskAssessmentVersion(response: AxiosResponse): Promise<RiskAssessmentVersionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentVersionResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentVersionResponse>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param id (optional) The id of the RiskAssessmentVersion
     * @return Payload of RiskAssessmentVersionResponse
     */
    updateRiskAssessmentVersion(body: UpdateRiskAssessmentVersionRequest, riskAssessmentId?: number | undefined, id?: number | undefined, signal?: AbortSignal): Promise<RiskAssessmentVersionResponse> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{id}";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRiskAssessmentVersion(_response);
        });
    }

    protected processUpdateRiskAssessmentVersion(response: AxiosResponse): Promise<RiskAssessmentVersionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentVersionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentVersionResponse>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param id (optional) The id of the RiskAssessmentVersion
     */
    deleteRiskAssessmentVersion(riskAssessmentId?: number | undefined, id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{id}";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRiskAssessmentVersion(_response);
        });
    }

    protected processDeleteRiskAssessmentVersion(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param id (optional) The id of the RiskAssessmentVersion
     * @return Payload of RiskAssessmentVersionResponse
     */
    forkRiskAssessmentVersion(riskAssessmentId?: number | undefined, id?: number | undefined, signal?: AbortSignal): Promise<RiskAssessmentVersionResponse> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{id}/fork";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForkRiskAssessmentVersion(_response);
        });
    }

    protected processForkRiskAssessmentVersion(response: AxiosResponse): Promise<RiskAssessmentVersionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentVersionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentVersionResponse>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param id (optional) The id of the RiskAssessmentVersion
     * @return Payload of RiskAssessmentVersionResponse
     */
    finaliseRiskAssessmentVersion(riskAssessmentId?: number | undefined, id?: number | undefined, signal?: AbortSignal): Promise<RiskAssessmentVersionResponse> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{id}/finalise";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFinaliseRiskAssessmentVersion(_response);
        });
    }

    protected processFinaliseRiskAssessmentVersion(response: AxiosResponse): Promise<RiskAssessmentVersionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentVersionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentVersionResponse>(null as any);
    }

    /**
     * @param riskAssessmentId (optional) The riskAssessmentId of the RiskAssessment
     * @param id (optional) The id of the RiskAssessmentVersion
     * @return Payload of RiskAssessmentVersionResponse
     */
    revokeRiskAssessmentVersion(riskAssessmentId?: number | undefined, id?: number | undefined, signal?: AbortSignal): Promise<RiskAssessmentVersionResponse> {
        let url_ = this.baseUrl + "/risk-assessments/{riskAssessmentId}/versions/{id}/revoke";
        if (riskAssessmentId !== null && riskAssessmentId !== undefined)
        url_ = url_.replace("{riskAssessmentId}", encodeURIComponent("" + riskAssessmentId));
        else
            url_ = url_.replace("/{riskAssessmentId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRevokeRiskAssessmentVersion(_response);
        });
    }

    protected processRevokeRiskAssessmentVersion(response: AxiosResponse): Promise<RiskAssessmentVersionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentVersionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentVersionResponse>(null as any);
    }

    /**
     * @return Payload of Object
     */
    readSampleDefaults(signal?: AbortSignal): Promise<any> {
        let url_ = this.baseUrl + "/sample-defaults";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadSampleDefaults(_response);
        });
    }

    protected processReadSampleDefaults(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param registrationNumber (optional) 
     * @param own (optional) 
     * @param copied (optional) 
     * @param fromEdi (optional) 
     * @return Payload of ValuesDto containing SampleResponse
     */
    listSamples(page?: number | undefined, pageSize?: number | undefined, registrationNumber?: string | undefined, own?: boolean | undefined, copied?: boolean | undefined, fromEdi?: boolean | undefined, signal?: AbortSignal): Promise<ValuesDto_sampleResponse> {
        let url_ = this.baseUrl + "/samples?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (registrationNumber === null)
            throw new Error("The parameter 'registrationNumber' cannot be null.");
        else if (registrationNumber !== undefined)
            url_ += "registrationNumber=" + encodeURIComponent("" + registrationNumber) + "&";
        if (own === null)
            throw new Error("The parameter 'own' cannot be null.");
        else if (own !== undefined)
            url_ += "own=" + encodeURIComponent("" + own) + "&";
        if (copied === null)
            throw new Error("The parameter 'copied' cannot be null.");
        else if (copied !== undefined)
            url_ += "copied=" + encodeURIComponent("" + copied) + "&";
        if (fromEdi === null)
            throw new Error("The parameter 'fromEdi' cannot be null.");
        else if (fromEdi !== undefined)
            url_ += "fromEdi=" + encodeURIComponent("" + fromEdi) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSamples(_response);
        });
    }

    protected processListSamples(response: AxiosResponse): Promise<ValuesDto_sampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_sampleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_sampleResponse>(null as any);
    }

    /**
     * @return Payload of SampleResponse
     */
    createSample(body: CreateSampleRequest, signal?: AbortSignal): Promise<SampleResponse> {
        let url_ = this.baseUrl + "/samples";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSample(_response);
        });
    }

    protected processCreateSample(response: AxiosResponse): Promise<SampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SampleResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SampleResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Sample
     * @return Payload of SampleResponse
     */
    readSample(id?: string | undefined, signal?: AbortSignal): Promise<SampleResponse> {
        let url_ = this.baseUrl + "/samples/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadSample(_response);
        });
    }

    protected processReadSample(response: AxiosResponse): Promise<SampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SampleResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SampleResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Unit
     * @return Payload of SampleResponse
     */
    updateSample(body: UpdateSampleRequest, id?: string | undefined, signal?: AbortSignal): Promise<SampleResponse> {
        let url_ = this.baseUrl + "/samples/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSample(_response);
        });
    }

    protected processUpdateSample(response: AxiosResponse): Promise<SampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SampleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SampleResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Sample
     */
    deleteSample(id?: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/samples/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSample(_response);
        });
    }

    protected processDeleteSample(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) The id of the Unit
     * @return Payload of SampleResponse
     */
    revertSample(body: RevertSampleRequest, id?: string | undefined, signal?: AbortSignal): Promise<SampleResponse> {
        let url_ = this.baseUrl + "/samples/{id}/revert";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRevertSample(_response);
        });
    }

    protected processRevertSample(response: AxiosResponse): Promise<SampleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SampleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SampleResponse>(null as any);
    }

    /**
     * @return Payload of ValuesDto containing UnitResponse
     */
    listUnits(signal?: AbortSignal): Promise<ValuesDto_unitResponse> {
        let url_ = this.baseUrl + "/units";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListUnits(_response);
        });
    }

    protected processListUnits(response: AxiosResponse): Promise<ValuesDto_unitResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_unitResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_unitResponse>(null as any);
    }

    /**
     * @return Payload of UnitResponse
     */
    createUnit(body: CreateUnitRequest, signal?: AbortSignal): Promise<UnitResponse> {
        let url_ = this.baseUrl + "/units";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUnit(_response);
        });
    }

    protected processCreateUnit(response: AxiosResponse): Promise<UnitResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UnitResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnitResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Unit
     * @return Payload of UnitResponse
     */
    readUnit(id?: number | undefined, signal?: AbortSignal): Promise<UnitResponse> {
        let url_ = this.baseUrl + "/units/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadUnit(_response);
        });
    }

    protected processReadUnit(response: AxiosResponse): Promise<UnitResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UnitResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnitResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Unit
     * @return Payload of UnitResponse
     */
    updateUnit(body: UpdateUnitRequest, id?: number | undefined, signal?: AbortSignal): Promise<UnitResponse> {
        let url_ = this.baseUrl + "/units/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUnit(_response);
        });
    }

    protected processUpdateUnit(response: AxiosResponse): Promise<UnitResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UnitResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnitResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Unit
     */
    deleteUnit(id?: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/units/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUnit(_response);
        });
    }

    protected processDeleteUnit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Payload of CurrentUserDto
     */
    readCurrentUser(signal?: AbortSignal): Promise<CurrentUserDto> {
        let url_ = this.baseUrl + "/users/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadCurrentUser(_response);
        });
    }

    protected processReadCurrentUser(response: AxiosResponse): Promise<CurrentUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CurrentUserDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Payload of NotFoundResult", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CurrentUserDto>(null as any);
    }

    /**
     * @param laboratory (optional) 
     * @param producer (optional) 
     * @param supplier (optional) 
     * @param limit (optional) 
     * @return Payload of LocationForCurrentUserResponse
     */
    listCurrentUserLocations(laboratory?: boolean | undefined, producer?: boolean | undefined, supplier?: boolean | undefined, limit?: number | undefined, signal?: AbortSignal): Promise<LocationForCurrentUserResponse> {
        let url_ = this.baseUrl + "/users/current/locations?";
        if (laboratory === null)
            throw new Error("The parameter 'laboratory' cannot be null.");
        else if (laboratory !== undefined)
            url_ += "laboratory=" + encodeURIComponent("" + laboratory) + "&";
        if (producer === null)
            throw new Error("The parameter 'producer' cannot be null.");
        else if (producer !== undefined)
            url_ += "producer=" + encodeURIComponent("" + producer) + "&";
        if (supplier === null)
            throw new Error("The parameter 'supplier' cannot be null.");
        else if (supplier !== undefined)
            url_ += "supplier=" + encodeURIComponent("" + supplier) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListCurrentUserLocations(_response);
        });
    }

    protected processListCurrentUserLocations(response: AxiosResponse): Promise<LocationForCurrentUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LocationForCurrentUserResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Payload of NotFoundResult", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationForCurrentUserResponse>(null as any);
    }

    /**
     * @param limit (optional) 
     * @return Payload of MonitoringGroupForCurrentUserResponse
     */
    listCurrentUserMonitoringGroups(limit?: number | undefined, signal?: AbortSignal): Promise<MonitoringGroupForCurrentUserResponse> {
        let url_ = this.baseUrl + "/users/current/monitoring-groups?";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListCurrentUserMonitoringGroups(_response);
        });
    }

    protected processListCurrentUserMonitoringGroups(response: AxiosResponse): Promise<MonitoringGroupForCurrentUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MonitoringGroupForCurrentUserResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Payload of NotFoundResult", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonitoringGroupForCurrentUserResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Payload of CurrentUserRolesDto
     */
    readUserRoles(body?: UpdateOrCreateUserRolesRequest | undefined, signal?: AbortSignal): Promise<CurrentUserRolesDto> {
        let url_ = this.baseUrl + "/users/current/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadUserRoles(_response);
        });
    }

    protected processReadUserRoles(response: AxiosResponse): Promise<CurrentUserRolesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CurrentUserRolesDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CurrentUserRolesDto>(null as any);
    }

    /**
     * @param countryId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param own (optional) 
     * @param forCommunity (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing ReportCombinedSampleAnalysisResultResponse
     */
    listReportsSamplesAnalysisResultsReport(hazardId: number, productId: number, countryId?: number | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, own?: boolean | undefined, forCommunity?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_reportCombinedSampleAnalysisResultResponse> {
        let url_ = this.baseUrl + "/reports/samples/analysis-results-report?";
        if (hazardId === undefined || hazardId === null)
            throw new Error("The parameter 'hazardId' must be defined and cannot be null.");
        else
            url_ += "hazardId=" + encodeURIComponent("" + hazardId) + "&";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (own === null)
            throw new Error("The parameter 'own' cannot be null.");
        else if (own !== undefined)
            url_ += "own=" + encodeURIComponent("" + own) + "&";
        if (forCommunity === null)
            throw new Error("The parameter 'forCommunity' cannot be null.");
        else if (forCommunity !== undefined)
            url_ += "forCommunity=" + encodeURIComponent("" + forCommunity) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListReportsSamplesAnalysisResultsReport(_response);
        });
    }

    protected processListReportsSamplesAnalysisResultsReport(response: AxiosResponse): Promise<ValuesDto_reportCombinedSampleAnalysisResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_reportCombinedSampleAnalysisResultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_reportCombinedSampleAnalysisResultResponse>(null as any);
    }

    /**
     * @param language (optional) 
     * @param countryId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param own (optional) 
     * @param forCommunity (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing ReportCombinedSampleAnalysisResultResponse
     */
    listReportsSamplesAnalysisResultsReportCsv(hazardId: number, productId: number, language?: string | undefined, countryId?: number | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, own?: boolean | undefined, forCommunity?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_reportCombinedSampleAnalysisResultResponse> {
        let url_ = this.baseUrl + "/reports/samples/analysis-results-report/csv/{language}?";
        if (language !== null && language !== undefined)
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        else
            url_ = url_.replace("/{language}", "");
        if (hazardId === undefined || hazardId === null)
            throw new Error("The parameter 'hazardId' must be defined and cannot be null.");
        else
            url_ += "hazardId=" + encodeURIComponent("" + hazardId) + "&";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (own === null)
            throw new Error("The parameter 'own' cannot be null.");
        else if (own !== undefined)
            url_ += "own=" + encodeURIComponent("" + own) + "&";
        if (forCommunity === null)
            throw new Error("The parameter 'forCommunity' cannot be null.");
        else if (forCommunity !== undefined)
            url_ += "forCommunity=" + encodeURIComponent("" + forCommunity) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListReportsSamplesAnalysisResultsReportCsv(_response);
        });
    }

    protected processListReportsSamplesAnalysisResultsReportCsv(response: AxiosResponse): Promise<ValuesDto_reportCombinedSampleAnalysisResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_reportCombinedSampleAnalysisResultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_reportCombinedSampleAnalysisResultResponse>(null as any);
    }

    /**
     * @param countryId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param own (optional) 
     * @param forCommunity (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing CombinedSamplesBenchmarkReportResponse
     */
    listReportsSamplesBenchmarkReport(hazardId: number, productId: number, countryId?: number | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, own?: boolean | undefined, forCommunity?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_combinedSamplesBenchmarkReportResponse> {
        let url_ = this.baseUrl + "/reports/samples/benchmark-report?";
        if (hazardId === undefined || hazardId === null)
            throw new Error("The parameter 'hazardId' must be defined and cannot be null.");
        else
            url_ += "hazardId=" + encodeURIComponent("" + hazardId) + "&";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (own === null)
            throw new Error("The parameter 'own' cannot be null.");
        else if (own !== undefined)
            url_ += "own=" + encodeURIComponent("" + own) + "&";
        if (forCommunity === null)
            throw new Error("The parameter 'forCommunity' cannot be null.");
        else if (forCommunity !== undefined)
            url_ += "forCommunity=" + encodeURIComponent("" + forCommunity) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListReportsSamplesBenchmarkReport(_response);
        });
    }

    protected processListReportsSamplesBenchmarkReport(response: AxiosResponse): Promise<ValuesDto_combinedSamplesBenchmarkReportResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_combinedSamplesBenchmarkReportResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_combinedSamplesBenchmarkReportResponse>(null as any);
    }

    /**
     * @param language (optional) 
     * @param countryId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param own (optional) 
     * @param forCommunity (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing CombinedSamplesBenchmarkReportResponse
     */
    listReportsSamplesBenchmarkReportCsv(hazardId: number, productId: number, language?: string | undefined, countryId?: number | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, own?: boolean | undefined, forCommunity?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_combinedSamplesBenchmarkReportResponse> {
        let url_ = this.baseUrl + "/reports/samples/benchmark-report/csv/{language}?";
        if (language !== null && language !== undefined)
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        else
            url_ = url_.replace("/{language}", "");
        if (hazardId === undefined || hazardId === null)
            throw new Error("The parameter 'hazardId' must be defined and cannot be null.");
        else
            url_ += "hazardId=" + encodeURIComponent("" + hazardId) + "&";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (own === null)
            throw new Error("The parameter 'own' cannot be null.");
        else if (own !== undefined)
            url_ += "own=" + encodeURIComponent("" + own) + "&";
        if (forCommunity === null)
            throw new Error("The parameter 'forCommunity' cannot be null.");
        else if (forCommunity !== undefined)
            url_ += "forCommunity=" + encodeURIComponent("" + forCommunity) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListReportsSamplesBenchmarkReportCsv(_response);
        });
    }

    protected processListReportsSamplesBenchmarkReportCsv(response: AxiosResponse): Promise<ValuesDto_combinedSamplesBenchmarkReportResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_combinedSamplesBenchmarkReportResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_combinedSamplesBenchmarkReportResponse>(null as any);
    }

    /**
     * @param countryId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param own (optional) 
     * @param forCommunity (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing CombinedSamplesGroupedByCountryReportResponse
     */
    listReportsSamplesGroupedByCountryReport(hazardId: number, productId: number, countryId?: number | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, own?: boolean | undefined, forCommunity?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_combinedSamplesGroupedByCountryReportResponse> {
        let url_ = this.baseUrl + "/reports/samples/grouped-by-country-report?";
        if (hazardId === undefined || hazardId === null)
            throw new Error("The parameter 'hazardId' must be defined and cannot be null.");
        else
            url_ += "hazardId=" + encodeURIComponent("" + hazardId) + "&";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (own === null)
            throw new Error("The parameter 'own' cannot be null.");
        else if (own !== undefined)
            url_ += "own=" + encodeURIComponent("" + own) + "&";
        if (forCommunity === null)
            throw new Error("The parameter 'forCommunity' cannot be null.");
        else if (forCommunity !== undefined)
            url_ += "forCommunity=" + encodeURIComponent("" + forCommunity) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListReportsSamplesGroupedByCountryReport(_response);
        });
    }

    protected processListReportsSamplesGroupedByCountryReport(response: AxiosResponse): Promise<ValuesDto_combinedSamplesGroupedByCountryReportResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_combinedSamplesGroupedByCountryReportResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_combinedSamplesGroupedByCountryReportResponse>(null as any);
    }

    /**
     * @param language (optional) 
     * @param countryId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param own (optional) 
     * @param forCommunity (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing CombinedSamplesGroupedByCountryReportResponse
     */
    listReportsSamplesGroupedByCountryReportCsv(hazardId: number, productId: number, language?: string | undefined, countryId?: number | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, own?: boolean | undefined, forCommunity?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_combinedSamplesGroupedByCountryReportResponse> {
        let url_ = this.baseUrl + "/reports/samples/grouped-by-country-report/csv/{language}?";
        if (language !== null && language !== undefined)
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        else
            url_ = url_.replace("/{language}", "");
        if (hazardId === undefined || hazardId === null)
            throw new Error("The parameter 'hazardId' must be defined and cannot be null.");
        else
            url_ += "hazardId=" + encodeURIComponent("" + hazardId) + "&";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (own === null)
            throw new Error("The parameter 'own' cannot be null.");
        else if (own !== undefined)
            url_ += "own=" + encodeURIComponent("" + own) + "&";
        if (forCommunity === null)
            throw new Error("The parameter 'forCommunity' cannot be null.");
        else if (forCommunity !== undefined)
            url_ += "forCommunity=" + encodeURIComponent("" + forCommunity) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListReportsSamplesGroupedByCountryReportCsv(_response);
        });
    }

    protected processListReportsSamplesGroupedByCountryReportCsv(response: AxiosResponse): Promise<ValuesDto_combinedSamplesGroupedByCountryReportResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_combinedSamplesGroupedByCountryReportResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_combinedSamplesGroupedByCountryReportResponse>(null as any);
    }

    /**
     * @param countryId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param own (optional) 
     * @param forCommunity (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing CombinedSamplesHazardsReportResponse
     */
    listReportsSamplesHazardsReport(productId: number, countryId?: number | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, own?: boolean | undefined, forCommunity?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_combinedSamplesHazardsReportResponse> {
        let url_ = this.baseUrl + "/reports/samples/hazards?";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (own === null)
            throw new Error("The parameter 'own' cannot be null.");
        else if (own !== undefined)
            url_ += "own=" + encodeURIComponent("" + own) + "&";
        if (forCommunity === null)
            throw new Error("The parameter 'forCommunity' cannot be null.");
        else if (forCommunity !== undefined)
            url_ += "forCommunity=" + encodeURIComponent("" + forCommunity) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListReportsSamplesHazardsReport(_response);
        });
    }

    protected processListReportsSamplesHazardsReport(response: AxiosResponse): Promise<ValuesDto_combinedSamplesHazardsReportResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_combinedSamplesHazardsReportResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_combinedSamplesHazardsReportResponse>(null as any);
    }

    /**
     * @param language (optional) 
     * @param countryId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param own (optional) 
     * @param forCommunity (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing CombinedSamplesHazardsReportResponse
     */
    listReportsSamplesHazardsReportCsv(productId: number, language?: string | undefined, countryId?: number | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, own?: boolean | undefined, forCommunity?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_combinedSamplesHazardsReportResponse> {
        let url_ = this.baseUrl + "/reports/samples/hazards/csv/{language}?";
        if (language !== null && language !== undefined)
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        else
            url_ = url_.replace("/{language}", "");
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (own === null)
            throw new Error("The parameter 'own' cannot be null.");
        else if (own !== undefined)
            url_ += "own=" + encodeURIComponent("" + own) + "&";
        if (forCommunity === null)
            throw new Error("The parameter 'forCommunity' cannot be null.");
        else if (forCommunity !== undefined)
            url_ += "forCommunity=" + encodeURIComponent("" + forCommunity) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListReportsSamplesHazardsReportCsv(_response);
        });
    }

    protected processListReportsSamplesHazardsReportCsv(response: AxiosResponse): Promise<ValuesDto_combinedSamplesHazardsReportResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_combinedSamplesHazardsReportResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_combinedSamplesHazardsReportResponse>(null as any);
    }

    /**
     * @param countryId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param own (optional) 
     * @param forCommunity (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing CombinedSamplesProductsReportResponse
     */
    listReportsSamplesProductsReport(hazardId: number, countryId?: number | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, own?: boolean | undefined, forCommunity?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_combinedSamplesProductsReportResponse> {
        let url_ = this.baseUrl + "/reports/samples/products?";
        if (hazardId === undefined || hazardId === null)
            throw new Error("The parameter 'hazardId' must be defined and cannot be null.");
        else
            url_ += "hazardId=" + encodeURIComponent("" + hazardId) + "&";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (own === null)
            throw new Error("The parameter 'own' cannot be null.");
        else if (own !== undefined)
            url_ += "own=" + encodeURIComponent("" + own) + "&";
        if (forCommunity === null)
            throw new Error("The parameter 'forCommunity' cannot be null.");
        else if (forCommunity !== undefined)
            url_ += "forCommunity=" + encodeURIComponent("" + forCommunity) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListReportsSamplesProductsReport(_response);
        });
    }

    protected processListReportsSamplesProductsReport(response: AxiosResponse): Promise<ValuesDto_combinedSamplesProductsReportResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_combinedSamplesProductsReportResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_combinedSamplesProductsReportResponse>(null as any);
    }

    /**
     * @param language (optional) 
     * @param countryId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param own (optional) 
     * @param forCommunity (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing CombinedSamplesProductsReportResponse
     */
    listReportsSamplesProductsReportCsv(language?: string | undefined, countryId?: number | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, own?: boolean | undefined, forCommunity?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_combinedSamplesProductsReportResponse> {
        let url_ = this.baseUrl + "/reports/samples/products/csv/{language}?";
        if (language !== null && language !== undefined)
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        else
            url_ = url_.replace("/{language}", "");
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (own === null)
            throw new Error("The parameter 'own' cannot be null.");
        else if (own !== undefined)
            url_ += "own=" + encodeURIComponent("" + own) + "&";
        if (forCommunity === null)
            throw new Error("The parameter 'forCommunity' cannot be null.");
        else if (forCommunity !== undefined)
            url_ += "forCommunity=" + encodeURIComponent("" + forCommunity) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListReportsSamplesProductsReportCsv(_response);
        });
    }

    protected processListReportsSamplesProductsReportCsv(response: AxiosResponse): Promise<ValuesDto_combinedSamplesProductsReportResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_combinedSamplesProductsReportResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_combinedSamplesProductsReportResponse>(null as any);
    }

    /**
     * @param laboratory (optional) 
     * @param producer (optional) 
     * @param supplier (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing LocationResponse
     */
    listPortalCurrentUserLocations(laboratory?: boolean | undefined, producer?: boolean | undefined, supplier?: boolean | undefined, limit?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_locationResponse> {
        let url_ = this.baseUrl + "/portal/users/current/locations?";
        if (laboratory === null)
            throw new Error("The parameter 'laboratory' cannot be null.");
        else if (laboratory !== undefined)
            url_ += "laboratory=" + encodeURIComponent("" + laboratory) + "&";
        if (producer === null)
            throw new Error("The parameter 'producer' cannot be null.");
        else if (producer !== undefined)
            url_ += "producer=" + encodeURIComponent("" + producer) + "&";
        if (supplier === null)
            throw new Error("The parameter 'supplier' cannot be null.");
        else if (supplier !== undefined)
            url_ += "supplier=" + encodeURIComponent("" + supplier) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalCurrentUserLocations(_response);
        });
    }

    protected processListPortalCurrentUserLocations(response: AxiosResponse): Promise<ValuesDto_locationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_locationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_locationResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Location
     * @return Payload of LocationResponse
     */
    readPortalCurrentUserLocation(id?: number | undefined, signal?: AbortSignal): Promise<LocationResponse> {
        let url_ = this.baseUrl + "/portal/users/current/locations/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPortalCurrentUserLocation(_response);
        });
    }

    protected processReadPortalCurrentUserLocation(response: AxiosResponse): Promise<LocationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LocationResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationResponse>(null as any);
    }

    /**
     * @param id (optional) The Guid of the EdiIncomingSampleUpload
     * @return Payload of EdiIncomingSampleUploadResponse
     */
    readEdiIncomingSampleUpload(id?: string | undefined, signal?: AbortSignal): Promise<EdiIncomingSampleUploadResponse> {
        let url_ = this.baseUrl + "/portal/edi/incoming-sample-uploads/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadEdiIncomingSampleUpload(_response);
        });
    }

    protected processReadEdiIncomingSampleUpload(response: AxiosResponse): Promise<EdiIncomingSampleUploadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EdiIncomingSampleUploadResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EdiIncomingSampleUploadResponse>(null as any);
    }

    /**
     * @return Payload of EdiIncomingSampleUploadResponse
     */
    createEdiIncomingSampleUpload(body: CreateEdiIncomingSampleUploadRequest, signal?: AbortSignal): Promise<EdiIncomingSampleUploadResponse> {
        let url_ = this.baseUrl + "/portal/edi/incoming-sample-uploads";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEdiIncomingSampleUpload(_response);
        });
    }

    protected processCreateEdiIncomingSampleUpload(response: AxiosResponse): Promise<EdiIncomingSampleUploadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EdiIncomingSampleUploadResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EdiIncomingSampleUploadResponse>(null as any);
    }

    /**
     * @param limit (optional) 
     * @return Payload of ValuesDto containing FavouriteResponse
     */
    listPortalFavourites(kindOf: string, limit?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_favouriteResponse> {
        let url_ = this.baseUrl + "/portal/favourites?";
        if (kindOf === undefined || kindOf === null)
            throw new Error("The parameter 'kindOf' must be defined and cannot be null.");
        else
            url_ += "kindOf=" + encodeURIComponent("" + kindOf) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalFavourites(_response);
        });
    }

    protected processListPortalFavourites(response: AxiosResponse): Promise<ValuesDto_favouriteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_favouriteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_favouriteResponse>(null as any);
    }

    /**
     * @return Payload of FavouriteResponse
     */
    createPortalFavourite(body: CreateFavouriteRequest, signal?: AbortSignal): Promise<FavouriteResponse> {
        let url_ = this.baseUrl + "/portal/favourites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePortalFavourite(_response);
        });
    }

    protected processCreatePortalFavourite(response: AxiosResponse): Promise<FavouriteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FavouriteResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FavouriteResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Favourite
     */
    deletePortalFavourite(id?: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/portal/favourites/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePortalFavourite(_response);
        });
    }

    protected processDeletePortalFavourite(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param search (optional) 
     * @param productGroupCode (optional) 
     * @param isActiveMonitoring (optional) 
     * @param isExpired (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing ProductAutocompleteResponse
     */
    listPortalFeedMaterialsAutocomplete(search?: string | undefined, productGroupCode?: string | undefined, isActiveMonitoring?: boolean | undefined, isExpired?: boolean | undefined, limit?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_productAutocompleteResponse> {
        let url_ = this.baseUrl + "/portal/feed-materials:autocomplete?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (productGroupCode === null)
            throw new Error("The parameter 'productGroupCode' cannot be null.");
        else if (productGroupCode !== undefined)
            url_ += "productGroupCode=" + encodeURIComponent("" + productGroupCode) + "&";
        if (isActiveMonitoring === null)
            throw new Error("The parameter 'isActiveMonitoring' cannot be null.");
        else if (isActiveMonitoring !== undefined)
            url_ += "isActiveMonitoring=" + encodeURIComponent("" + isActiveMonitoring) + "&";
        if (isExpired === null)
            throw new Error("The parameter 'isExpired' cannot be null.");
        else if (isExpired !== undefined)
            url_ += "isExpired=" + encodeURIComponent("" + isExpired) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalFeedMaterialsAutocomplete(_response);
        });
    }

    protected processListPortalFeedMaterialsAutocomplete(response: AxiosResponse): Promise<ValuesDto_productAutocompleteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_productAutocompleteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_productAutocompleteResponse>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @param productGroupCode (optional) 
     * @param isActiveMonitoring (optional) 
     * @param isExpired (optional) 
     * @param productIds (optional) 
     * @return List of products
     */
    listPortalFeedMaterials(page?: number | undefined, pageSize?: number | undefined, search?: string | undefined, productGroupCode?: string | undefined, isActiveMonitoring?: boolean | undefined, isExpired?: boolean | undefined, productIds?: string | undefined, signal?: AbortSignal): Promise<ValuesDto_productResponse> {
        let url_ = this.baseUrl + "/portal/feed-materials?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (productGroupCode === null)
            throw new Error("The parameter 'productGroupCode' cannot be null.");
        else if (productGroupCode !== undefined)
            url_ += "productGroupCode=" + encodeURIComponent("" + productGroupCode) + "&";
        if (isActiveMonitoring === null)
            throw new Error("The parameter 'isActiveMonitoring' cannot be null.");
        else if (isActiveMonitoring !== undefined)
            url_ += "isActiveMonitoring=" + encodeURIComponent("" + isActiveMonitoring) + "&";
        if (isExpired === null)
            throw new Error("The parameter 'isExpired' cannot be null.");
        else if (isExpired !== undefined)
            url_ += "isExpired=" + encodeURIComponent("" + isExpired) + "&";
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            url_ += "productIds=" + encodeURIComponent("" + productIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalFeedMaterials(_response);
        });
    }

    protected processListPortalFeedMaterials(response: AxiosResponse): Promise<ValuesDto_productResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_productResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_productResponse>(null as any);
    }

    /**
     * @param search (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing HazardAutocompleteResponse
     */
    listPortalHazardsAutocomplete(search?: string | undefined, limit?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_hazardAutocompleteResponse> {
        let url_ = this.baseUrl + "/portal/hazards:autocomplete?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalHazardsAutocomplete(_response);
        });
    }

    protected processListPortalHazardsAutocomplete(response: AxiosResponse): Promise<ValuesDto_hazardAutocompleteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_hazardAutocompleteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_hazardAutocompleteResponse>(null as any);
    }

    /**
     * @return CSV format
     */
    listPortalHazardsCsv(language: string, signal?: AbortSignal): Promise<ContentResult> {
        let url_ = this.baseUrl + "/portal/hazards/csv/{language}";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/csv"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalHazardsCsv(_response);
        });
    }

    protected processListPortalHazardsCsv(response: AxiosResponse): Promise<ContentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ContentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentResult>(null as any);
    }

    /**
     * @param productIds (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing HazardResponse
     */
    listPortalHazardsReport(productIds?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_hazardResponse> {
        let url_ = this.baseUrl + "/portal/hazards/report?";
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            url_ += "productIds=" + encodeURIComponent("" + productIds) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalHazardsReport(_response);
        });
    }

    protected processListPortalHazardsReport(response: AxiosResponse): Promise<ValuesDto_hazardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_hazardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_hazardResponse>(null as any);
    }

    /**
     * @param search (optional) 
     * @param category (optional) 
     * @param severity (optional) 
     * @param parentHazardIds (optional) 
     * @param hazardIds (optional) 
     * @param factsheetIncluded (optional) 
     * @param isFavourite (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @param orderByDesc (optional) 
     * @return Payload of ValuesDto containing HazardResponse
     */
    listPortalHazards(search?: string | undefined, category?: string | undefined, severity?: string | undefined, parentHazardIds?: string | undefined, hazardIds?: string | undefined, factsheetIncluded?: boolean | undefined, isFavourite?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined, orderByDesc?: string | undefined, signal?: AbortSignal): Promise<ValuesDto_hazardResponse> {
        let url_ = this.baseUrl + "/portal/hazards?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        if (severity === null)
            throw new Error("The parameter 'severity' cannot be null.");
        else if (severity !== undefined)
            url_ += "severity=" + encodeURIComponent("" + severity) + "&";
        if (parentHazardIds === null)
            throw new Error("The parameter 'parentHazardIds' cannot be null.");
        else if (parentHazardIds !== undefined)
            url_ += "parentHazardIds=" + encodeURIComponent("" + parentHazardIds) + "&";
        if (hazardIds === null)
            throw new Error("The parameter 'hazardIds' cannot be null.");
        else if (hazardIds !== undefined)
            url_ += "hazardIds=" + encodeURIComponent("" + hazardIds) + "&";
        if (factsheetIncluded === null)
            throw new Error("The parameter 'factsheetIncluded' cannot be null.");
        else if (factsheetIncluded !== undefined)
            url_ += "factsheetIncluded=" + encodeURIComponent("" + factsheetIncluded) + "&";
        if (isFavourite === null)
            throw new Error("The parameter 'isFavourite' cannot be null.");
        else if (isFavourite !== undefined)
            url_ += "isFavourite=" + encodeURIComponent("" + isFavourite) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDesc === null)
            throw new Error("The parameter 'orderByDesc' cannot be null.");
        else if (orderByDesc !== undefined)
            url_ += "orderByDesc=" + encodeURIComponent("" + orderByDesc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalHazards(_response);
        });
    }

    protected processListPortalHazards(response: AxiosResponse): Promise<ValuesDto_hazardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_hazardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_hazardResponse>(null as any);
    }

    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @param orderByDesc (optional) 
     * @return Payload of ValuesDto containing HazardResponse
     */
    listPortalParentHazards(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | undefined, orderByDesc?: string | undefined, signal?: AbortSignal): Promise<ValuesDto_hazardResponse> {
        let url_ = this.baseUrl + "/portal/hazards/parent?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDesc === null)
            throw new Error("The parameter 'orderByDesc' cannot be null.");
        else if (orderByDesc !== undefined)
            url_ += "orderByDesc=" + encodeURIComponent("" + orderByDesc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalParentHazards(_response);
        });
    }

    protected processListPortalParentHazards(response: AxiosResponse): Promise<ValuesDto_hazardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_hazardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_hazardResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Hazard
     * @return Payload of HazardResponse
     */
    readPortalHazard(id?: number | undefined, signal?: AbortSignal): Promise<HazardResponse> {
        let url_ = this.baseUrl + "/portal/hazards/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPortalHazard(_response);
        });
    }

    protected processReadPortalHazard(response: AxiosResponse): Promise<HazardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HazardResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HazardResponse>(null as any);
    }

    /**
     * @param search (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing MethodAutocompleteResponse
     */
    listPortalMethodsAutocomplete(search?: string | undefined, limit?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_methodAutocompleteResponse> {
        let url_ = this.baseUrl + "/portal/methods:autocomplete?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalMethodsAutocomplete(_response);
        });
    }

    protected processListPortalMethodsAutocomplete(response: AxiosResponse): Promise<ValuesDto_methodAutocompleteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_methodAutocompleteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_methodAutocompleteResponse>(null as any);
    }

    /**
     * @return CSV format
     */
    listPortalMethodsCsv(language: string, signal?: AbortSignal): Promise<ContentResult> {
        let url_ = this.baseUrl + "/portal/methods/csv/{language}";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/csv"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalMethodsCsv(_response);
        });
    }

    protected processListPortalMethodsCsv(response: AxiosResponse): Promise<ContentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ContentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentResult>(null as any);
    }

    /**
     * @param search (optional) 
     * @param orderBy (optional) 
     * @param orderByDesc (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing MethodResponse
     */
    listPortalMethods(search?: string | undefined, orderBy?: string | undefined, orderByDesc?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_methodResponse> {
        let url_ = this.baseUrl + "/portal/methods?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDesc === null)
            throw new Error("The parameter 'orderByDesc' cannot be null.");
        else if (orderByDesc !== undefined)
            url_ += "orderByDesc=" + encodeURIComponent("" + orderByDesc) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalMethods(_response);
        });
    }

    protected processListPortalMethods(response: AxiosResponse): Promise<ValuesDto_methodResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_methodResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_methodResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the Method
     * @return Payload of MethodResponse
     */
    readPortalMethod(id?: number | undefined, signal?: AbortSignal): Promise<MethodResponse> {
        let url_ = this.baseUrl + "/portal/methods/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPortalMethod(_response);
        });
    }

    protected processReadPortalMethod(response: AxiosResponse): Promise<MethodResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MethodResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MethodResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the ProcessingAidGroup
     * @param language (optional) The language to read
     * @return Payload of File
     */
    readPortalPdfProcessingAidGroup(id?: number | undefined, language?: string | undefined, signal?: AbortSignal): Promise<File> {
        let url_ = this.baseUrl + "/portal/processing-aid-groups/{id}/pdf/{language}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        if (language !== null && language !== undefined)
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        else
            url_ = url_.replace("/{language}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPortalPdfProcessingAidGroup(_response);
        });
    }

    protected processReadPortalPdfProcessingAidGroup(response: AxiosResponse): Promise<File> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<File>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<File>(null as any);
    }

    /**
     * @param id (optional) The id of the Hazard
     * @param language (optional) The language to read
     * @return Payload of File
     */
    readPortalPdfHazard(id?: number | undefined, language?: string | undefined, signal?: AbortSignal): Promise<File> {
        let url_ = this.baseUrl + "/portal/hazards/{id}/pdf/{language}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        if (language !== null && language !== undefined)
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        else
            url_ = url_.replace("/{language}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPortalPdfHazard(_response);
        });
    }

    protected processReadPortalPdfHazard(response: AxiosResponse): Promise<File> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<File>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<File>(null as any);
    }

    /**
     * @param id (optional) The id of the RiskAssessment
     * @param language (optional) The language to read
     * @return Payload of File
     */
    readPortalPdfRiskAssessment(id?: number | undefined, language?: string | undefined, signal?: AbortSignal): Promise<File> {
        let url_ = this.baseUrl + "/portal/risk-assessments/{id}/pdf/{language}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        if (language !== null && language !== undefined)
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        else
            url_ = url_.replace("/{language}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPortalPdfRiskAssessment(_response);
        });
    }

    protected processReadPortalPdfRiskAssessment(response: AxiosResponse): Promise<File> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<File>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<File>(null as any);
    }

    /**
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Payload of ValuesDto containing ProductResponse
     */
    listPortalProducts(search?: string | undefined, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_productResponse> {
        let url_ = this.baseUrl + "/portal/products?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalProducts(_response);
        });
    }

    protected processListPortalProducts(response: AxiosResponse): Promise<ValuesDto_productResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_productResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_productResponse>(null as any);
    }

    /**
     * @param search (optional) 
     * @param productGroupCode (optional) 
     * @param productGroupCategory (optional) 
     * @param isActiveMonitoring (optional) 
     * @param isExpired (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing ProductAutocompleteResponse
     */
    listPortalProductsAutocomplete(search?: string | undefined, productGroupCode?: string | undefined, productGroupCategory?: string | undefined, isActiveMonitoring?: boolean | undefined, isExpired?: boolean | undefined, limit?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_productAutocompleteResponse> {
        let url_ = this.baseUrl + "/portal/products:autocomplete?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (productGroupCode === null)
            throw new Error("The parameter 'productGroupCode' cannot be null.");
        else if (productGroupCode !== undefined)
            url_ += "productGroupCode=" + encodeURIComponent("" + productGroupCode) + "&";
        if (productGroupCategory === null)
            throw new Error("The parameter 'productGroupCategory' cannot be null.");
        else if (productGroupCategory !== undefined)
            url_ += "productGroupCategory=" + encodeURIComponent("" + productGroupCategory) + "&";
        if (isActiveMonitoring === null)
            throw new Error("The parameter 'isActiveMonitoring' cannot be null.");
        else if (isActiveMonitoring !== undefined)
            url_ += "isActiveMonitoring=" + encodeURIComponent("" + isActiveMonitoring) + "&";
        if (isExpired === null)
            throw new Error("The parameter 'isExpired' cannot be null.");
        else if (isExpired !== undefined)
            url_ += "isExpired=" + encodeURIComponent("" + isExpired) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalProductsAutocomplete(_response);
        });
    }

    protected processListPortalProductsAutocomplete(response: AxiosResponse): Promise<ValuesDto_productAutocompleteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_productAutocompleteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_productAutocompleteResponse>(null as any);
    }

    /**
     * @return CSV format
     */
    listPortalProductsCsv2(language: string, signal?: AbortSignal): Promise<ContentResult> {
        let url_ = this.baseUrl + "/portal/products/csv/{language}";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/csv"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalProductsCsv2(_response);
        });
    }

    protected processListPortalProductsCsv2(response: AxiosResponse): Promise<ContentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ContentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentResult>(null as any);
    }

    /**
     * @param id (optional) The id of the Product
     * @return Payload of ProductResponse
     */
    readPortalProduct(id?: number | undefined, signal?: AbortSignal): Promise<ProductResponse> {
        let url_ = this.baseUrl + "/portal/products/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPortalProduct(_response);
        });
    }

    protected processReadPortalProduct(response: AxiosResponse): Promise<ProductResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProductResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductResponse>(null as any);
    }

    /**
     * @param search (optional) 
     * @param productGroupCode (optional) 
     * @param productGroupCategory (optional) 
     * @param isActiveMonitoring (optional) 
     * @param isExpired (optional) 
     * @param limit (optional) 
     * @return Payload of ValuesDto containing ProductOrMyProductAutocompleteResponse
     */
    listPortalProductsOrMyProductsAutocomplete(search?: string | undefined, productGroupCode?: string | undefined, productGroupCategory?: string | undefined, isActiveMonitoring?: boolean | undefined, isExpired?: boolean | undefined, limit?: number | undefined, signal?: AbortSignal): Promise<ValuesDto_productOrMyProductAutocompleteResponse> {
        let url_ = this.baseUrl + "/portal/products-or-my-products:autocomplete?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (productGroupCode === null)
            throw new Error("The parameter 'productGroupCode' cannot be null.");
        else if (productGroupCode !== undefined)
            url_ += "productGroupCode=" + encodeURIComponent("" + productGroupCode) + "&";
        if (productGroupCategory === null)
            throw new Error("The parameter 'productGroupCategory' cannot be null.");
        else if (productGroupCategory !== undefined)
            url_ += "productGroupCategory=" + encodeURIComponent("" + productGroupCategory) + "&";
        if (isActiveMonitoring === null)
            throw new Error("The parameter 'isActiveMonitoring' cannot be null.");
        else if (isActiveMonitoring !== undefined)
            url_ += "isActiveMonitoring=" + encodeURIComponent("" + isActiveMonitoring) + "&";
        if (isExpired === null)
            throw new Error("The parameter 'isExpired' cannot be null.");
        else if (isExpired !== undefined)
            url_ += "isExpired=" + encodeURIComponent("" + isExpired) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalProductsOrMyProductsAutocomplete(_response);
        });
    }

    protected processListPortalProductsOrMyProductsAutocomplete(response: AxiosResponse): Promise<ValuesDto_productOrMyProductAutocompleteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_productOrMyProductAutocompleteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_productOrMyProductAutocompleteResponse>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param search (optional) 
     * @param publicationDateFrom (optional) 
     * @param publicationDateTo (optional) 
     * @param lastModifiedAtFrom (optional) 
     * @param lastModifiedAtTo (optional) 
     * @param orderBy (optional) 
     * @param orderByDesc (optional) 
     * @param hazardIds (optional) 
     * @param productIds (optional) 
     * @param processingAidIds (optional) 
     * @param isFavourite (optional) 
     * @return Payload of ValuesDto containing RiskAssessmentResponse
     */
    listPortalRiskAssessmentsPublished(page?: number | undefined, pageSize?: number | undefined, search?: string | undefined, publicationDateFrom?: Date | undefined, publicationDateTo?: Date | undefined, lastModifiedAtFrom?: Date | undefined, lastModifiedAtTo?: Date | undefined, orderBy?: string | undefined, orderByDesc?: string | undefined, hazardIds?: string | undefined, productIds?: string | undefined, processingAidIds?: string | undefined, isFavourite?: boolean | undefined, signal?: AbortSignal): Promise<ValuesDto_riskAssessmentResponse> {
        let url_ = this.baseUrl + "/portal/risk-assessments/published?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (publicationDateFrom === null)
            throw new Error("The parameter 'publicationDateFrom' cannot be null.");
        else if (publicationDateFrom !== undefined)
            url_ += "publicationDateFrom=" + encodeURIComponent(publicationDateFrom ? "" + publicationDateFrom.toISOString() : "") + "&";
        if (publicationDateTo === null)
            throw new Error("The parameter 'publicationDateTo' cannot be null.");
        else if (publicationDateTo !== undefined)
            url_ += "publicationDateTo=" + encodeURIComponent(publicationDateTo ? "" + publicationDateTo.toISOString() : "") + "&";
        if (lastModifiedAtFrom === null)
            throw new Error("The parameter 'lastModifiedAtFrom' cannot be null.");
        else if (lastModifiedAtFrom !== undefined)
            url_ += "lastModifiedAtFrom=" + encodeURIComponent(lastModifiedAtFrom ? "" + lastModifiedAtFrom.toISOString() : "") + "&";
        if (lastModifiedAtTo === null)
            throw new Error("The parameter 'lastModifiedAtTo' cannot be null.");
        else if (lastModifiedAtTo !== undefined)
            url_ += "lastModifiedAtTo=" + encodeURIComponent(lastModifiedAtTo ? "" + lastModifiedAtTo.toISOString() : "") + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDesc === null)
            throw new Error("The parameter 'orderByDesc' cannot be null.");
        else if (orderByDesc !== undefined)
            url_ += "orderByDesc=" + encodeURIComponent("" + orderByDesc) + "&";
        if (hazardIds === null)
            throw new Error("The parameter 'hazardIds' cannot be null.");
        else if (hazardIds !== undefined)
            url_ += "hazardIds=" + encodeURIComponent("" + hazardIds) + "&";
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            url_ += "productIds=" + encodeURIComponent("" + productIds) + "&";
        if (processingAidIds === null)
            throw new Error("The parameter 'processingAidIds' cannot be null.");
        else if (processingAidIds !== undefined)
            url_ += "processingAidIds=" + encodeURIComponent("" + processingAidIds) + "&";
        if (isFavourite === null)
            throw new Error("The parameter 'isFavourite' cannot be null.");
        else if (isFavourite !== undefined)
            url_ += "isFavourite=" + encodeURIComponent("" + isFavourite) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPortalRiskAssessmentsPublished(_response);
        });
    }

    protected processListPortalRiskAssessmentsPublished(response: AxiosResponse): Promise<ValuesDto_riskAssessmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValuesDto_riskAssessmentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValuesDto_riskAssessmentResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the RiskAssessment
     * @return Payload of RiskAssessmentResponse
     */
    readPortalRiskAssessment(id?: number | undefined, signal?: AbortSignal): Promise<RiskAssessmentResponse> {
        let url_ = this.baseUrl + "/portal/risk-assessments/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPortalRiskAssessment(_response);
        });
    }

    protected processReadPortalRiskAssessment(response: AxiosResponse): Promise<RiskAssessmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentResponse>(null as any);
    }

    /**
     * @param sampleId (optional) The sampleId of the Sample
     * @return Payload of SampleDataMonitoringGroupResponse
     */
    createPortalSampleDataMonitoringGroup(body: CreateSampleDataMonitoringGroupRequest, sampleId?: string | undefined, signal?: AbortSignal): Promise<SampleDataMonitoringGroupResponse> {
        let url_ = this.baseUrl + "/portal/samples/{sampleId}/sample-data-monitoring-groups";
        if (sampleId !== null && sampleId !== undefined)
        url_ = url_.replace("{sampleId}", encodeURIComponent("" + sampleId));
        else
            url_ = url_.replace("/{sampleId}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePortalSampleDataMonitoringGroup(_response);
        });
    }

    protected processCreatePortalSampleDataMonitoringGroup(response: AxiosResponse): Promise<SampleDataMonitoringGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SampleDataMonitoringGroupResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SampleDataMonitoringGroupResponse>(null as any);
    }

    /**
     * @param sampleId (optional) The sampleId of the Sample
     * @param id (optional) The id of the SampleDataMonitoringGroup
     */
    deletePortalSampleDataMonitoringGroup(sampleId?: string | undefined, id?: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/portal/samples/{sampleId}/sample-data-monitoring-groups/{id}";
        if (sampleId !== null && sampleId !== undefined)
        url_ = url_.replace("{sampleId}", encodeURIComponent("" + sampleId));
        else
            url_ = url_.replace("/{sampleId}", "");
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePortalSampleDataMonitoringGroup(_response);
        });
    }

    protected processDeletePortalSampleDataMonitoringGroup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) The id of the Hazard
     * @return Payload of HazardResponse
     */
    readPdfHazard(id?: number | undefined, signal?: AbortSignal): Promise<HazardResponse> {
        let url_ = this.baseUrl + "/GetPdfHazard";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPdfHazard(_response);
        });
    }

    protected processReadPdfHazard(response: AxiosResponse): Promise<HazardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HazardResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HazardResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the ProcessingAidGroup
     * @return Payload of ProcessingAidGroupResponse
     */
    readPdfProcessingAidGroup(id?: number | undefined, signal?: AbortSignal): Promise<ProcessingAidGroupResponse> {
        let url_ = this.baseUrl + "/GetPdfProcessingAidGroup";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPdfProcessingAidGroup(_response);
        });
    }

    protected processReadPdfProcessingAidGroup(response: AxiosResponse): Promise<ProcessingAidGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProcessingAidGroupResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessingAidGroupResponse>(null as any);
    }

    /**
     * @param id (optional) The id of the RiskAssessment
     * @return Payload of RiskAssessmentResponse
     */
    readPdfRiskAssessment(id?: number | undefined, signal?: AbortSignal): Promise<RiskAssessmentResponse> {
        let url_ = this.baseUrl + "/GetPdfRiskAssessment";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadPdfRiskAssessment(_response);
        });
    }

    protected processReadPdfRiskAssessment(response: AxiosResponse): Promise<RiskAssessmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RiskAssessmentResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentResponse>(null as any);
    }

    /**
     * @return Payload of EdiIncomingSampleExcelResponse
     */
    createEdiIncomingSampleExcel(body: CreateEdiIncomingSampleExcelRequest, signal?: AbortSignal): Promise<EdiIncomingSampleExcelResponse> {
        let url_ = this.baseUrl + "/CreateEdiIncomingSampleExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEdiIncomingSampleExcel(_response);
        });
    }

    protected processCreateEdiIncomingSampleExcel(response: AxiosResponse): Promise<EdiIncomingSampleExcelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EdiIncomingSampleExcelResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EdiIncomingSampleExcelResponse>(null as any);
    }

    /**
     * @return Payload of EdiIncomingSampleExcelResponse
     */
    createEdiIncomingSampleExcel2(body: ValidateEdiIncomingSampleExcelRequest, signal?: AbortSignal): Promise<EdiIncomingSampleExcelResponse> {
        let url_ = this.baseUrl + "/ValidateEdiIncomingSampleExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEdiIncomingSampleExcel2(_response);
        });
    }

    protected processCreateEdiIncomingSampleExcel2(response: AxiosResponse): Promise<EdiIncomingSampleExcelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EdiIncomingSampleExcelResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EdiIncomingSampleExcelResponse>(null as any);
    }

    /**
     * @return Payload of EdiIncomingSampleXmlResponse
     */
    createEdiIncomingSampleXml(body: CreateEdiIncomingSampleXmlRequest, signal?: AbortSignal): Promise<EdiIncomingSampleXmlResponse> {
        let url_ = this.baseUrl + "/CreateEdiIncomingSampleXml";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEdiIncomingSampleXml(_response);
        });
    }

    protected processCreateEdiIncomingSampleXml(response: AxiosResponse): Promise<EdiIncomingSampleXmlResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EdiIncomingSampleXmlResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EdiIncomingSampleXmlResponse>(null as any);
    }

    /**
     * @return Payload of EdiIncomingSampleXmlResponse
     */
    createEdiIncomingSampleXml2(body: ValidateEdiIncomingSampleXmlRequest, signal?: AbortSignal): Promise<EdiIncomingSampleXmlResponse> {
        let url_ = this.baseUrl + "/ValidateEdiIncomingSampleXml";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEdiIncomingSampleXml2(_response);
        });
    }

    protected processCreateEdiIncomingSampleXml2(response: AxiosResponse): Promise<EdiIncomingSampleXmlResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EdiIncomingSampleXmlResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EdiIncomingSampleXmlResponse>(null as any);
    }
}

export interface AnalysisAssignmentPlannedRelationResponse {
    id: string;
    hazardId: number;
    combinedSampleId: string;
    detectionBorderValue: number | undefined;
    hazard: HazardRelationResponse;

    [key: string]: any;
}

export interface AnalysisAssignmentRelationResponse {
    id: string;
    hazard: HazardRelationResponse;

    [key: string]: any;
}

export interface AnalysisReport {
    guid: string;
    combinedSampleId: string;
    userId: number | undefined;
    laboratoryLocationId: number | undefined;
    code: string;
    explanation: string;
    moisturePercentage: number;
    source: string;
    date: Date;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    analysisResults: AnalysisResult[];
    combinedSample: CombinedSample;
    laboratoryLocation: Location;
    user: User;

    [key: string]: any;
}

export interface AnalysisReportRelationResponse {
    guid: string;
    combinedSampleId: string;
    userId: number | undefined;
    laboratoryLocationId: number | undefined;
    code: string;
    explanation: string;
    moisturePercentage: number;
    source: string;
    date: Date;
    laboratoryLocation: LocationRelationResponse;
    analysisResults: AnalysisResultRelationResponse[];

    [key: string]: any;
}

export interface AnalysisReportResponse {
    guid: string;
    combinedSampleId: string;
    userId: number | undefined;
    laboratoryLocationId: number | undefined;
    code: string;
    source: string;
    date: Date;
    analysisResults: AnalysisResultRelationResponse[];
    laboratoryRelation: LocationRelationResponse;

    [key: string]: any;
}

export interface AnalysisResult {
    kindOf: number;
    guid: string;
    analysisReportGuid: string;
    hazardId: number;
    methodId: number | undefined;
    methodText: string;
    unitId: number | undefined;
    value: number | undefined;
    valueText: string;
    valueProductOfDs: number | undefined;
    detectionBorderUnitId: number | undefined;
    detectionBorderValue: number | undefined;
    hazardType: string;
    presentType: string;
    largerThanValue: number | undefined;
    laboratoryLocationId: number | undefined;
    symbol: number;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    moisturePercentage: number | undefined;
    valueComputed: number | undefined;
    valueConverted: number | undefined;
    analysisReport: AnalysisReport;
    detectionBorderUnit: Unit;
    hazard: Hazard;
    laboratoryLocation: Location;
    method: Method;
    unit: Unit;

    [key: string]: any;
}

export interface AnalysisResultRelationResponse {
    kindOf: AnalysisResultRelationResponseKindOf;
    guid: string;
    analysisReportGuid: string;
    hazardId: number;
    methodId: number | undefined;
    methodText: string;
    unitId: number | undefined;
    value: number | undefined;
    valueProductOfDs: number | undefined;
    hazardType: string;
    presentType: string;
    symbol: AnalysisResultRelationResponseSymbol;

    [key: string]: any;
}

export interface AnalysisResultResponse {
    kindOf: AnalysisResultResponseKindOf;
    guid: string;
    analysisReportGuid: string;
    hazardId: number;
    methodId: number | undefined;
    methodText: string;
    unitId: number | undefined;
    value: number | undefined;
    valueProductOfDs: number | undefined;
    hazardType: string;
    presentType: string;
    symbol: AnalysisResultResponseSymbol;

    [key: string]: any;
}

export interface AnalysisSet {
    id: number;
    locationId: number;
    name: string;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    analysisSetItems: AnalysisSetItem[];
    location: Location;

    [key: string]: any;
}

export interface AnalysisSetAutocompleteResponse {
    id: number;
    locationId: number;
    name: string;

    [key: string]: any;
}

export interface AnalysisSetItem {
    id: number;
    analysisSetId: number;
    hazardId: number;
    methodId: number | undefined;
    detectionBorderValue: number | undefined;
    sortOrder: number;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    analysisSet: AnalysisSet;
    hazard: Hazard;
    method: Method;

    [key: string]: any;
}

export interface AnalysisSetItemRelationResponse {
    id: number;
    analysisSetId: number;
    hazardId: number;
    methodId: number | undefined;
    detectionBorderValue: number | undefined;
    sortOrder: number;
    hazard: HazardRelationResponse;
    method: MethodRelationResponse;

    [key: string]: any;
}

export interface AnalysisSetResponse {
    id: number;
    locationId: number;
    name: string;
    analysisSetItems: AnalysisSetItemRelationResponse[];
    location: LocationRelationResponse;

    [key: string]: any;
}

export interface CombinedAnalysisAssignment {
    kindOf: number;
    id: string;
    hazardId: number;
    combinedSampleId: string;
    detectionBorderValue: number | undefined;
    analysisAssignmentId: number | undefined;
    analysisAssignmentPlannedId: number | undefined;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    combinedSample: CombinedSample;
    hazard: Hazard;

    [key: string]: any;
}

export interface CombinedSample {
    kindOf: number;
    id: string;
    parentSampleGuid: string | undefined;
    parentPlannedSampleGuid: string | undefined;
    sampleDataId: number | undefined;
    sampleId: number | undefined;
    plannedSampleId: number | undefined;
    userId: number | undefined;
    productId: number;
    myProductId: number | undefined;
    monitoringGroupId: number | undefined;
    locationId: number;
    sampleNumber: string;
    countryCode3: string;
    countryId: number | undefined;
    forCommunity: number | undefined;
    laboratoryLocationId: number | undefined;
    plannedSampleNumber: string;
    sampleType: string;
    year: number | undefined;
    quarter: number | undefined;
    month: number | undefined;
    date: Date | undefined;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    status: number;
    level: number;
    priority: number;
    sampleDataMyProductId: number | undefined;
    sampleDataLocationId: number | undefined;
    originLocationId: number | undefined;
    producerLocationId: number | undefined;
    supplierLocationId: number | undefined;
    sampleDataStatus: string;
    batchNumber: string;
    statusResetDate: Date | undefined;
    parentSampleId: number | undefined;
    parentPlannedSampleId: number | undefined;
    characteristics: string;
    createdFromPlannedSampleId: string | undefined;
    isDeleted: boolean;
    deletedBy: number | undefined;
    deletedAt: Date | undefined;
    ediIncomingSampleFileId: string | undefined;
    combinedAnalysisAssignments: CombinedAnalysisAssignment[];
    analysisReports: AnalysisReport[];
    country: Country;
    inverseCreatedFromPlannedSample: CombinedSample[];
    inverseParentPlannedSample: CombinedSample[];
    inverseParentSample: CombinedSample[];
    ediIncomingSampleFile: EdiIncomingSampleFile;
    location: Location;
    monitoringGroup: MonitoringGroup;
    myProduct: MyProduct;
    producerLocation: Location;
    product: Product;
    laboratoryLocation: Location;
    sampleCharacteristicsSampleData: SampleCharacteristicsSampleDatum[];
    sampleDataMonitoringGroups: SampleDataMonitoringGroup[];
    supplierLocation: Location;
    originLocation: Location;
    user: User;
    archived: boolean;
    createdFromPlannedSample: CombinedSample;
    parentPlannedSample: CombinedSample;
    parentSample: CombinedSample;

    [key: string]: any;
}

export interface CombinedSampleRelationResponse {
    kindOf: string;
    id: string;
    locationId: number;
    sampleNumber: string;

    [key: string]: any;
}

export interface CombinedSampleResponse {
    kindOf: string;
    id: string;
    sampleNumber: string;
    forCommunity: boolean | undefined;
    sampleType: string;
    date: Date | undefined;
    lastModifiedAt: Date;
    status: string;
    level: string;
    location: LocationRelationResponse;
    product: ProductRelationResponse;
    myProduct: MyProductRelationResponse;

    [key: string]: any;
}

export interface CombinedSamplesBenchmarkReportResponse {
    level: string;
    productId: number;
    hazardId: number | undefined;
    nrBelowRejectionValue: number;
    nrBetweenRejectionValues: number;
    nrAboveRejectionValue: number;
    nrOfTotalResults: number;

    [key: string]: any;
}

export interface CombinedSamplesGroupedByCountryReportResponse {
    countryId: number | undefined;
    productId: number;
    hazardId: number | undefined;
    countryNameAsJson: JsonTranslation;
    nrBelowRejectionValue: number;
    nrBetweenRejectionValues: number;
    nrAboveRejectionValue: number;
    nrOfTotalResults: number;
    country: Country;

    [key: string]: any;
}

export interface CombinedSamplesHazardsReportResponse {
    hazardId: number;
    productId: number;
    parentHazardNameAsJson: JsonTranslation;
    unitNameAsJson: JsonTranslation;
    unitId: number | undefined;
    parentHazardId: number | undefined;
    nameAsJson: JsonTranslation;
    limitMinRejectionValue: number | undefined;
    limitMaxRejectionValue: number | undefined;
    limitUnitNameAsJson: JsonTranslation;
    nrBelowRejectionValue: number;
    nrBetweenRejectionValues: number;
    nrAboveRejectionValue: number;
    nrOfTotalResults: number;

    [key: string]: any;
}

export interface CombinedSamplesProductsReportResponse {
    productId: number;
    hazardId: number;
    productGroupId: number;
    code: string;
    nameAsJson: JsonTranslation;
    nrBelowRejectionValue: number;
    nrBetweenRejectionValues: number;
    nrAboveRejectionValue: number;
    nrOfTotalResults: number;

    [key: string]: any;
}

export interface ContentResult {
    content: string;
    contentType: string;
    statusCode: number | undefined;

    [key: string]: any;
}

export interface ControlMeasure {
    id: number;
    controlMeasureGroupId: number;
    nameAsJson: JsonTranslation;
    vName_en: string;
    vName_nl: string;
    vName_de: string;
    descriptionAsJson: JsonTranslation;
    vDescription_en: string;
    vDescription_nl: string;
    vDescription_de: string;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    controlMeasureGroup: ControlMeasureGroup;
    hazardsControlMeasures: HazardsControlMeasure[];
    riskAssessmentsProcessStepsHazardsControlMeasures: RiskAssessmentsProcessStepsHazardsControlMeasure[];

    [key: string]: any;
}

export interface ControlMeasureGroup {
    id: number;
    nameAsJson: JsonTranslation;
    vName_en: string;
    vName_nl: string;
    vName_de: string;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    controlMeasures: ControlMeasure[];

    [key: string]: any;
}

export interface ControlMeasureGroupResponse {
    id: number;
    nameAsJson: JsonTranslation;

    [key: string]: any;
}

export interface ControlMeasureRelationResponse {
    id: number;
    controlMeasureGroupId: number;
    groupNameAsJson: JsonTranslation;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;

    [key: string]: any;
}

export interface ControlMeasureResponse {
    id: number;
    controlMeasureGroupId: number;
    groupNameAsJson: JsonTranslation;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;

    [key: string]: any;
}

export interface CopiedSampleResponse {
    kindOf: CopiedSampleResponseKindOf;
    id: string;
    parentSampleGuid: string | undefined;
    parentPlannedSampleGuid: string | undefined;
    sampleDataId: number | undefined;
    sampleId: number | undefined;
    plannedSampleId: number | undefined;
    userId: number | undefined;
    productId: number;
    myProductId: number | undefined;
    monitoringGroupId: number | undefined;
    locationId: number | undefined;
    sampleNumber: string;
    countryCode3: string;
    countryId: number | undefined;
    forCommunity: boolean | undefined;
    laboratoryLocationId: number | undefined;
    plannedSampleNumber: number | undefined;
    sampleType: string;
    year: number | undefined;
    quarter: number | undefined;
    month: number | undefined;
    date: Date | undefined;
    lastModifiedAt: Date;
    status: string;
    level: string;
    priority: number;
    originLocationId: number | undefined;
    sampleDataStatus: string;
    batchNumber: string;
    statusResetDate: Date | undefined;
    parentSampleId: number | undefined;
    parentPlannedSampleId: number | undefined;
    producerLocationId: number | undefined;
    supplierLocationId: number | undefined;
    characteristics: string;
    analysisAssignments: AnalysisAssignmentRelationResponse[];
    analysisReports: AnalysisReportRelationResponse[];
    country: CountryRelationResponse;
    location: LocationRelationResponse;
    producerLocation: LocationRelationResponse;
    product: ProductRelationResponse;
    laboratoryLocation: LocationRelationResponse;
    supplierLocation: LocationRelationResponse;
    originLocation: LocationRelationResponse;

    [key: string]: any;
}

export interface Country {
    id: number;
    code3: string;
    nameAsJson: JsonTranslation;
    vName_en: string;
    vName_nl: string;
    vName_de: string;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    combinedSamples: CombinedSample[];
    locations: Location[];

    [key: string]: any;
}

export interface CountryAutocompleteResponse {
    id: number;
    code3: string;
    nameAsJson: JsonTranslation;

    [key: string]: any;
}

export interface CountryRelationResponse {
    id: number;
    code3: string;
    nameAsJson: JsonTranslation;

    [key: string]: any;
}

export interface CountryResponse {
    id: number;
    code3: string;
    nameAsJson: JsonTranslation;

    [key: string]: any;
}

export interface CreateAnalysisAssignmentPlannedRelationRequest {
    hazardId: number;
    detectionBorderValue: number | undefined;

    [key: string]: any;
}

export interface CreateAnalysisReportRequest {
    combinedSampleId: string;
    laboratoryLocationId: number | undefined;
    code: string;
    explanation: string;
    moisturePercentage: number;
    source: string;
    date: Date;
    analysisResults: CreateAnalysisResultRelationRequest[];

    [key: string]: any;
}

export interface CreateAnalysisResultRelationRequest {
    kindOf: CreateAnalysisResultRelationRequestKindOf;
    hazardId: number;
    methodId: number | undefined;
    methodText: string;
    unitId: number | undefined;
    value: number | undefined;
    valueProductOfDs: number | undefined;
    hazardType: string;
    presentType: string;
    symbol: CreateAnalysisResultRelationRequestSymbol;

    [key: string]: any;
}

export interface CreateAnalysisResultRequest {
    kindOf: CreateAnalysisResultRequestKindOf;
    guid: string;
    analysisReportGuid: string;
    hazardId: number;
    methodId: number | undefined;
    methodText: string;
    unitId: number | undefined;
    value: number | undefined;
    valueProductOfDs: number | undefined;
    hazardType: string;
    presentType: string;
    symbol: CreateAnalysisResultRequestSymbol;

    [key: string]: any;
}

export interface CreateAnalysisSetItemRelationRequest {
    hazardId: number;
    methodId: number | undefined;
    detectionBorderValue: number | undefined;
    sortOrder: number;

    [key: string]: any;
}

export interface CreateAnalysisSetRequest {
    locationId: number;
    name: string;
    analysisSetItems: CreateAnalysisSetItemRelationRequest[];

    [key: string]: any;
}

export interface CreateControlMeasureGroupRequest {
    nameAsJson: JsonTranslation;

    [key: string]: any;
}

export interface CreateControlMeasureRequest {
    controlMeasureGroupId: number;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;

    [key: string]: any;
}

export interface CreateCopiedSampleRequest {
    parentSampleGuid: string;
    locationId: number;

    [key: string]: any;
}

export interface CreateDocumentRequest {
    title: string;
    number: number | undefined;
    typeShort: string;
    languages: string;
    version: Date | undefined;
    stippDocumentId: string | undefined;
    stippParentDocumentId: string | undefined;
    subDocuments: CreateDocumentRequest[];

    [key: string]: any;
}

export interface CreateEdiIncomingSampleExcelRequest {
    kindOf: number;
    ediIncomingSampleRequestId: string;
    receivedAt: Date;
    fileAttachment: IFileAttachment;

    [key: string]: any;
}

export interface CreateEdiIncomingSampleUploadRequest {
    kindOf: number;
    nrOfAttachments: number;
    receivedAt: Date;
    userId: number | undefined;
    fileAttachment: IFileAttachment;

    [key: string]: any;
}

export interface CreateEdiIncomingSampleXmlRequest {
    kindOf: number;
    ediIncomingSampleRequestId: string;
    receivedAt: Date;
    fileAttachment: IFileAttachment;

    [key: string]: any;
}

export interface CreateFavouriteRequest {
    kindOf: number;
    userId: number | undefined;
    riskAssessmentId: number | undefined;
    productId: number | undefined;
    documentId: string | undefined;

    [key: string]: any;
}

export interface CreateHazardRequest {
    unitId: number | undefined;
    parentHazardId: number | undefined;
    code: string;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;
    standardReference: string;
    analysisBase: CreateHazardRequestAnalysisBase | undefined;
    analysisBaseNameAsJson: JsonTranslation;
    category: CreateHazardRequestCategory;
    severity: CreateHazardRequestSeverity | undefined;
    isActiveMonitoring: boolean;
    isActiveForRiskAssessment: boolean;
    moistureContentConversion: boolean;
    hazardType: CreateHazardRequestHazardType;
    sortOrder: number | undefined;

    [key: string]: any;
}

export interface CreateHazardsControlMeasureRequest {
    hazardId: number;
    controlMeasureId: number;

    [key: string]: any;
}

export interface CreateHazardsFactsheetFileReferenceRequest {
    hazardId: number;
    language: string;
    path: string;

    [key: string]: any;
}

export interface CreateHazardsStandardDocumentFileReferenceRequest {
    hazardId: number;
    language: string;
    path: string;

    [key: string]: any;
}

export interface CreateLocationRequest {
    id: number;
    name: string;
    city: string;
    registrationNumber: string;
    crmId: string;
    isProducer: boolean;
    isSupplier: boolean;
    isLaboratory: boolean;
    countryId: number;

    [key: string]: any;
}

export interface CreateLocationsMonitoringGroupRequest {
    locationId: number;
    monitoringGroupId: number;
    startDate: Date;
    endDate: Date | undefined;

    [key: string]: any;
}

export interface CreateMethodRequest {
    code: string;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;

    [key: string]: any;
}

export interface CreateMonitoringGroupRequest {
    name: string;
    code: string;
    isActive: boolean;

    [key: string]: any;
}

export interface CreateMyProductRequest {
    locationId: number | undefined;
    productId: number;
    code: string;
    name: string;
    expirationDate: Date | undefined;

    [key: string]: any;
}

export interface CreatePlannedSampleRequest {
    productId: number;
    myProductId: number | undefined;
    monitoringGroupId: number | undefined;
    locationId: number | undefined;
    plannedSampleNumber: string;
    sampleType: CreatePlannedSampleRequestSampleType;
    year: number;
    quarter: number | undefined;
    month: number | undefined;
    date: Date | undefined;
    status: CreatePlannedSampleRequestStatus;
    combinedAnalysisAssignments: CreateAnalysisAssignmentPlannedRelationRequest[];

    [key: string]: any;
}

export interface CreateProcessingAidGroupRequest {
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;
    factsheetVersionDate: Date | undefined;

    [key: string]: any;
}

export interface CreateProcessingAidGroupsFactsheetFileReferenceRequest {
    processingAidGroupId: number;
    language: string;
    path: string;

    [key: string]: any;
}

export interface CreateProcessingAidGroupsProcessingAidRelationRequest {
    processingAidGroupId: number;

    [key: string]: any;
}

export interface CreateProcessingAidRequest {
    nameAsJson: JsonTranslation;
    processingAidGroupsProcessingAids: CreateProcessingAidGroupsProcessingAidRelationRequest[];

    [key: string]: any;
}

export interface CreateProcessStepGroupRequest {
    sortOrder: number;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;

    [key: string]: any;
}

export interface CreateProcessStepRequest {
    processStepGroupId: number;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;
    sortOrder: number;

    [key: string]: any;
}

export interface CreateProductGroupRequest {
    descriptionAsJson: JsonTranslation;
    category: CreateProductGroupRequestCategory;
    code: string;

    [key: string]: any;
}

export interface CreateProductRequest {
    productGroupId: number;
    code: string;
    nameAsJson: JsonTranslation;
    definitionAsJson: JsonTranslation;
    synonymsAsJson: JsonTranslations;
    isActiveMonitoring: boolean;
    isActiveForRiskAssessment: boolean;
    isEuProduct: boolean;
    expirationDate: Date | undefined;

    [key: string]: any;
}

export interface CreateRiskAssessmentRequest {
    code: string;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;
    remarksAsJson: JsonTranslation;
    riskAssessmentVersions: CreateRiskAssessmentVersionRelationRequest[];

    [key: string]: any;
}

export interface CreateRiskAssessmentsProcessingAidRequest {
    riskAssessmentVersionId: number;
    processingAidId: number;

    [key: string]: any;
}

export interface CreateRiskAssessmentsProcessStepRequest {
    riskAssessmentVersionId: number;
    processStepId: number;

    [key: string]: any;
}

export interface CreateRiskAssessmentsProcessStepsHazardRequest {
    riskAssessmentsProcessStepId: number;
    hazardId: number;
    likelyOccurrence: string;
    explanationAsJson: JsonTranslation;
    referenceDiagram: string;
    riskAssessmentsProcessStepsHazardsControlMeasures: CreateRiskAssessmentsProcessStepsHazardsControlMeasureRelationRequest[];

    [key: string]: any;
}

export interface CreateRiskAssessmentsProcessStepsHazardsControlMeasureRelationRequest {
    riskAssessmentsProcessStepsHazardId: number;
    controlMeasureId: number;

    [key: string]: any;
}

export interface CreateRiskAssessmentsProcessStepsHazardsControlMeasureRequest {
    riskAssessmentsProcessStepsHazardId: number;
    controlMeasureId: number;

    [key: string]: any;
}

export interface CreateRiskAssessmentsProcessStepsProductRequest {
    riskAssessmentsProcessStepId: number;
    productId: number;

    [key: string]: any;
}

export interface CreateRiskAssessmentsProductRequest {
    riskAssessmentVersionId: number;
    productId: number;

    [key: string]: any;
}

export interface CreateRiskAssessmentVersionFlowChartFileReferenceRequest {
    riskAssessmentVersionId: number;
    language: string;
    name: string;
    position: number | undefined;
    path: string;
    flowChartVersionDate: Date | undefined;

    [key: string]: any;
}

export interface CreateRiskAssessmentVersionRelationRequest {
    riskAssessmentId: number;
    versionNumber: number;
    status: CreateRiskAssessmentVersionRelationRequestStatus;
    flowchartVersionDate: string;
    publicationDate: string;

    [key: string]: any;
}

export interface CreateRiskAssessmentVersionRequest {
    riskAssessmentId: number;
    versionNumber: number;
    flowchartVersionDate: string;

    [key: string]: any;
}

export interface CreateSampleDataMonitoringGroupRequest {
    monitoringGroupId: number;
    combinedSampleId: string;

    [key: string]: any;
}

export interface CreateSampleRequest {
    productId: number;
    locationId: number;
    sampleNumber: string;
    date: Date;
    sampleType: CreateSampleRequestSampleType;
    batchNumber: string;
    countryId: number | undefined;
    producerLocationId: number | undefined;
    supplierLocationId: number | undefined;
    characteristics: string;
    createdFromPlannedSampleId: string | undefined;

    [key: string]: any;
}

export interface CreateUnitRequest {
    code: string;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;

    [key: string]: any;
}

export interface CurrentUserDto {
    objectId: string;
    name: string;
    roles: string[];
    groups: UserGroupsContext[];
    positions: string[];
    userLocationIds: number[];

    [key: string]: any;
}

export interface CurrentUserRolesDto {
    roles: string[];

    [key: string]: any;
}

export interface DateOnly {
    year: number;
    month: number;
    day: number;
    dayOfWeek: DateOnlyDayOfWeek;
    dayOfYear: number;
    dayNumber: number;

    [key: string]: any;
}

export interface Document {
    id: string;
    title: string;
    number: number | undefined;
    typeShort: string;
    languages: string;
    version: Date | undefined;
    stippDocumentId: string | undefined;
    stippParentDocumentId: string | undefined;
    parentId: string | undefined;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    subDocuments: Document[];
    parent: Document;

    [key: string]: any;
}

export interface DocumentResponse {
    id: string;
    title: string;
    number: number | undefined;
    typeShort: string;
    languages: string;
    version: Date | undefined;
    stippDocumentId: string | undefined;
    stippParentDocumentId: string | undefined;
    parentId: string | undefined;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    subDocuments: DocumentResponse[];
    parent: Document;

    [key: string]: any;
}

export interface EdiIncomingSampleEmailResponse {
    kindOf: number;
    guid: string;
    emailAddress: string;
    emailSubject: string;
    nrOfAttachments: number;
    receivedAt: Date;
    repliedAt: Date | undefined;
    hasErrors: boolean;
    done: boolean;
    succeeded: boolean;
    errorMessages: string;
    errorMessagesEn: string;
    errorMessagesNl: string;
    errorMessagesDe: string;
    ediIncomingSampleFiles: EdiIncomingSampleFileRelationResponse[];

    [key: string]: any;
}

export interface EdiIncomingSampleError {
    kindOf: number;
    guid: string;
    ediIncomingSampleRequestId: string | undefined;
    ediIncomingSampleFileId: string;
    field: string;
    message: string;
    errorMessageAsJson: JsonTranslation;
    innerException: string;
    stackTrace: string;
    filePath: string;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    ediIncomingSampleFile: EdiIncomingSampleFile;
    ediIncomingSampleRequest: EdiIncomingSampleRequest;

    [key: string]: any;
}

export interface EdiIncomingSampleErrorRelationResponse {
    field: string;
    message: string;
    messageEn: string;
    messageNl: string;
    messageDe: string;
    innerException: string;
    stackTrace: string;
    translation: JsonTranslation;

    [key: string]: any;
}

export interface EdiIncomingSampleExcelResponse {
    kindOf: number;
    guid: string;
    ediIncomingSampleRequestId: string;
    path: string;
    fileName: string;
    contentType: string;
    fileSize: number | undefined;
    receivedAt: Date;
    convertedAt: Date | undefined;
    importedAt: Date | undefined;
    hasErrors: boolean;
    errorMessages: string;
    errorMessagesEn: string;
    errorMessagesNl: string;
    errorMessagesDe: string;
    ediIncomingSampleErrors: EdiIncomingSampleErrorRelationResponse[];

    [key: string]: any;
}

export interface EdiIncomingSampleFile {
    kindOf: number;
    guid: string;
    ediIncomingSampleRequestId: string;
    path: string;
    fileName: string;
    contentType: string;
    fileSize: number | undefined;
    receivedAt: Date;
    convertedAt: Date | undefined;
    importedAt: Date | undefined;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    incomingPayloadAsJson: string;
    convertedPayloadAsJson: string;
    entityPayloadAsJson: string;
    createdEntityAsJson: string;
    combinedSamples: CombinedSample[];
    ediIncomingSampleErrors: EdiIncomingSampleError[];
    ediIncomingSampleRequest: EdiIncomingSampleRequest;

    [key: string]: any;
}

export interface EdiIncomingSampleFileRelationResponse {
    kindOf: number;
    guid: string;
    relativePath: string;
    fileName: string;
    fileSize: number | undefined;
    receivedAt: Date;
    convertedAt: Date | undefined;
    importedAt: Date | undefined;
    ediIncomingSampleErrors: EdiIncomingSampleErrorRelationResponse[];
    combinedSamples: CombinedSampleRelationResponse[];

    [key: string]: any;
}

export interface EdiIncomingSampleRequest {
    kindOf: number;
    guid: string;
    emailAddress: string;
    emailBody: string;
    nrOfAttachments: number;
    receivedAt: Date;
    repliedAt: Date | undefined;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    emailSubject: string;
    emailMessageId: string;
    userId: number | undefined;
    ediIncomingSampleErrors: EdiIncomingSampleError[];
    ediIncomingSampleFiles: EdiIncomingSampleFile[];
    user: User;

    [key: string]: any;
}

export interface EdiIncomingSampleUploadResponse {
    kindOf: number;
    guid: string;
    nrOfAttachments: number;
    receivedAt: Date;
    hasErrors: boolean;
    done: boolean;
    succeeded: boolean;
    errorMessages: string;
    ediIncomingSampleFiles: EdiIncomingSampleFileRelationResponse[];

    [key: string]: any;
}

export interface EdiIncomingSampleXmlResponse {
    kindOf: number;
    guid: string;
    ediIncomingSampleRequestId: string;
    path: string;
    fileName: string;
    contentType: string;
    fileSize: number | undefined;
    receivedAt: Date;
    convertedAt: Date | undefined;
    importedAt: Date | undefined;
    hasErrors: boolean;
    errorMessages: string;
    errorMessagesEn: string;
    errorMessagesNl: string;
    errorMessagesDe: string;
    ediIncomingSampleErrors: EdiIncomingSampleErrorRelationResponse[];

    [key: string]: any;
}

export interface Favourite {
    id: string;
    kindOf: number;
    userId: number;
    riskAssessmentId: number | undefined;
    productId: number | undefined;
    createdAt: Date | undefined;
    lastModifiedAt: Date | undefined;
    createdBy: number | undefined;
    lastModifiedBy: number | undefined;
    product: Product;
    riskAssessment: RiskAssessment;
    user: User;

    [key: string]: any;
}

export interface FavouriteResponse {
    id: string;
    kindOf: number;
    userId: number;
    riskAssessmentId: number | undefined;
    productId: number | undefined;
    documentId: string | undefined;
    product: ProductRelationResponse;
    riskAssessment: RiskAssessmentRelationResponse;
    document: Document;

    [key: string]: any;
}

export interface File {

    [key: string]: any;
}

export interface Hazard {
    id: number;
    parentHazardId: number | undefined;
    unitId: number | undefined;
    code: string;
    nameAsJson: JsonTranslation;
    vName_en: string;
    vName_nl: string;
    vName_de: string;
    descriptionAsJson: JsonTranslation;
    vDescription_en: string;
    vDescription_nl: string;
    vDescription_de: string;
    standardReference: string;
    analysisBase: string;
    category: string;
    severity: string;
    isActiveMonitoring: boolean;
    isActiveForRiskAssessment: boolean;
    moistureContentConversion: boolean;
    hazardType: string;
    standardDocumentFileReferenceAsJson: JsonTranslation;
    vStandardDocumentFileReference_en: string;
    vStandardDocumentFileReference_nl: string;
    vStandardDocumentFileReference_de: string;
    sortOrder: number | undefined;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    nrOfRiskAssessments: number;
    nrOfChildrenHazards: number;
    countryId: number | undefined;
    nrBelowRejectionValue: number;
    nrBetweenRejectionValues: number;
    nrAboveRejectionValue: number;
    country: Country;
    combinedAnalysisAssignments: CombinedAnalysisAssignment[];
    analysisResults: AnalysisResult[];
    analysisSetItems: AnalysisSetItem[];
    hazardsControlMeasures: HazardsControlMeasure[];
    hazardsLimits: HazardsLimit[];
    childrenHazards: Hazard[];
    products: Product[];
    riskAssessmentsProcessStepsHazards: RiskAssessmentsProcessStepsHazard[];
    unit: Unit;
    hazardsFactsheetFileReference: HazardsFactsheetFileReference;
    hazardsStandardDocumentFileReferences: HazardsStandardDocumentFileReference[];
    favourites: Favourite[];
    parentHazard: Hazard;

    [key: string]: any;
}

export interface HazardAutocompleteResponse {
    id: number;
    code: string;
    nameAsJson: JsonTranslation;
    hazardType: HazardAutocompleteResponseHazardType;
    standardDocumentFileReferenceAsJson: JsonTranslation;
    unitCode: string;
    nrOfRiskAssessments: number;
    moistureContentConversion: boolean;
    unitNameAsJson: JsonTranslation;
    analysisBase: HazardAutocompleteResponseAnalysisBase | undefined;
    analysisBaseNameAsJson: JsonTranslation;
    hazardsLimits: HazardsLimitRelationResponse[];

    [key: string]: any;
}

export interface HazardRelationResponse {
    id: number;
    parentHazardNameAsJson: JsonTranslation;
    unitNameAsJson: JsonTranslation;
    code: string;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;
    standardReference: string;
    analysisBase: HazardRelationResponseAnalysisBase | undefined;
    analysisBaseNameAsJson: JsonTranslation;
    category: HazardRelationResponseCategory;
    severity: HazardRelationResponseSeverity | undefined;
    isActiveMonitoring: boolean;
    isActiveForRiskAssessment: boolean;
    moistureContentConversion: boolean;
    hazardType: HazardRelationResponseHazardType;
    standardDocumentFileReferenceAsJson: JsonTranslation;
    sortOrder: number | undefined;

    [key: string]: any;
}

export interface HazardResponse {
    id: number;
    parentHazardNameAsJson: JsonTranslation;
    unitNameAsJson: JsonTranslation;
    unitId: number | undefined;
    parentHazardId: number | undefined;
    code: string;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;
    standardReference: string;
    analysisBase: HazardResponseAnalysisBase | undefined;
    analysisBaseNameAsJson: JsonTranslation;
    category: HazardResponseCategory;
    severity: HazardResponseSeverity | undefined;
    isActiveMonitoring: boolean;
    isActiveForRiskAssessment: boolean;
    moistureContentConversion: boolean;
    hazardType: HazardResponseHazardType;
    sortOrder: number | undefined;
    unitCode: string;
    nrOfRiskAssessments: number;
    nrOfChildrenHazards: number;
    hazardsLimits: HazardsLimitRelationResponse[];
    hazardsControlMeasures: HazardsControlMeasureRelationResponse[];
    hazardsFactsheetFileReference: HazardsFactsheetFileReferenceRelationResponse;
    hazardsStandardDocumentFileReferences: HazardsStandardDocumentFileReferenceRelationResponse[];

    [key: string]: any;
}

export interface HazardsControlMeasure {
    id: number;
    hazardId: number;
    controlMeasureId: number;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    controlMeasure: ControlMeasure;
    hazard: Hazard;

    [key: string]: any;
}

export interface HazardsControlMeasureRelationResponse {
    id: number;
    hazardId: number;
    controlMeasureId: number;
    controlMeasure: ControlMeasureRelationResponse;

    [key: string]: any;
}

export interface HazardsControlMeasureResponse {
    id: number;
    hazardId: number;
    controlMeasureId: number;

    [key: string]: any;
}

export interface HazardsFactsheetFileReference {
    id: number;
    hazardId: number;
    language: string;
    path: string;
    factsheetVersionDate: DateOnly | undefined;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;

    [key: string]: any;
}

export interface HazardsFactsheetFileReferenceRelationResponse {
    id: number;
    hazardId: number;
    language: string;
    path: string;

    [key: string]: any;
}

export interface HazardsFactsheetFileReferenceResponse {
    id: number;
    hazardId: number;
    language: string;
    path: string;

    [key: string]: any;
}

export interface HazardsLimit {
    id: number;
    hazardId: number;
    unitId: number;
    startDate: Date;
    endDate: Date | undefined;
    minimumActionBorderValue: number | undefined;
    maximumActionBorderValue: number | undefined;
    minimumRejectionBorderValue: number | undefined;
    maximumRejectionBorderValue: number | undefined;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    hazard: Hazard;
    unit: Unit;

    [key: string]: any;
}

export interface HazardsLimitRelationResponse {
    id: number;
    unitId: number;
    startDate: Date;
    endDate: Date | undefined;
    minimumActionBorderValue: number | undefined;
    maximumActionBorderValue: number | undefined;
    minimumRejectionBorderValue: number | undefined;
    maximumRejectionBorderValue: number | undefined;
    unitCode: string;
    unitNameAsJson: JsonTranslation;

    [key: string]: any;
}

export interface HazardsLimitResponse {
    id: number;
    hazardId: number;
    unitId: number;
    startDate: Date;
    endDate: Date | undefined;
    minimumActionBorderValue: number | undefined;
    maximumActionBorderValue: number | undefined;
    minimumRejectionBorderValue: number | undefined;
    maximumRejectionBorderValue: number | undefined;

    [key: string]: any;
}

export interface HazardsStandardDocumentFileReference {
    id: number;
    hazardId: number;
    language: string;
    path: string;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;

    [key: string]: any;
}

export interface HazardsStandardDocumentFileReferenceRelationResponse {
    id: number;
    hazardId: number;
    path: string;
    language: string;

    [key: string]: any;
}

export interface HazardsStandardDocumentFileReferenceResponse {
    id: number;
    hazardId: number;
    language: string;
    path: string;

    [key: string]: any;
}

export interface IFileAttachment {
    contentId: string;
    name: string;
    contentType: string;
    size: number;
    contentBytes: string;
    path: string;
    guid: string | undefined;

    [key: string]: any;
}

export interface JsonTranslation {
    en: string;
    nl: string;
    de: string;

    [key: string]: any;
}

export interface JsonTranslations {
    en: string[];
    nl: string[];
    de: string[];

    [key: string]: any;
}

export interface Location {
    id: number;
    name: string;
    city: string;
    registrationNumber: string;
    legacyRegistrationNumber: string;
    crmId: string;
    crmModifiedOn: Date | undefined;
    isLaboratory: boolean;
    isProducer: boolean;
    isSupplier: boolean;
    countryId: number | undefined;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    isActive: boolean;
    parentId: number | undefined;
    createdFromRelationId: number | undefined;
    nrOfCommunitySamples: number;
    country: Country;
    triedToFetchFromCrmAt: Date;
    childLocations: Location[];
    analysisResults: AnalysisResult[];
    analysisSets: AnalysisSet[];
    analysisReports: AnalysisReport[];
    combinedSampleLocations: CombinedSample[];
    combinedSampleProducerLocations: CombinedSample[];
    combinedSampleSupplierLocations: CombinedSample[];
    combinedSampleLaboratoryLocations: CombinedSample[];
    combinedSampleOriginLocations: CombinedSample[];
    locationsMonitoringGroups: LocationsMonitoringGroup[];
    locationsUsers: LocationsUser[];
    myProducts: MyProduct[];
    sampleCharacteristics: SampleCharacteristic[];
    parentLocation: Location;

    [key: string]: any;
}

export interface LocationAutocompleteResponse {
    id: number;
    name: string;
    registrationNumber: string;
    legacyRegistrationNumber: string;

    [key: string]: any;
}

export interface LocationForCurrentUserResponse {
    id: number;
    name: string;
    city: string;
    registrationNumber: string;
    legacyRegistrationNumber: string;
    isProducer: boolean;
    isSupplier: boolean;
    isLaboratory: boolean;
    countryId: number;
    nrOfCommunitySamples: number;

    [key: string]: any;
}

export interface LocationRelationResponse {
    id: number;
    name: string;

    [key: string]: any;
}

export interface LocationResponse {
    id: number;
    name: string;
    city: string;
    registrationNumber: string;
    legacyRegistrationNumber: string;
    crmId: string;
    crmModifiedOn: Date | undefined;
    isProducer: boolean;
    isSupplier: boolean;
    isLaboratory: boolean;
    countryId: number;
    countryNameAsJson: JsonTranslation;

    [key: string]: any;
}

export interface LocationAutoCompleteResponse {
  id: number;
  name: string;
  city: string;
  countryId: number;
  registrationNumber: string;
  legacyRegistrationNumber: string;
  isProducer: boolean;
  isSupplier: boolean;
  isLaboratory: boolean;
  isActive: boolean;

  [key: string]: any;
}

export interface LocationsMonitoringGroup {
    id: number;
    locationId: number;
    monitoringGroupId: number;
    startDate: Date;
    endDate: Date | undefined;
    status: number;
    approvalDateLocation: Date | undefined;
    approvalDateGroup: Date | undefined;
    autoInsert: boolean;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    location: Location;
    monitoringGroup: MonitoringGroup;

    [key: string]: any;
}

export interface LocationsMonitoringGroupForGroupManagerResponse {
    id: number;
    locationId: number;
    monitoringGroupId: number;
    startDate: Date;
    endDate: Date | undefined;
    status: LocationsMonitoringGroupForGroupManagerResponseStatus;
    approvalDateLocation: Date | undefined;
    approvalDateGroup: Date | undefined;
    autoInsert: boolean;
    location: LocationRelationResponse;
    monitoringGroup: MonitoringGroupRelationResponse;

    [key: string]: any;
}

export interface LocationsMonitoringGroupResponse {
    id: number;
    locationId: number;
    monitoringGroupId: number;
    startDate: Date;
    endDate: Date | undefined;
    status: LocationsMonitoringGroupResponseStatus;
    approvalDateLocation: Date | undefined;
    approvalDateGroup: Date | undefined;
    autoInsert: boolean;
    location: LocationRelationResponse;
    monitoringGroup: MonitoringGroupRelationResponse;

    [key: string]: any;
}

export interface LocationsUser {
    id: number;
    locationId: number;
    userId: number;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    location: Location;
    user: User;

    [key: string]: any;
}

export interface Method {
    id: number;
    code: string;
    nameAsJson: JsonTranslation;
    vName_en: string;
    vName_nl: string;
    vName_de: string;
    descriptionAsJson: JsonTranslation;
    vDescription_en: string;
    vDescription_nl: string;
    vDescription_de: string;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    analysisResults: AnalysisResult[];
    analysisSetItems: AnalysisSetItem[];

    [key: string]: any;
}

export interface MethodAutocompleteResponse {
    id: number;
    code: string;
    nameAsJson: JsonTranslation;

    [key: string]: any;
}

export interface MethodRelationResponse {
    id: number;
    code: string;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;

    [key: string]: any;
}

export interface MethodResponse {
    id: number;
    code: string;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;

    [key: string]: any;
}

export interface MonitoringGroup {
    id: number;
    name: string;
    code: string;
    isActive: boolean;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    locationsMonitoringGroups: LocationsMonitoringGroup[];
    combinedSamples: CombinedSample[];
    monitoringGroupsUsers: MonitoringGroupsUser[];
    sampleDataMonitoringGroups: SampleDataMonitoringGroup[];

    [key: string]: any;
}

export interface MonitoringGroupAutocompleteResponse {
    id: number;
    name: string;

    [key: string]: any;
}

export interface MonitoringGroupForCurrentUserResponse {
    id: number;
    name: string;
    code: string;
    isActive: boolean;

    [key: string]: any;
}

export interface MonitoringGroupRelationResponse {
    id: number;
    name: string;
    code: string;
    isActive: boolean;

    [key: string]: any;
}

export interface MonitoringGroupResponse {
    id: number;
    name: string;
    code: string;
    isActive: boolean;

    [key: string]: any;
}

export interface MonitoringGroupsUser {
    id: number;
    monitoringGroupId: number;
    userId: number;
    createdAt: Date | undefined;
    createdBy: number | undefined;
    lastModifiedAt: Date | undefined;
    lastModifiedBy: number | undefined;
    monitoringGroup: MonitoringGroup;
    user: User;

    [key: string]: any;
}

export interface MyProduct {
    id: number;
    locationId: number | undefined;
    productId: number;
    code: string;
    name: string;
    expirationDate: Date | undefined;
    location: Location;
    combinedSamples: CombinedSample[];
    product: Product;

    [key: string]: any;
}

export interface MyProductRelationResponse {
    id: number;
    code: string;
    name: string;

    [key: string]: any;
}

export interface MyProductResponse {
    id: number;
    locationId: number | undefined;
    productId: number;
    code: string;
    name: string;
    expirationDate: Date | undefined;
    location: LocationRelationResponse;
    product: ProductRelationResponse;

    [key: string]: any;
}

export interface NotFoundResult {
    statusCode: number;

    [key: string]: any;
}

export interface PlannedSampleResponse {
    kindOf: PlannedSampleResponseKindOf;
    id: string;
    plannedSampleId: number | undefined;
    userId: number | undefined;
    productId: number;
    myProductId: number | undefined;
    monitoringGroupId: number | undefined;
    locationId: number | undefined;
    plannedSampleNumber: string;
    sampleType: string;
    year: number | undefined;
    quarter: number | undefined;
    month: number | undefined;
    date: Date | undefined;
    lastModifiedAt: Date;
    status: string;
    level: string;
    priority: number;
    originLocationId: number | undefined;
    sampleDataStatus: string;
    batchNumber: string;
    statusResetDate: Date | undefined;
    parentSampleId: number | undefined;
    parentPlannedSampleId: number | undefined;
    characteristics: string;
    combinedAnalysisAssignments: AnalysisAssignmentPlannedRelationResponse[];
    location: LocationRelationResponse;
    product: ProductRelationResponse;

    [key: string]: any;
}

export interface ProcessingAid {
    id: number;
    nameAsJson: JsonTranslation;
    vName_en: string;
    vName_nl: string;
    vName_de: string;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    nrOfRiskAssessments: number;
    processingAidGroupsProcessingAids: ProcessingAidGroupsProcessingAid[];
    riskAssessmentsProcessingAids: RiskAssessmentsProcessingAid[];

    [key: string]: any;
}

export interface ProcessingAidAutocompleteResponse {
    id: number;
    nameAsJson: JsonTranslation;
    nrOfRiskAssessments: number;

    [key: string]: any;
}

export interface ProcessingAidGroup {
    id: number;
    nameAsJson: JsonTranslation;
    vName_en: string;
    vName_nl: string;
    vName_de: string;
    descriptionAsJson: JsonTranslation;
    vDescription_en: string;
    vDescription_nl: string;
    vDescription_de: string;
    factsheetFileReferenceAsJson: JsonTranslation;
    vFactsheetFileReference_en: string;
    vFactsheetFileReference_nl: string;
    vFactsheetFileReference_de: string;
    factsheetVersionDate: DateOnly | undefined;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    processingAidGroupsProcessingAids: ProcessingAidGroupsProcessingAid[];
    processingAidGroupsFactsheetFileReferences: ProcessingAidGroupsFactsheetFileReference[];

    [key: string]: any;
}

export interface ProcessingAidGroupRelationResponse {
    id: number;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;
    factsheetVersionDate: Date | undefined;
    processingAidGroupsFactsheetFileReferences: ProcessingAidGroupsFactsheetFileReferenceRelationResponse[];

    [key: string]: any;
}

export interface ProcessingAidGroupResponse {
    id: number;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;
    factsheetVersionDate: Date | undefined;
    processingAidGroupsFactsheetFileReferences: ProcessingAidGroupsFactsheetFileReferenceRelationResponse[];

    [key: string]: any;
}

export interface ProcessingAidGroupsFactsheetFileReference {
    id: number;
    processingAidGroupId: number;
    language: string;
    path: string;
    factsheetVersionDate: DateOnly | undefined;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;

    [key: string]: any;
}

export interface ProcessingAidGroupsFactsheetFileReferenceRelationResponse {
    id: number;
    processingAidGroupId: number;
    language: string;
    path: string;

    [key: string]: any;
}

export interface ProcessingAidGroupsFactsheetFileReferenceResponse {
    id: number;
    processingAidGroupId: number;
    language: string;
    path: string;

    [key: string]: any;
}

export interface ProcessingAidGroupsProcessingAid {
    id: number;
    processingAidGroupId: number;
    processingAidId: number;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    processingAid: ProcessingAid;
    processingAidGroup: ProcessingAidGroup;

    [key: string]: any;
}

export interface ProcessingAidGroupsProcessingAidRelationResponse {
    processingAidGroupId: number;
    processingAidId: number;
    processingAidGroup: ProcessingAidGroupRelationResponse;

    [key: string]: any;
}

export interface ProcessingAidRelationResponse {
    id: number;
    nameAsJson: JsonTranslation;
    processingAidGroupsProcessingAids: ProcessingAidGroupsProcessingAidRelationResponse[];

    [key: string]: any;
}

export interface ProcessingAidResponse {
    id: number;
    nameAsJson: JsonTranslation;
    nrOfRiskAssessments: number;
    processingAidGroupsProcessingAids: ProcessingAidGroupsProcessingAidRelationResponse[];

    [key: string]: any;
}

export interface ProcessStep {
    id: number;
    processStepGroupId: number;
    nameAsJson: JsonTranslation;
    vName_en: string;
    vName_nl: string;
    vName_de: string;
    descriptionAsJson: JsonTranslation;
    vDescription_en: string;
    vDescription_nl: string;
    vDescription_de: string;
    sortOrder: number;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    processStepGroup: ProcessStepGroup;
    riskAssessmentsProcessSteps: RiskAssessmentsProcessStep[];

    [key: string]: any;
}

export interface ProcessStepGroup {
    id: number;
    nameAsJson: JsonTranslation;
    vName_en: string;
    vName_nl: string;
    vName_de: string;
    descriptionAsJson: JsonTranslation;
    vDescription_en: string;
    vDescription_nl: string;
    vDescription_de: string;
    sortOrder: number;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    processSteps: ProcessStep[];

    [key: string]: any;
}

export interface ProcessStepGroupResponse {
    id: number;
    sortOrder: number;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;

    [key: string]: any;
}

export interface ProcessStepRelationResponse {
    id: number;
    groupId: number;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;
    sortOrder: number;
    groupNameAsJson: JsonTranslation;

    [key: string]: any;
}

export interface ProcessStepResponse {
    id: number;
    processStepGroupId: number;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;
    sortOrder: number;
    groupNameAsJson: JsonTranslation;

    [key: string]: any;
}

export interface Product {
    id: number;
    productGroupId: number;
    code: string;
    nameAsJson: JsonTranslation;
    vName_en: string;
    vName_nl: string;
    vName_de: string;
    definitionAsJson: JsonTranslation;
    vDefinition_en: string;
    vDefinition_nl: string;
    vDefinition_de: string;
    synonymsAsJson: JsonTranslations;
    isActiveMonitoring: boolean;
    isActiveForRiskAssessment: boolean;
    isEuProduct: boolean;
    expirationDate: Date | undefined;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    nrOfRiskAssessments: number;
    computedCode: string;
    favourites: Favourite[];
    myProducts: MyProduct[];
    productGroup: ProductGroup;
    riskAssessmentsProcessStepsProducts: RiskAssessmentsProcessStepsProduct[];
    riskAssessmentsProducts: RiskAssessmentsProduct[];
    combinedSamples: CombinedSample[];

    [key: string]: any;
}

export interface ProductAutocompleteResponse {
    id: number;
    code: string;
    nameAsJson: JsonTranslation;
    nrOfRiskAssessments: number;

    [key: string]: any;
}

export interface ProductGroup {
    id: number;
    code: string;
    descriptionAsJson: JsonTranslation;
    vDescription_en: string;
    vDescription_nl: string;
    vDescription_de: string;
    category: string;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    products: Product[];

    [key: string]: any;
}

export interface ProductGroupRelationResponse {
    id: number;
    descriptionAsJson: JsonTranslation;
    category: ProductGroupRelationResponseCategory | undefined;
    categoryNameAsJson: JsonTranslation;
    code: string;

    [key: string]: any;
}

export interface ProductGroupResponse {
    id: number;
    descriptionAsJson: JsonTranslation;
    category: ProductGroupResponseCategory | undefined;
    categoryNameAsJson: JsonTranslation;
    code: string;

    [key: string]: any;
}

export interface ProductOrMyProductAutocompleteResponse {
    productId: number;
    myProductId: number | undefined;
    productCode: string;
    myProductCode: string;
    nameAsJson: JsonTranslation;
    myProductName: string;
    vName_en: string;
    vName_nl: string;
    vName_de: string;
    isActiveMonitoring: boolean | undefined;
    expirationDate: Date | undefined;
    productGroupCode: string;
    productGroupCategory: string;
    myProductLocationId: number | undefined;

    [key: string]: any;
}

export interface ProductRelationResponse {
    id: number;
    code: string;
    nameAsJson: JsonTranslation;

    [key: string]: any;
}

export interface ProductResponse {
    id: number;
    productGroupId: number;
    code: string;
    nameAsJson: JsonTranslation;
    definitionAsJson: JsonTranslation;
    synonymsAsJson: JsonTranslations;
    isActiveMonitoring: boolean;
    isActiveForRiskAssessment: boolean;
    isEuProduct: boolean;
    isFavourite: boolean;
    expirationDate: Date | undefined;
    nrOfRiskAssessments: number;
    productGroup: ProductGroupRelationResponse;

    [key: string]: any;
}

export interface ReportCombinedSampleAnalysisResultResponse {
    kindOf: ReportCombinedSampleAnalysisResultResponseKindOf;
    analysisResultId: string;
    locationId: number;
    locationName: string;
    productId: number;
    productNameAsJson: JsonTranslation;
    sampleNumber: string;
    analysisType: string;
    batchNumber: string;
    originLocationId: number | undefined;
    originLocationName: string;
    producerLocationId: number | undefined;
    producerLocationName: string;
    laboratoryLocationId: number | undefined;
    laboratoryLocationName: string;
    date: Date | undefined;
    reportNumber: string;
    hazardId: number;
    hazardNameAsJson: JsonTranslation;
    methodId: number | undefined;
    methodText: string;
    symbol: ReportCombinedSampleAnalysisResultResponseSymbol;
    value: number | undefined;
    unitId: number | undefined;
    unitText: string;
    minimumActionBorderValue: number | undefined;
    maximumActionBorderValue: number | undefined;
    minimumRejectionBorderValue: number | undefined;
    maximumRejectionBorderValue: number | undefined;
    countryNameAsJson: JsonTranslation;
    methodNameAsJson: JsonTranslation;

    [key: string]: any;
}

export interface RevertSampleRequest {
    id: string;
    status: string;

    [key: string]: any;
}

export interface RiskAssessment {
    id: number;
    code: string;
    nameAsJson: JsonTranslation;
    vName_en: string;
    vName_nl: string;
    vName_de: string;
    descriptionAsJson: JsonTranslation;
    vDescription_en: string;
    vDescription_nl: string;
    vDescription_de: string;
    remarksAsJson: JsonTranslation;
    vRemarks_en: string;
    vRemarks_nl: string;
    vRemarks_de: string;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    isDeleted: boolean;
    deletedBy: number | undefined;
    deletedAt: Date | undefined;
    favourites: Favourite[];
    riskAssessmentVersions: RiskAssessmentVersion[];

    [key: string]: any;
}

export interface RiskAssessmentRelationResponse {
    id: number;
    code: string;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;
    remarksAsJson: JsonTranslation;
    riskAssessmentVersions: RiskAssessmentVersionRelationResponse[];

    [key: string]: any;
}

export interface RiskAssessmentResponse {
    id: number;
    code: string;
    isFavourite: boolean;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;
    remarksAsJson: JsonTranslation;
    riskAssessmentVersions: RiskAssessmentVersionRelationResponse[];

    // [key: string]: any;
}

export interface RiskAssessmentsProcessingAid {
    id: number;
    riskAssessmentVersionId: number;
    processingAidId: number;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    processingAid: ProcessingAid;
    riskAssessmentVersion: RiskAssessmentVersion;

    [key: string]: any;
}

export interface RiskAssessmentsProcessingAidRelationResponse {
    id: number;
    riskAssessmentVersionId: number;
    processingAidId: number;
    processingAid: ProcessingAidRelationResponse;

    [key: string]: any;
}

export interface RiskAssessmentsProcessingAidResponse {
    id: number;
    riskAssessmentVersionId: number;
    processingAidId: number;

    [key: string]: any;
}

export interface RiskAssessmentsProcessStep {
    id: number;
    riskAssessmentVersionId: number;
    processStepId: number;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    processStep: ProcessStep;
    riskAssessmentVersion: RiskAssessmentVersion;
    riskAssessmentsProcessStepsHazards: RiskAssessmentsProcessStepsHazard[];
    riskAssessmentsProcessStepsProducts: RiskAssessmentsProcessStepsProduct[];

    [key: string]: any;
}

export interface RiskAssessmentsProcessStepRelationResponse {
    id: number;
    riskAssessmentVersionId: number;
    processStepId: number;
    processStep: ProcessStepRelationResponse;
    riskAssessmentsProcessStepsHazards: RiskAssessmentsProcessStepsHazardRelationResponse[];
    riskAssessmentsProcessStepsProducts: RiskAssessmentsProcessStepsProductRelationResponse[];

    [key: string]: any;
}

export interface RiskAssessmentsProcessStepResponse {
    id: number;
    riskAssessmentVersionId: number;
    processStepId: number;

    [key: string]: any;
}

export interface RiskAssessmentsProcessStepsHazard {
    id: number;
    riskAssessmentsProcessStepId: number;
    hazardId: number;
    likelyOccurrence: string;
    explanationAsJson: JsonTranslation;
    vExplanation_en: string;
    vExplanation_nl: string;
    vExplanation_de: string;
    referenceDiagram: string;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    hazard: Hazard;
    riskAssessmentsProcessStep: RiskAssessmentsProcessStep;
    riskAssessmentsProcessStepsHazardsControlMeasures: RiskAssessmentsProcessStepsHazardsControlMeasure[];

    [key: string]: any;
}

export interface RiskAssessmentsProcessStepsHazardRelationResponse {
    id: number;
    riskAssessmentsProcessStepId: number;
    hazardId: number;
    likelyOccurrence: string;
    explanationAsJson: JsonTranslation;
    referenceDiagram: string;
    hazard: HazardRelationResponse;
    riskAssessmentsProcessStepsHazardsControlMeasures: RiskAssessmentsProcessStepsHazardsControlMeasureRelationResponse[];

    [key: string]: any;
}

export interface RiskAssessmentsProcessStepsHazardResponse {
    id: number;
    riskAssessmentsProcessStepId: number;
    hazardId: number;
    likelyOccurrence: string;
    explanationAsJson: JsonTranslation;
    referenceDiagram: string;
    riskAssessmentsProcessStepsHazardsControlMeasures: RiskAssessmentsProcessStepsHazardsControlMeasureRelationResponse[];

    [key: string]: any;
}

export interface RiskAssessmentsProcessStepsHazardsControlMeasure {
    id: number;
    riskAssessmentsProcessStepsHazardId: number;
    controlMeasureId: number;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    controlMeasure: ControlMeasure;
    riskAssessmentsProcessStepsHazard: RiskAssessmentsProcessStepsHazard;

    [key: string]: any;
}

export interface RiskAssessmentsProcessStepsHazardsControlMeasureRelationResponse {
    id: number;
    riskAssessmentsProcessStepsHazardId: number;
    controlMeasureId: number;
    controlMeasure: ControlMeasureRelationResponse;

    [key: string]: any;
}

export interface RiskAssessmentsProcessStepsHazardsControlMeasureResponse {
    id: number;
    riskAssessmentsProcessStepsHazardId: number;
    controlMeasureId: number;

    [key: string]: any;
}

export interface RiskAssessmentsProcessStepsProduct {
    id: number;
    riskAssessmentsProcessStepId: number;
    productId: number;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    product: Product;
    riskAssessmentsProcessStep: RiskAssessmentsProcessStep;

    [key: string]: any;
}

export interface RiskAssessmentsProcessStepsProductRelationResponse {
    id: number;
    riskAssessmentsProcessStepId: number;
    productId: number;
    product: ProductRelationResponse;

    [key: string]: any;
}

export interface RiskAssessmentsProcessStepsProductResponse {
    id: number;
    riskAssessmentsProcessStepId: number;
    productId: number;

    [key: string]: any;
}

export interface RiskAssessmentsProduct {
    id: number;
    riskAssessmentVersionId: number;
    productId: number;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    product: Product;
    riskAssessmentVersion: RiskAssessmentVersion;

    [key: string]: any;
}

export interface RiskAssessmentsProductRelationResponse {
    id: number;
    riskAssessmentVersionId: number;
    productId: number;
    product: ProductRelationResponse;

    [key: string]: any;
}

export interface RiskAssessmentsProductResponse {
    id: number;
    riskAssessmentVersionId: number;
    productId: number;

    [key: string]: any;
}

export interface RiskAssessmentVersion {
    id: number;
    riskAssessmentId: number;
    versionNumber: number;
    status: string;
    publicationDate: Date | undefined;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    isDeleted: boolean;
    deletedBy: number | undefined;
    deletedAt: Date | undefined;
    riskAssessment: RiskAssessment;
    riskAssessmentsProcessSteps: RiskAssessmentsProcessStep[];
    riskAssessmentsProcessingAids: RiskAssessmentsProcessingAid[];
    riskAssessmentsProducts: RiskAssessmentsProduct[];
    riskAssessmentVersionFlowChartFileReferences: RiskAssessmentVersionFlowChartFileReference[];

    [key: string]: any;
}

export interface RiskAssessmentVersionFlowChartFileReference {
    id: number;
    riskAssessmentVersionId: number;
    language: string;
    name: string;
    position: number | undefined;
    path: string;
    flowChartVersionDate: Date | undefined;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    riskAssessmentVersion: RiskAssessmentVersion;

    [key: string]: any;
}

export interface RiskAssessmentVersionFlowChartFileReferenceRelationResponse {
    id: number;
    riskAssessmentVersionId: number;
    language: string;
    name: string;
    position: number | undefined;
    path: string;
    flowChartVersionDate: Date | undefined;

    [key: string]: any;
}

export interface RiskAssessmentVersionFlowChartFileReferenceResponse {
    id: number;
    riskAssessmentVersionId: number;
    language: string;
    name: string;
    position: number | undefined;
    path: string;
    flowChartVersionDate: Date | undefined;

    [key: string]: any;
}

export interface RiskAssessmentVersionRelationResponse {
    id: number;
    riskAssessmentId: number;
    versionNumber: number;
    status: RiskAssessmentVersionRelationResponseStatus;
    flowchartVersionDate: Date | undefined;
    publicationDate: Date | undefined;
    lastModifiedAt: Date;
    riskAssessmentsProcessSteps: RiskAssessmentsProcessStepRelationResponse[];
    riskAssessmentsProcessingAids: RiskAssessmentsProcessingAidRelationResponse[];
    riskAssessmentsProducts: RiskAssessmentsProductRelationResponse[];
    riskAssessmentVersionFlowChartFileReferences: RiskAssessmentVersionFlowChartFileReferenceRelationResponse[];

    [key: string]: any;
}

export interface RiskAssessmentVersionResponse {
    id: number;
    riskAssessmentId: number;
    versionNumber: number;
    status: RiskAssessmentVersionResponseStatus;
    flowchartVersionDate: string;
    publicationDate: string;
    lastModifiedAt: Date;
    riskAssessmentsProcessSteps: RiskAssessmentsProcessStepRelationResponse[];
    riskAssessmentsProcessingAids: RiskAssessmentsProcessingAidRelationResponse[];
    riskAssessmentsProducts: RiskAssessmentsProductRelationResponse[];
    riskAssessmentVersionFlowChartFileReferences: RiskAssessmentVersionFlowChartFileReferenceRelationResponse[];

    [key: string]: any;
}

export interface SampleAutocompleteResponse {
    kindOf: SampleAutocompleteResponseKindOf;
    id: string;
    sampleNumber: string;

    [key: string]: any;
}

export interface SampleCharacteristic {
    id: number;
    locationId: number;
    name: string;
    sortOrder: number;
    isActive: boolean;
    location: Location;
    sampleCharacteristicsSampleData: SampleCharacteristicsSampleDatum[];

    [key: string]: any;
}

export interface SampleCharacteristicsSampleDatum {
    id: number;
    sampleCharacteristicsId: number;
    combinedSampleId: string;
    description: string;
    sampleCharacteristics: SampleCharacteristic;
    combinedSample: CombinedSample;

    [key: string]: any;
}

export interface SampleDataMonitoringGroup {
    guid: string;
    monitoringGroupId: number;
    combinedSampleId: string;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    combinedSample: CombinedSample;
    monitoringGroup: MonitoringGroup;

    [key: string]: any;
}

export interface SampleDataMonitoringGroupResponse {
    guid: string;
    monitoringGroupId: number;
    combinedSampleId: string;

    [key: string]: any;
}

export interface SampleResponse {
    kindOf: SampleResponseKindOf;
    id: string;
    parentSampleGuid: string | undefined;
    parentPlannedSampleGuid: string | undefined;
    sampleDataId: number | undefined;
    sampleId: number | undefined;
    plannedSampleId: number | undefined;
    userId: number | undefined;
    productId: number;
    myProductId: number | undefined;
    monitoringGroupId: number | undefined;
    locationId: number | undefined;
    sampleNumber: string;
    countryCode3: string;
    countryId: number | undefined;
    forCommunity: boolean | undefined;
    laboratoryLocationId: number | undefined;
    plannedSampleNumber: string;
    sampleType: string;
    year: number | undefined;
    quarter: number | undefined;
    month: number | undefined;
    date: Date | undefined;
    lastModifiedAt: Date;
    status: string;
    level: string;
    priority: number;
    originLocationId: number | undefined;
    sampleDataStatus: string;
    batchNumber: string;
    statusResetDate: Date | undefined;
    parentSampleId: number | undefined;
    parentPlannedSampleId: number | undefined;
    producerLocationId: number | undefined;
    supplierLocationId: number | undefined;
    characteristics: string;
    analysisAssignments: AnalysisAssignmentRelationResponse[];
    analysisReports: AnalysisReportRelationResponse[];
    country: CountryRelationResponse;
    location: LocationRelationResponse;
    myProduct: MyProductRelationResponse;
    producerLocation: LocationRelationResponse;
    product: ProductRelationResponse;
    laboratoryLocation: LocationRelationResponse;
    sharedGroups: MonitoringGroupResponse[];
    supplierLocation: LocationRelationResponse;
    originLocation: LocationRelationResponse;

    [key: string]: any;
}

export interface Unit {
    id: number;
    code: string;
    nameAsJson: JsonTranslation;
    vName_en: string;
    vName_nl: string;
    vName_de: string;
    descriptionAsJson: JsonTranslation;
    vDescription_en: string;
    vDescription_nl: string;
    vDescription_de: string;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    analysisResultDetectionBorderUnits: AnalysisResult[];
    analysisResultUnits: AnalysisResult[];
    hazards: Hazard[];
    hazardsLimits: HazardsLimit[];

    [key: string]: any;
}

export interface UnitRelationResponse {
    id: number;
    code: string;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;

    [key: string]: any;
}

export interface UnitResponse {
    id: number;
    code: string;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;

    [key: string]: any;
}

export interface UpdateAnalysisAssignmentPlannedRelationRequest {
    id: string;
    hazardId: number;
    detectionBorderValue: number | undefined;

    [key: string]: any;
}

export interface UpdateAnalysisReportRequest {
    guid: string;
    combinedSampleId: string;
    laboratoryLocationId: number | undefined;
    code: string;
    explanation: string;
    moisturePercentage: number;
    source: string;
    date: Date;
    analysisResults: UpdateAnalysisResultRelationRequest[];

    [key: string]: any;
}

export interface UpdateAnalysisResultRelationRequest {
    kindOf: UpdateAnalysisResultRelationRequestKindOf;
    guid: string | undefined;
    analysisReportGuid: string;
    hazardId: number;
    methodId: number | undefined;
    methodText: string;
    unitId: number | undefined;
    value: number | undefined;
    valueProductOfDs: number | undefined;
    hazardType: string;
    presentType: string;
    symbol: UpdateAnalysisResultRelationRequestSymbol;

    [key: string]: any;
}

export interface UpdateAnalysisResultRequest {
    guid: string;
    analysisReportGuid: string;
    hazardId: number;
    methodId: number | undefined;
    methodText: string;
    unitId: number | undefined;
    value: number | undefined;
    valueProductOfDs: number | undefined;
    hazardType: string;
    presentType: string;
    symbol: UpdateAnalysisResultRequestSymbol;

    [key: string]: any;
}

export interface UpdateAnalysisSetItemRelationRequest {
    id: number;
    analysisSetId: number;
    hazardId: number;
    methodId: number | undefined;
    detectionBorderValue: number | undefined;
    sortOrder: number;

    [key: string]: any;
}

export interface UpdateAnalysisSetRequest {
    locationId: number;
    name: string;
    analysisSetItems: UpdateAnalysisSetItemRelationRequest[];

    [key: string]: any;
}

export interface UpdateAutoInsertLocationsMonitoringGroupRequest {
    id: number;
    autoInsert: boolean;

    [key: string]: any;
}

export interface UpdateControlMeasureGroupRequest {
    nameAsJson: JsonTranslation;

    [key: string]: any;
}

export interface UpdateControlMeasureRequest {
    controlMeasureGroupId: number;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;

    [key: string]: any;
}

export interface UpdateCopiedSampleRequest {
    id: string;
    parentSampleGuid: string;
    locationId: number;
    sampleNumber: string;

    [key: string]: any;
}

export interface UpdateHazardRequest {
    id: number;
    unitId: number | undefined;
    parentHazardId: number | undefined;
    code: string;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;
    standardReference: string;
    analysisBase: UpdateHazardRequestAnalysisBase | undefined;
    analysisBaseNameAsJson: JsonTranslation;
    category: UpdateHazardRequestCategory;
    severity: UpdateHazardRequestSeverity | undefined;
    isActiveMonitoring: boolean;
    isActiveForRiskAssessment: boolean;
    moistureContentConversion: boolean;
    hazardType: UpdateHazardRequestHazardType;
    sortOrder: number | undefined;

    [key: string]: any;
}

export interface UpdateHazardsFactsheetFileReferenceRequest {

    [key: string]: any;
}

export interface UpdateHazardsLimitRequest {
    id: number;
    unitId: number | undefined;
    startDate: Date;
    endDate: Date | undefined;
    minimumActionBorderValue: number | undefined;
    maximumActionBorderValue: number | undefined;
    minimumRejectionBorderValue: number | undefined;
    maximumRejectionBorderValue: number | undefined;

    [key: string]: any;
}

export interface UpdateHazardsStandardDocumentFileReferenceRequest {

    [key: string]: any;
}

export interface UpdateLocationRequest {
    name: string;
    city: string;
    registrationNumber: string;
    crmId: string;
    isProducer: boolean;
    isSupplier: boolean;
    isLaboratory: boolean;
    countryId: number;

    [key: string]: any;
}

export interface UpdateLocationsMonitoringGroupAsManagerRequest {
    id: number;
    monitoringGroupId: number;
    endDate: Date | undefined;

    [key: string]: any;
}

export interface UpdateMethodRequest {
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;

    [key: string]: any;
}

export interface UpdateMonitoringGroupRequest {
    id: number;
    name: string;
    code: string;
    isActive: boolean;

    [key: string]: any;
}

export interface UpdateMyProductRequest {
    id: number;
    locationId: number | undefined;
    productId: number;
    name: string;
    expirationDate: Date | undefined;

    [key: string]: any;
}

export interface UpdateOrCreateUserRolesRequest {
    identityProvider: string;
    userId: string;
    userDetails: string;
    claims: UserClaimRelation[];
    accessToken: string;

    [key: string]: any;
}

export interface UpdatePlannedSampleRequest {
    id: string;
    productId: number;
    myProductId: number | undefined;
    monitoringGroupId: number | undefined;
    locationId: number | undefined;
    plannedSampleNumber: string;
    sampleType: UpdatePlannedSampleRequestSampleType;
    year: number;
    quarter: number | undefined;
    month: number | undefined;
    date: Date | undefined;
    status: UpdatePlannedSampleRequestStatus;
    combinedAnalysisAssignments: UpdateAnalysisAssignmentPlannedRelationRequest[];

    [key: string]: any;
}

export interface UpdateProcessingAidGroupRequest {
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;
    factsheetVersionDate: Date | undefined;

    [key: string]: any;
}

export interface UpdateProcessingAidGroupsFactsheetFileReferenceRequest {

    [key: string]: any;
}

export interface UpdateProcessingAidGroupsProcessingAidRelationRequest {
    processingAidGroupId: number;
    processingAidId: number;

    [key: string]: any;
}

export interface UpdateProcessingAidRequest {
    nameAsJson: JsonTranslation;
    processingAidGroupsProcessingAids: UpdateProcessingAidGroupsProcessingAidRelationRequest[];

    [key: string]: any;
}

export interface UpdateProcessStepGroupRequest {
    sortOrder: number;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;

    [key: string]: any;
}

export interface UpdateProcessStepRequest {
    processStepGroupId: number;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;
    sortOrder: number;

    [key: string]: any;
}

export interface UpdateProductGroupRequest {
    descriptionAsJson: JsonTranslation;
    category: UpdateProductGroupRequestCategory;
    code: string;

    [key: string]: any;
}

export interface UpdateProductRequest {
    id: number;
    productGroupId: number;
    code: string;
    nameAsJson: JsonTranslation;
    definitionAsJson: JsonTranslation;
    synonymsAsJson: JsonTranslations;
    isActiveMonitoring: boolean;
    isActiveForRiskAssessment: boolean;
    isEuProduct: boolean;
    expirationDate: Date | undefined;

    [key: string]: any;
}

export interface UpdateRiskAssessmentRequest {
    id: number;
    code: string;
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;
    remarksAsJson: JsonTranslation;
    riskAssessmentVersions: UpdateRiskAssessmentVersionRelationRequest[];

    [key: string]: any;
}

export interface UpdateRiskAssessmentsProcessingAidRelationRequest {
    riskAssessmentVersionId: number;
    processingAidId: number;

    [key: string]: any;
}

export interface UpdateRiskAssessmentsProcessingAidRequest {
    id: number;
    riskAssessmentVersionId: number;
    processingAidId: number;

    [key: string]: any;
}

export interface UpdateRiskAssessmentsProcessStepRelationRequest {
    riskAssessmentVersionId: number;
    processStepId: number;

    [key: string]: any;
}

export interface UpdateRiskAssessmentsProcessStepRequest {
    id: number;
    riskAssessmentVersionId: number;
    processStepId: number;

    [key: string]: any;
}

export interface UpdateRiskAssessmentsProcessStepsHazardRequest {
    riskAssessmentsProcessStepId: number;
    hazardId: number;
    likelyOccurrence: string;
    explanationAsJson: JsonTranslation;
    referenceDiagram: string;
    riskAssessmentsProcessStepsHazardsControlMeasures: UpdateRiskAssessmentsProcessStepsHazardsControlMeasureRelationRequest[];

    [key: string]: any;
}

export interface UpdateRiskAssessmentsProcessStepsHazardsControlMeasureRelationRequest {
    id: number | undefined;
    riskAssessmentsProcessStepsHazardId: number;
    controlMeasureId: number;
    name:string;
    value:number;

    [key: string]: any;
}

export interface UpdateRiskAssessmentsProcessStepsHazardsControlMeasureRequest {
    id: number;
    riskAssessmentsProcessStepsHazardId: number;
    controlMeasureId: number;

    [key: string]: any;
}

export interface UpdateRiskAssessmentsProcessStepsProductRequest {
    id: number;
    riskAssessmentsProcessStepId: number;
    productId: number;

    [key: string]: any;
}

export interface UpdateRiskAssessmentsProductRelationRequest {
    riskAssessmentVersionId: number;
    productId: number;

    [key: string]: any;
}

export interface UpdateRiskAssessmentsProductRequest {
    id: number;
    riskAssessmentVersionId: number;
    productId: number;

    [key: string]: any;
}

export interface UpdateRiskAssessmentVersionFlowChartFileReferenceRequest {
    riskAssessmentVersionId: number;
    language: string;
    name: string;
    position: number | undefined;
    flowChartVersionDate: Date | undefined;

    [key: string]: any;
}

export interface UpdateRiskAssessmentVersionRelationRequest {
    id: number;
    riskAssessmentId: number;
    versionNumber: number;
    status: UpdateRiskAssessmentVersionRelationRequestStatus;
    flowchartVersionDate: string;
    publicationDate: string;
    riskAssessmentsProcessSteps: UpdateRiskAssessmentsProcessStepRelationRequest[];
    riskAssessmentsProcessingAids: UpdateRiskAssessmentsProcessingAidRelationRequest[];
    riskAssessmentsProducts: UpdateRiskAssessmentsProductRelationRequest[];

    [key: string]: any;
}

export interface UpdateRiskAssessmentVersionRequest {
    riskAssessmentId: number;
    versionNumber: number;
    flowchartVersionDate: string;
    publicationDate: Date | undefined;

    [key: string]: any;
}

export interface UpdateSampleRequest {
    id: string;
    sampleNumber: string;
    countryCode3: string;
    laboratoryLocationId: number | undefined;
    date: Date;
    sampleType: UpdateSampleRequestSampleType;
    batchNumber: string;
    countryId: number | undefined;
    producerLocationId: number | undefined;
    supplierLocationId: number | undefined;
    originLocationId: number | undefined;
    characteristics: string;

    [key: string]: any;
}

export interface UpdateStatusLocationsMonitoringGroupRequest {
    id: number;
    status: UpdateStatusLocationsMonitoringGroupRequestStatus;

    [key: string]: any;
}

export interface UpdateUnitRequest {
    nameAsJson: JsonTranslation;
    descriptionAsJson: JsonTranslation;

    [key: string]: any;
}

export interface User {
    id: number;
    azureId: string;
    name: string;
    createdBy: number | undefined;
    createdAt: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedAt: Date | undefined;
    positionsAsJson: UserPositionAsJson[];
    groupsAsJson: UserGroupAsJson[];
    rolesAsJson: UserRoleAsJson[];
    analysisReports: AnalysisReport[];
    favourites: Favourite[];
    monitoringGroupsUsers: MonitoringGroupsUser[];
    locationsUsers: LocationsUser[];
    combinedSamples: CombinedSample[];
    ediIncomingSampleRequestUsers: EdiIncomingSampleRequest[];

    [key: string]: any;
}

export interface UserClaimRelation {
    typ: string;
    val: string;

    [key: string]: any;
}

export interface UserGroupAsJson {
    code: string;
    group: string;
    type: string;
    typeName: string;

    [key: string]: any;
}

export interface UserGroupsContext {
    userId: number;
    userCanBeGroupManager: boolean;
    monitoringGroupId: number;
    code: string;
    group: string;
    typeName: string;

    [key: string]: any;
}

export interface UserPositionAsJson {
    position: string;
    positionName: string;
    company: string;

    [key: string]: any;
}

export interface UserRoleAsJson {
    role: string;
    roleName: string;

    [key: string]: any;
}

export interface ValidateEdiIncomingSampleExcelRequest {
    kindOf: number;
    fileAttachment: IFileAttachment;

    [key: string]: any;
}

export interface ValidateEdiIncomingSampleXmlRequest {
    kindOf: number;
    fileAttachment: IFileAttachment;

    [key: string]: any;
}

export interface ValuesDto_analysisSetAutocompleteResponse {
    values: AnalysisSetAutocompleteResponse[];

    [key: string]: any;
}

export interface ValuesDto_analysisSetResponse {
    values: AnalysisSetResponse[];

    [key: string]: any;
}

export interface ValuesDto_combinedSampleResponse {
    values: CombinedSampleResponse[];

    [key: string]: any;
}

export interface ValuesDto_combinedSamplesBenchmarkReportResponse {
    values: CombinedSamplesBenchmarkReportResponse[];

    [key: string]: any;
}

export interface ValuesDto_combinedSamplesGroupedByCountryReportResponse {
    values: CombinedSamplesGroupedByCountryReportResponse[];

    [key: string]: any;
}

export interface ValuesDto_combinedSamplesHazardsReportResponse {
    values: CombinedSamplesHazardsReportResponse[];

    [key: string]: any;
}

export interface ValuesDto_combinedSamplesProductsReportResponse {
    values: CombinedSamplesProductsReportResponse[];

    [key: string]: any;
}

export interface ValuesDto_controlMeasureGroupResponse {
    values: ControlMeasureGroupResponse[];

    [key: string]: any;
}

export interface ValuesDto_controlMeasureResponse {
    values: ControlMeasureResponse[];

    [key: string]: any;
}

export interface ValuesDto_countryAutocompleteResponse {
    values: CountryAutocompleteResponse[];

    [key: string]: any;
}

export interface ValuesDto_countryResponse {
    values: CountryResponse[];

    [key: string]: any;
}

export interface ValuesDto_documentResponse {
    values: DocumentResponse[];

    [key: string]: any;
}

export interface ValuesDto_ediIncomingSampleEmailResponse {
    values: EdiIncomingSampleEmailResponse[];

    [key: string]: any;
}

export interface ValuesDto_favouriteResponse {
    values: FavouriteResponse[];

    [key: string]: any;
}

export interface ValuesDto_hazardAutocompleteResponse {
    values: HazardAutocompleteResponse[];

    [key: string]: any;
}

export interface ValuesDto_hazardResponse {
    values: HazardResponse[];

    [key: string]: any;
}

export interface ValuesDto_locationAutocompleteResponse {
    values: LocationAutocompleteResponse[];

    [key: string]: any;
}

export interface ValuesDto_locationResponse {
    values: LocationResponse[];

    [key: string]: any;
}

export interface ValuesDto_locationsMonitoringGroupForGroupManagerResponse {
    values: LocationsMonitoringGroupForGroupManagerResponse[];

    [key: string]: any;
}

export interface ValuesDto_locationsMonitoringGroupResponse {
    values: LocationsMonitoringGroupResponse[];

    [key: string]: any;
}

export interface ValuesDto_methodAutocompleteResponse {
    values: MethodAutocompleteResponse[];

    [key: string]: any;
}

export interface ValuesDto_methodResponse {
    values: MethodResponse[];

    [key: string]: any;
}

export interface ValuesDto_monitoringGroupAutocompleteResponse {
    values: MonitoringGroupAutocompleteResponse[];

    [key: string]: any;
}

export interface ValuesDto_monitoringGroupResponse {
    values: MonitoringGroupResponse[];

    [key: string]: any;
}

export interface ValuesDto_myProductResponse {
    values: MyProductResponse[];

    [key: string]: any;
}

export interface ValuesDto_plannedSampleResponse {
    values: PlannedSampleResponse[];

    [key: string]: any;
}

export interface ValuesDto_processingAidAutocompleteResponse {
    values: ProcessingAidAutocompleteResponse[];

    [key: string]: any;
}

export interface ValuesDto_processingAidGroupResponse {
    values: ProcessingAidGroupResponse[];

    [key: string]: any;
}

export interface ValuesDto_processingAidResponse {
    values: ProcessingAidResponse[];

    [key: string]: any;
}

export interface ValuesDto_processStepGroupResponse {
    values: ProcessStepGroupResponse[];

    [key: string]: any;
}

export interface ValuesDto_processStepResponse {
    values: ProcessStepResponse[];

    [key: string]: any;
}

export interface ValuesDto_productAutocompleteResponse {
    values: ProductAutocompleteResponse[];

    [key: string]: any;
}

export interface ValuesDto_productGroupResponse {
    values: ProductGroupResponse[];

    [key: string]: any;
}

export interface ValuesDto_productOrMyProductAutocompleteResponse {
    values: ProductOrMyProductAutocompleteResponse[];

    [key: string]: any;
}

export interface ValuesDto_productResponse {
    values: ProductResponse[];

    [key: string]: any;
}

export interface ValuesDto_reportCombinedSampleAnalysisResultResponse {
    values: ReportCombinedSampleAnalysisResultResponse[];

    [key: string]: any;
}

export interface ValuesDto_riskAssessmentResponse {
    values: RiskAssessmentResponse[];

    [key: string]: any;
}

export interface ValuesDto_riskAssessmentVersionResponse {
    values: RiskAssessmentVersionResponse[];

    [key: string]: any;
}

export interface ValuesDto_sampleAutocompleteResponse {
    values: SampleAutocompleteResponse[];

    [key: string]: any;
}

export interface ValuesDto_sampleResponse {
    values: SampleResponse[];

    [key: string]: any;
}

export interface ValuesDto_unitResponse {
    values: UnitResponse[];

    [key: string]: any;
}

export interface BadRequestResult {
    /** Error code */
    code: string;
    /** Error message */
    message: string;

    [key: string]: any;
}

export enum AnalysisResultRelationResponseKindOf {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = "ToggleResult"
}

export enum AnalysisResultRelationResponseSymbol {
    None = "None",
    LowerThan = "LowerThan",
    Equals = "Equals",
    GreaterThan = "GreaterThan",
}

export enum AnalysisResultResponseKindOf {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum AnalysisResultResponseSymbol {
    None = "None",
    LowerThan = "LowerThan",
    Equals = "Equals",
    GreaterThan = "GreaterThan",
}

export enum CopiedSampleResponseKindOf {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum CreateAnalysisResultRelationRequestKindOf {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum CreateAnalysisResultRelationRequestSymbol {
    None = "None",
    LowerThan = "LowerThan",
    Equals = "Equals",
    GreaterThan = "GreaterThan",
}

export enum CreateAnalysisResultRequestKindOf {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum CreateAnalysisResultRequestSymbol {
    None = "None",
    LowerThan = "LowerThan",
    Equals = "Equals",
    GreaterThan = "GreaterThan",
}

export enum CreateHazardRequestAnalysisBase {
    None = "None",
    Moist12Percent = "Moist12Percent",
    DryMatter = "DryMatter",
    FatBasis = "FatBasis",
    Product = "Product",
    Protein = "Protein",
}

export enum CreateHazardRequestCategory {
    None = "None",
    Chemical = "Chemical",
    Microbiological = "Microbiological",
    Physical = "Physical",
}

export enum CreateHazardRequestSeverity {
    None = "None",
    Low = "Low",
    Medium = "Medium",
    High = "High",
}

export enum CreateHazardRequestHazardType {
    None = "None",
    Toggle = "Toggle",
    Value = "Value",
}

export enum CreatePlannedSampleRequestSampleType {
    None = "None",
    Other = "Other",
    GMPplus = "GMPplus",
}

export enum CreatePlannedSampleRequestStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum CreateProductGroupRequestCategory {
    None = "None",
    FeedMaterial = "FeedMaterial",
    Additives = "Additives",
    Premixtures = "Premixtures",
    CompoundFeeds = "CompoundFeeds",
}

export enum CreateRiskAssessmentVersionRelationRequestStatus {
    None = "None",
    Draft = "Draft",
    Published = "Published",
    Revoked = "Revoked",
    Archived = "Archived",
}

export enum CreateSampleRequestSampleType {
    None = "None",
    Other = "Other",
    GMPplus = "GMPplus",
}

export enum DateOnlyDayOfWeek {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum HazardAutocompleteResponseHazardType {
    None = "None",
    Toggle = "Toggle",
    Value = "Value",
}

export enum HazardAutocompleteResponseAnalysisBase {
    None = "None",
    Moist12Percent = "Moist12Percent",
    DryMatter = "DryMatter",
    FatBasis = "FatBasis",
    Product = "Product",
    Protein = "Protein",
}

export enum HazardRelationResponseAnalysisBase {
    None = "None",
    Moist12Percent = "Moist12Percent",
    DryMatter = "DryMatter",
    FatBasis = "FatBasis",
    Product = "Product",
    Protein = "Protein",
}

export enum HazardRelationResponseCategory {
    None = "None",
    Chemical = "Chemical",
    Microbiological = "Microbiological",
    Physical = "Physical",
}

export enum HazardRelationResponseSeverity {
    None = "None",
    Low = "Low",
    Medium = "Medium",
    High = "High",
}

export enum HazardRelationResponseHazardType {
    None = "None",
    Toggle = "Toggle",
    Value = "Value",
}

export enum HazardResponseAnalysisBase {
    None = "None",
    Moist12Percent = "Moist12Percent",
    DryMatter = "DryMatter",
    FatBasis = "FatBasis",
    Product = "Product",
    Protein = "Protein",
}

export enum HazardResponseCategory {
    None = "None",
    Chemical = "Chemical",
    Microbiological = "Microbiological",
    Physical = "Physical",
}

export enum HazardResponseSeverity {
    None = "None",
    Low = "Low",
    Medium = "Medium",
    High = "High",
}

export enum HazardResponseHazardType {
    None = "None",
    Toggle = "Toggle",
    Value = "Value",
}

export enum LocationsMonitoringGroupForGroupManagerResponseStatus {
    Requested = "Requested",
    Rejected = "Rejected",
    Accepted = "Accepted",
}

export enum LocationsMonitoringGroupResponseStatus {
    Requested = "Requested",
    Rejected = "Rejected",
    Accepted = "Accepted",
}

export enum PlannedSampleResponseKindOf {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum ProductGroupRelationResponseCategory {
    None = "None",
    FeedMaterial = "FeedMaterial",
    Additives = "Additives",
    Premixtures = "Premixtures",
    CompoundFeeds = "CompoundFeeds",
}

export enum ProductGroupResponseCategory {
    None = "None",
    FeedMaterial = "FeedMaterial",
    Additives = "Additives",
    Premixtures = "Premixtures",
    CompoundFeeds = "CompoundFeeds",
}

export enum ReportCombinedSampleAnalysisResultResponseKindOf {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum ReportCombinedSampleAnalysisResultResponseSymbol {
    None = "None",
    LowerThan = "LowerThan",
    Equals = "Equals",
    GreaterThan = "GreaterThan",
}

export enum RiskAssessmentVersionRelationResponseStatus {
    None = "None",
    Draft = "Draft",
    Published = "Published",
    Revoked = "Revoked",
    Archived = "Archived",
}

export enum RiskAssessmentVersionResponseStatus {
    None = "None",
    Draft = "Draft",
    Published = "Published",
    Revoked = "Revoked",
    Archived = "Archived",
}

export enum SampleAutocompleteResponseKindOf {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum SampleResponseKindOf {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum UpdateAnalysisResultRelationRequestKindOf {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum UpdateAnalysisResultRelationRequestSymbol {
    None = "None",
    LowerThan = "LowerThan",
    Equals = "Equals",
    GreaterThan = "GreaterThan",
}

export enum UpdateAnalysisResultRequestSymbol {
    None = "None",
    LowerThan = "LowerThan",
    Equals = "Equals",
    GreaterThan = "GreaterThan",
}

export enum UpdateHazardRequestAnalysisBase {
    None = "None",
    Moist12Percent = "Moist12Percent",
    DryMatter = "DryMatter",
    FatBasis = "FatBasis",
    Product = "Product",
    Protein = "Protein",
}

export enum UpdateHazardRequestCategory {
    None = "None",
    Chemical = "Chemical",
    Microbiological = "Microbiological",
    Physical = "Physical",
}

export enum UpdateHazardRequestSeverity {
    None = "None",
    Low = "Low",
    Medium = "Medium",
    High = "High",
}

export enum UpdateHazardRequestHazardType {
    None = "None",
    Toggle = "Toggle",
    Value = "Value",
}

export enum UpdatePlannedSampleRequestSampleType {
    None = "None",
    Other = "Other",
    GMPplus = "GMPplus",
}

export enum UpdatePlannedSampleRequestStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum UpdateProductGroupRequestCategory {
    None = "None",
    FeedMaterial = "FeedMaterial",
    Additives = "Additives",
    Premixtures = "Premixtures",
    CompoundFeeds = "CompoundFeeds",
}

export enum UpdateRiskAssessmentVersionRelationRequestStatus {
    None = "None",
    Draft = "Draft",
    Published = "Published",
    Revoked = "Revoked",
    Archived = "Archived",
}

export enum UpdateSampleRequestSampleType {
    None = "None",
    Other = "Other",
    GMPplus = "GMPplus",
}

export enum UpdateStatusLocationsMonitoringGroupRequestStatus {
    Requested = "Requested",
    Rejected = "Rejected",
    Accepted = "Accepted",
}

export type ApiListResponse<T> = {
  values: T[]
}

export type HazardProduct = {
  hazardId: number
  productId: number
  parentHazardNameAsJson: JsonTranslation
  unitNameAsJson: JsonTranslation
  unitId: number
  parentHazardId: number
  nameAsJson: JsonTranslation
  productCode: string
  productNameAsJson: JsonTranslation
  limitMinRejectionValue: number
  limitMaxRejectionValue: number
  limitUnitNameAsJson: JsonTranslation
  nrBelowRejectionValue: number
  nrBetweenRejectionValues: number
  nrAboveRejectionValue: number
  nrOfTotalResults: number
}

export type ProductHazardSummary = {
  productId: number
  hazardId: number
  productGroupId: number
  code: string
  nameAsJson: JsonTranslation
  hazardNameAsJson: JsonTranslation
  nrBelowRejectionValue: number
  nrBetweenRejectionValues: number
  nrAboveRejectionValue: number
  nrOfTotalResults: number
}


export type CountryHazardStats = {
  countryId: number
  productId: number
  countryNameAsJson: JsonTranslation
  nrBelowRejectionValue: number
  nrBetweenRejectionValues: number
  nrAboveRejectionValue: number
  nrOfTotalResults: number
}

export type ProductHazardMonitoring = {
  productId: number
  productNameAsJson: JsonTranslation
  hazardId: number
  hazardNameAsJson: JsonTranslation
  own: number
  forCommunity: number
  monitoringGroupId: number
  monitoringGroupName: string
  nrBelowRejectionValue: number
  nrBetweenRejectionValues: number
  nrAboveRejectionValue: number
  nrOfTotalResults: number
}

export type ProductAnalysisResult = {
  hazardId: number
  productId: number
  originLocationId: number
  kindOf: number
  kindOfSample: number
  forCommunity: number
  analysisResultId: string
  locationId: number
  locationName: string
  productNameAsJson: JsonTranslation
  sampleNumber: string
  sampleDate: string
  analysisType: string
  batchNumber: string
  countryId: number
  countryNameAsJson: JsonTranslation
  producerLocationId: number
  producerLocationName: string
  supplierLocationId: number
  supplierLocationName: string
  laboratoryLocationId: number
  laboratoryLocationName: string
  reportDate: string
  reportNumber: string
  hazardNameAsJson: JsonTranslation
  methodNameAsJson: JsonTranslation
  symbol: string
  value: number
  unitId: number
  unitNameAsJson: JsonTranslation
  minimumActionBorderValue: number
  maximumActionBorderValue: number
  minimumRejectionBorderValue: number
  maximumRejectionBorderValue: number
  moisturePercentage: number
  productCode: string
}
export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}
